/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

// <div className="hello-world">
// 	<h1>
// 		Hello <span className="hello-world-name">World</span>TEST
// 	</h1>
// </div>

import React, { useEffect, useState } from 'react'
import HelloFoo from '../../hello-foo/pages/HelloFoo';
import api from '../../../common/services/liferay/api';
import Select, { components } from "react-select";
import { CustomDropdownIndicator } from './CustomDropdownIndicator'
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";

import { updateTranslation } from './translation.service';
import { count } from 'rxjs';
// import XHR from 'i18next-xhr-backend';

// i18n
// 	.use(initReactI18next) // passes i18n down to react-i18next
// 	.init({
// 		// the translations
// 		// (tip move them in a JSON file and import them,
// 		// or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
// 		resources: {
// 			en: {
// 				translation: {
// 					"Calculate_your_volume": "Calculate your volume",
// 					"Choose_your_project": "Choose your project",
// 					"Choose_an_option": "Choose an option",
// 					"length": "length",
// 					"Outer_length": "Outer length",
// 					"Inner_length": "Inner length",
// 					"Width": "Width",
// 					"Outer_width": "Outer width",
// 					"Inner_width": "Inner width",
// 					"Height": "Height",
// 					"Diameter": "Diameter",
// 					"Outer_diameter": "Outer diameter",
// 					"Inner_diameter": "Inner diameter",
// 					"Depth": "Depth",
// 					"Rise": "Rise",
// 					"Run": "Run",
// 					"Platform_depth": "Platform depth",
// 					"Number_of_stairs": "Number of stairs",
// 					"Shape": "Shape",
// 					"Order_detail": "Order detail",
// 					"Reserve_volume": "Reserve volume",
// 					"Total_volume": "Total volume",
// 					"Add_shape": "Add shape",
// 					"Next": "Next",
// 				}
// 			}
// 		},
// 		lng: "en", // if you're using a language detector, do not define the lng option
// 		fallbackLng: "en",

// 		interpolation: {
// 			escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
// 		}
// 	});
const HelloWorld = () => {
	const { t } = useTranslation();


	const [langKeysReady, setLangKeysReady] = useState(false);
	const [showMinVolMessage, setShowMinVolMessage] = useState(false);
	const [minimumVolume, setminimumVolume] = useState(null);
	const [minimumVolumeId, setminimumVolumeId] = useState(null);

	// const [createDefaultUnitsArray, setCreateDefaultUnitsArray] = useState([
	// 	{
	// 		"defaultUnit": "m | cm",
	// 		"side": 0,
	// 		"shape": 0,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 1,
	// 		"shape": 0,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 2,
	// 		"shape": 0,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "cm",
	// 		"side": 3,
	// 		"shape": 0,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 3,
	// 		"shape": 1,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "cm",
	// 		"side": 4,
	// 		"shape": 1,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 5,
	// 		"shape": 2,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 6,
	// 		"shape": 2,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "cm",
	// 		"side": 3,
	// 		"shape": 2,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 1,
	// 		"shape": 3,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 2,
	// 		"shape": 3,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "cm",
	// 		"side": 3,
	// 		"shape": 3,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 7,
	// 		"shape": 4,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 8,
	// 		"shape": 4,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 9,
	// 		"shape": 4,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 10,
	// 		"shape": 4,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "cm",
	// 		"side": 11,
	// 		"shape": 4,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 2,
	// 		"shape": 5,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 12,
	// 		"shape": 5,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "m",
	// 		"side": 13,
	// 		"shape": 5,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnit": "cm",
	// 		"side": 14,
	// 		"shape": 5,
	// 		"systemUnit": 0
	// 	},
	// 	/// ft | in
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 1,
	// 		"shape": 0,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 2,
	// 		"shape": 0,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "in",
	// 		"side": 3,
	// 		"shape": 0,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 3,
	// 		"shape": 1,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "in",
	// 		"side": 4,
	// 		"shape": 1,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 5,
	// 		"shape": 2,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 6,
	// 		"shape": 2,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "in",
	// 		"side": 3,
	// 		"shape": 2,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 1,
	// 		"shape": 3,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 2,
	// 		"shape": 3,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "in",
	// 		"side": 3,
	// 		"shape": 3,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 7,
	// 		"shape": 4,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 8,
	// 		"shape": 4,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 9,
	// 		"shape": 4,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 10,
	// 		"shape": 4,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "in",
	// 		"side": 11,
	// 		"shape": 4,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 2,
	// 		"shape": 5,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 12,
	// 		"shape": 5,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "ft",
	// 		"side": 13,
	// 		"shape": 5,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnit": "in",
	// 		"side": 14,
	// 		"shape": 5,
	// 		"systemUnit": 1
	// 	}
	// ]);
	const [lettersArray, setLettersArray] = useState(['A', 'B', 'C', 'D', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M']);
	const [isAdmin, setIsAdmin] = useState(false);
	const [showConfig, setShowConfig] = useState(false);
	const [defaultUnitsList, setDefaultUnitsList] = useState(null);
	const [dataDefaultUnitsReady, setDataDefaultUnitsReady] = useState(false);
	// const [urlBase, setUrlBase] = useState('http://localhost:8080/o/c/');
	// const [urlBase, setUrlBase] = useState('https://cxogdev-web.cemexgws.com/o/c/');
	// const [urlBase, setUrlBase] = useState('https://localhost:7213/api/');
	// const [urlBase, setUrlBase] = useState('https://localhost:8080/api/');
	const [urlBase, setUrlBase] = useState('https://cxapi-dev.cemexgws.com/api/'); //PROD

	// const [optionsReady, setOptionsReady] = useState(false);
	// const [dataReady, setDataReady] = useState(false);
	const [selectedImage, setSelectedImage] = useState(0);
	// const [selectedUnit, setSelectedUnit] = useState(null);
	const [siteId, setSiteId] = useState(null);

	const [shapesVolumeArray, setShapesVolumeArray] = useState([
		{
			id: 0,
			selectedImage: 0,
			length: 0,
			lengthUnit: 0,
			widthUnit: 0,
			width: 0,
			diameterUnit: 0,
			diameter: 0,
			heightUnit: 0,
			height: 0,
			outerDiameterUnit: 0,
			outerDiameter: 0,
			innerDiameterUnit: 0,
			innerDiameter: 0,
			outerWidthUnit: 0,
			outerWidth: 0,
			innerWidthUnit: 0,
			innerWidth: 0,
			outerLengthUnit: 0,
			outerLength: 0,
			innerLengthUnit: 0,
			innerLength: 0,
			depthUnit: 0,
			depth: 0,
			riseUnit: 0,
			rise: 0,
			runUnit: 0,
			run: 0,
			platformDepthUnit: 0,
			platformDepth: 0,
			numberStairs: 0,
			shapeVolume: 0
		}
	]);

	// const [lengthUnit, setLengthUnit] = useState('');
	// const [length, setLength] = useState('');
	// const [widthUnit, setWidthUnit] = useState('');
	// const [width, setWidth] = useState('');
	// const [diameterUnit, setDiameterUnit] = useState('');
	// const [diameter, setDiameter] = useState('');
	// const [heightUnit, setheightUnit] = useState('');
	// const [height, setheight] = useState('');
	// const [outerDiameterUnit, setOuterDiameterUnit] = useState('');
	// const [outerDiameter, setOuterDiameter] = useState('');
	// const [innerDiameterUnit, setInnerDiameterUnit] = useState('');
	// const [innerDiameter, setInnerDiameter] = useState('');
	// const [outerWidthUnit, setOuterWidthUnit] = useState('');
	// const [outerWidth, setOuterWidth] = useState('');
	// const [innerWidthUnit, setInnerWidthUnit] = useState('');
	// const [innerWidth, setInnerWidth] = useState('');
	// const [outerLengthUnit, setOuterLengthUnit] = useState('');
	// const [outerLength, setOuterLength] = useState('');
	// const [innerLengthUnit, setInnerLengthUnit] = useState('');
	// const [innerLength, setInnerLength] = useState('');
	// const [depthUnit, setDepthUnit] = useState('');
	// const [depth, setDepth] = useState('');
	// const [riseUnit, setRiseUnit] = useState('');
	// const [rise, setRise] = useState('');
	// const [runUnit, setRunUnit] = useState('');
	// const [run, setRun] = useState('');
	// const [platformDepthUnit, setPlatformDepthUnit] = useState('');
	// const [platformDepth, setPlatformDepth] = useState('');
	// const [numberStairs, setNumberStairs] = useState(1);

	const [reserveVolume, setReserveVolume] = useState(0);
	const [reserveVolumeAmount, setReserveVolumeAmount] = useState(0);
	const [totalVolume, setTotalVolume] = useState(0);
	const [images, setImages] = useState([
		{
			url: '',
			label: t('Square_Slab')
		},
		{
			url: '',
			label: t('Column')
		},
		{
			url: '',
			label: t('Tube')
		},
		{
			url: '',
			label: t('Wall')
		},
		{
			url: '',
			label: t('Strip_foundations')
		},
		{
			url: '',
			label: t('Stairs')
		}]);
	// const [selectedProjectIdsList, setSelectedProjectIdsList] = useState(['Foundations', 'Domestic garage foundations']);
	const [units, setUnits] = useState(['m | cm | M3', 'ft | in | yrd']);
	const [unitsM, setUnitsM] = useState([
		{
			label: 'm',
			value: 'm'
		},
		{
			label: 'cm',
			value: 'cm'
		},
		{
			label: 'mm',
			value: 'mm'
		}]);
	const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	const [projectList, setProjectList] = useState(null);
	const [optionList, setOptionList] = useState(null);
	const [selectedProjectId, setSelectedProjectId] = useState(null);
	const [selectedOptionId, setSelectedOptionId] = useState(null);
	const [accountInfo, setAccountInfo] = useState(null);
	const [shapeAdded, setShapeAdded] = useState(0);
	const [selectedArrayShapeItem, setSelectedArrayShapeItem] = useState(0);
	const [nextActivated, setNextActivated] = useState(false);
	const [langKeysList, setLangKeysList] = useState(null);
	// const [optionListFiltered, setOptionListFiltered] = useState(null);
	const isMobile = screenWidth <= 1076;
	// const isMobile = screenWidth <= 768;
	function handleWindowSizeChange() {
		setScreenWidth(window.innerWidth);
	}

	const [decimalsCount, setdecimalsCount] = useState(1);
	const [decimalsCountID, setdecimalsCountID] = useState('');

	//TEST
	// useEffect(() => {
	// 	console.log('useEffect 1');
	// 	if (siteId == null) {
	// 		// ONLY ON LIFERAY
	// 		var siteval = themeDisplay.getSiteGroupId();
	// 		setSiteId(siteval);

	// 		// setSiteId(1681592);
	// 	}
	// 	if (langKeysList == null && siteId != null) {
	// 		console.log('getLangKeysList 1');
	// 		getLangKeysList();
	// 	}
	// });

	useEffect(() => {
		// console.log('useEffect 2');
		if (siteId == null) {
			// ONLY ON LIFERAY
			var siteval = themeDisplay.getSiteGroupId();
			setSiteId(siteval);

			// setSiteId(1681592);
		}


		if (langKeysList == null && siteId != null) {
			// console.log('getLangKeysList 2');
			getLangKeysList();
		}

		// if (projectList == null && siteId != null) {
		// 	getProjectList();
		// 	getOptionsList();
		// }

		if (accountInfo == null && siteId != null) {
			getUserInfo();
		}

		if (minimumVolumeId == null && siteId != null) {
			getMinimumVolume();
		}


		if (defaultUnitsList == null && siteId != null) {
			getDefaultUnitsList(0, 0);
		}


		// ONLY ON LIFERAY
		Liferay.on('goToPrevious', function (event) {
			setNextActivated(false);
		});

		window.addEventListener('resize', handleWindowSizeChange);
		return () => {
			window.removeEventListener('resize', handleWindowSizeChange);
		}
	}, []);



	useEffect(() => {

		////console.log('useeffect shapesVolumeArray.length -1', shapesVolumeArray.length - 1);
		if (siteId != null) {
			getDefaultUnitsList(0, shapesVolumeArray.length - 1);
		}
	}, [shapeAdded]);

	useEffect(() => {
		console.log('useEffect 3');
		if (langKeysList == null && siteId != null) {
			getLangKeysList();
			console.log('getLangKeysList 3');
		}

		if (minimumVolumeId == null && siteId != null) {
			getMinimumVolume();
		}

		// if (projectList == null && siteId != null) {
		// 	getProjectList();
		// 	getOptionsList();
		// }

		if (accountInfo == null && siteId != null) {
			getUserInfo();
		}


		if (defaultUnitsList == null && siteId != null) {
			getDefaultUnitsList(0, 0);
		}
	}, [siteId]);


	const getMinimumVolume = () => {
		// console.log('getMinimumVolume');
		fetch(urlBase + 'minimumVolume/' + siteId, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				// 'Authorization': `Bearer ${getTokenFromCookie()}`,
				// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
			}
		}).then(function (response) {
			return response.json();
		}).then(function (response) {
			// console.log('getMinimumVolume response', response);
			setminimumVolume(response[0].minVal);
			setminimumVolumeId(response[0].id);
		});
	};


	const customStyles = {
		control: (provided) => ({ // class attribute : class=" css-i32vvf-control"
			...provided,
			background: '#FFFF',
			// display: 'flex',
			// flexWrap: 'nowrap',
			borderColor: '#3999FF',
			borderRadius: '7px',
			borderWidth: '1px',
			// width: '1px',
			fontWeight: 700,
			color: '#3999FF',
			// textDecorationColor: '#3999FF'
		}),
		menu: (provided) => ({ // 'menu' is from the div class too.
			...provided,
			fontWeight: 700,
			// background: 'transparent',
			background: '#FFFF',
			width: '92%',
			color: '#3999FF',
			// textDecorationColor: '#3999FF'
		}),
		singleValue: provided => ({
			...provided,
			color: '#3999FF',
			fontWeight: 700,
		}),
		placeholder: (baseStyles) => ({
			...baseStyles,
			// fontSize: "1em",
			// color: '#0003B1',
			fontWeight: 700,
			// borderColor: '#3999FF'
			color: '#3999FF',
		})
	};

	const getUserInfo = () => {
		if (Liferay.ThemeDisplay.isSignedIn() != false) {
			api('o/headless-admin-user/v1.0/my-user-account')
				.then((response) => response.json())
				.then((response) => {
					////console.log('my-user-account response', response);
					setAccountInfo(response);
					var permision = false;
					response.roleBriefs.forEach(element => {
						if (element.name == 'Administrator' ||
							element.name == 'Site Advance User' ||
							element.name == 'Advanced Users' ||
							element.name == 'Cemex Advanced Users') {
							permision = true;
						}
					});
					response.siteBriefs.forEach(element0 => {
						element0.roleBriefs.forEach(element => {
							if (element.name == 'Administrator' ||
								element.name == 'Site Advance User' ||
								element.name == 'Advanced Users' ||
								element.name == 'Cemex Advanced Users') {
								permision = true;
							}
						});

					});
					response.userGroupBriefs.forEach(element => {
						if (element.name == 'Administrator' ||
							element.name == 'Site Advance User' ||
							element.name == 'Advanced Users' ||
							element.name == 'Cemex Advanced Users') {
							permision = true;
						}
					});
					setIsAdmin(permision);

					// if (response.givenName) {
					// 	const nameElements = document.getElementsByClassName(
					// 		'hello-world-name'
					// 	);

					// 	if (nameElements.length) {
					// 		nameElements[0].innerHTML = response.givenName;
					// 	}
					// }
				});
		}

	}


	// const createDefaultUnitsInit = () => {
	// 	createDefaultUnitsArray.forEach(element => {
	// 		//console.log('JSON.stringify(element)', JSON.stringify(element));

	// 		Liferay.Util.fetch(urlBase + 'defaultunits/', {
	// 			body: JSON.stringify(element),
	// 			method: 'POST',
	// 			headers: {
	// 				'Content-Type': 'application/json',
	// 				// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 				// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 			}
	// 		}).then(function (response) {
	// 			return response.json();
	// 		}).then(function (response) {
	// 			//console.log('createDefaultUnitsInit DONE');
	// 			setDefaultUnitsList(null);
	// 		})
	// 	});
	// }

	const getLangKeysList = () => {
		fetch(urlBase + 'LangKey/' + siteId, {
			// body: new FormData(form),
			method: 'GET'
		}).then(function (response) {
			return response.json();
		}).then(function (response) {
			//console.log('response get LangKey', response);
			var newStringVal = '{';
			response.forEach(element => {
				newStringVal += '"' + element.key + '":"' + element.keyValue + '",'
				// newArrayVal.push({
				// 	[element.key]: element.keyValue
				// });
			});
			newStringVal = newStringVal.substring(0, newStringVal.length - 1);
			newStringVal += '}';
			var jsonval = JSON.parse(newStringVal);

			//console.log('before updateTranslation');
			updateTranslation('en', jsonval);

			var options = {
				// path where resources get loaded from, or a function
				// returning a path:
				// function(lngs, namespaces) { return customPath; }
				// the returned path will interpolate lng, ns if provided like giving a static path
				// loadPath: '/locales/{{lng}}/{{ns}}.json',
				loadPath: urlBase + 'LangKey/GetBackend/' + siteId,

				// path to post missing resources
				// addPath: 'locales/add/{{lng}}/{{ns}}',

				// your backend server supports multiloading
				// /locales/resources.json?lng=de+en&ns=ns1+ns2
				// Adapter is needed to enable MultiLoading https://github.com/i18next/i18next-multiload-backend-adapter
				// Returned JSON structure in this case is
				// {
				//  lang : {
				//   namespaceA: {},
				//   namespaceB: {},
				//   ...etc
				//  }
				// }
				allowMultiLoading: false, // set loadPath: '/locales/resources.json?lng={{lng}}&ns={{ns}}' to adapt to multiLoading

				// parse data after it has been fetched
				// in example use https://www.npmjs.com/package/json5
				// here it removes the letter a from the json (bad idea)
				parse: function (data) { return data.replace(/a/g, ''); },

				//parse data before it has been sent by addPath
				parsePayload: function (namespace, key, fallbackValue) { return { key } },

				// allow cross domain requests
				crossDomain: false,

				// allow credentials on cross domain requests
				withCredentials: false,

				// overrideMimeType sets request.overrideMimeType("application/json")
				overrideMimeType: false,

				// custom request headers sets request.setRequestHeader(key, value)
				customHeaders: {
					authorization: 'foo',
					// ...
				},

				// define a custom xhr function
				// can be used to support XDomainRequest in IE 8 and 9
				//
				// 'url' will be passed the value of 'loadPath'
				// 'options' will be this entire options object
				// 'callback' is a function that takes two parameters, 'data' and 'xhr'.
				//            'data' should be the key:value translation pairs for the
				//            requested language and namespace, or null in case of an error.
				//            'xhr' should be a status object, e.g. { status: 200 }
				// 'data' will be a key:value object used when saving missing translations
				ajax: function (url, options, callback, data) { },

				// adds parameters to resource URL. 'example.com' -> 'example.com?v=1.3.5'
				queryStringParams: { v: '1.3.5' }
			};

			// i18n
			// 	.use(initReactI18next) // passes i18n down to react-i18next
			// 	// .use({
			// 	// 	type: 'postProcessor',
			// 	// 	name: 'lazyInterpolateWithFunctions',
			// 	// 	process: function (value, key, options) {
			// 	// 		return options.skipInterpolation ? replaceKeys(value, options) : value;
			// 	// 	}
			// 	// })
			// 	// .use(XHR)
			// 	.init({
			// 		// the translations
			// 		// (tip move them in a JSON file and import them,
			// 		// or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)\

			// 		// backend: options,

			// 		resources: {
			// 			en: {
			// 				translation: {}
			// 			}
			// 		},

			// 		// resources: {
			// 		// 	en: {
			// 		// 		translation: jsonval
			// 		// 	}
			// 		// },

			// 		lng: "en", // if you're using a language detector, do not define the lng option
			// 		fallbackLng: "en",
			// 		// load: "languageOnly",
			// 		// ns: ["common"],
			// 		// defaultNS: "common",

			// 		// react: {
			// 		// 	wait: true,
			// 		// 	nsMode: "default"
			// 		// },

			// 		// postProcess: ['lazyInterpolateWithFunctions'],

			// 		interpolation: {
			// 			escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
			// 			prefix: '{',
			// 			suffix: '}'
			// 		}
			// 	});


			setLangKeysList(response);

			//Images labels update
			setImages([
				{
					url: '',
					label: t('Square_Slab')
				},
				{
					url: '',
					label: t('Column')
				},
				{
					url: '',
					label: t('Tube')
				},
				{
					url: '',
					label: t('Wall')
				},
				{
					url: '',
					label: t('Strip_foundations')
				},
				{
					url: '',
					label: t('Stairs')
				}]);
			setLangKeysReady(true);

		});
	}


	// const getProjectList = () => {
	// 	fetch(urlBase + 'project/' + siteId, {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		//console.log('response get project', response);
	// 		var projectListTemp = response;

	// 		if (projectListTemp != null && projectListTemp != 'null' && projectListTemp != undefined) {
	// 			var modArray = [];
	// 			projectListTemp.forEach(element => {
	// 				modArray.push({
	// 					value: element.id,
	// 					label: element.name
	// 				});
	// 			});
	// 			setProjectList(modArray);
	// 		} else {
	// 			setProjectList([]);
	// 		}
	// 		// setNewProject('');
	// 		setDataReady(true);
	// 	})
	// }

	// const getOptionsList = () => {
	// 	fetch(urlBase + 'projectoption/' + siteId, {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		var optionsListTemp = response;

	// 		if (optionsListTemp != null && optionsListTemp != 'null' && optionsListTemp != undefined) {
	// 			// var modArray = [];
	// 			// optionsListTemp.forEach(element => {
	// 			// 	modArray.push({
	// 			// 		value: element.id,
	// 			// 		label: element.name
	// 			// 	});
	// 			// });
	// 			setOptionList(optionsListTemp);
	// 		} else {
	// 			setOptionList([]);
	// 		}
	// 		// setNewOption('');
	// 		setOptionsReady(true);
	// 	})
	// }

	const getDefaultUnitsList = (indexImage, indexShape) => {
		fetch(urlBase + 'defaultunit/' + siteId, {
			// body: new FormData(form),
			method: 'GET'
		}).then(function (response) {
			return response.json();
		}).then(function (response) {
			//console.log('getDefaultUnitsList response 1', response);
			var defaultUnitsList = response;

			// if (defaultUnitsList.length == 0) {
			// 	createDefaultUnitsInit();

			// }

			if (defaultUnitsList != null && defaultUnitsList != 'null' && defaultUnitsList != undefined && defaultUnitsList.length > 0) {
				//console.log('before setDefaultUnitsList');
				// Liferay.Util.fetch(urlBase + 'defaultunits?page=2', {
				// 	// body: new FormData(form),
				// 	method: 'GET'
				// }).then(function (response) {
				// 	return response.json();
				// }).then(function (response) {
				// 	//console.log('getDefaultUnitsList response 2', response);
				// 	response.items.forEach(element => {
				// 		defaultUnitsList.push(element);
				// 	});
				// 	//console.log('defaultUnitsList 2 final', defaultUnitsList);

				var defunit = defaultUnitsList.filter(c => c.side == 0 && c.shape == 0 && c.systemUnit == 0)[0];
				var selSysUnit = 1;
				if (defunit.defaultUnitVal == 'm | cm') {
					setUnitsM([{
						label: 'm',
						value: 'm'
					},
					{
						label: 'cm',
						value: 'cm'
					},
					{
						label: 'mm',
						value: 'mm'
					}]);
					selSysUnit = 0;
				} else {
					setUnitsM([{
						label: 'ft',
						value: 'ft'
					},
					{
						label: 'in',
						value: 'in'
					},
					{
						label: 'y',
						value: 'y'
					}]);
				}

				if (indexImage == 0) {
					var lengthUnit = defaultUnitsList.filter(c => c.side == 1 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setLengthUnitArray(lengthUnit, indexShape);
					var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setWidthUnitArray(widthUnit, indexShape);
					var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setheightUnitArray(heightUnit, indexShape);
				}
				if (indexImage == 1) {
					var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setheightUnitArray(heightUnit, indexShape);
					var diameterUnit = defaultUnitsList.filter(c => c.side == 4 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setDiameterUnitArray(diameterUnit, indexShape);
				}
				if (indexImage == 2) {
					var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setheightUnitArray(heightUnit, indexShape);
					var d1 = defaultUnitsList.filter(c => c.side == 5 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setOuterDiameterUnitArray(d1, indexShape);
					var d2 = defaultUnitsList.filter(c => c.side == 6 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setInnerDiameterUnitArray(d2, indexShape);
				}
				if (indexImage == 3) {
					var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setWidthUnitArray(widthUnit, indexShape);
					var lengthUnit = defaultUnitsList.filter(c => c.side == 1 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setLengthUnitArray(lengthUnit, indexShape);
					var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setheightUnitArray(heightUnit, indexShape);
				}
				if (indexImage == 4) {
					var outerWidthUnit = defaultUnitsList.filter(c => c.side == 7 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setOuterWidthUnitArray(outerWidthUnit, indexShape);
					var outerLengthUnit = defaultUnitsList.filter(c => c.side == 8 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setOuterLengthUnitArray(outerLengthUnit, indexShape);
					var innerWidthUnit = defaultUnitsList.filter(c => c.side == 9 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setInnerWidthUnitArray(innerWidthUnit, indexShape);
					var innerLengthUnit = defaultUnitsList.filter(c => c.side == 10 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setInnerLengthUnitArray(innerLengthUnit, indexShape);
					var depthUnit = defaultUnitsList.filter(c => c.side == 11 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setDepthUnitArray(depthUnit, indexShape);
				}
				if (indexImage == 5) {
					var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setWidthUnitArray(widthUnit, indexShape);
					var riseUnit = defaultUnitsList.filter(c => c.side == 12 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setRiseUnitArray(riseUnit, indexShape);
					var run = defaultUnitsList.filter(c => c.side == 13 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setRunUnitArray(run, indexShape);
					var platformDepthUnit = defaultUnitsList.filter(c => c.side == 14 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setPlatformDepthUnitArray(platformDepthUnit, indexShape);
				}

				setDefaultUnitsList(defaultUnitsList);

				//GetDecimalNumbers
				var decimalsCount = defaultUnitsList.filter(c => c.side == 999)[0]?.shape;

				if (decimalsCount != null && decimalsCount != undefined && decimalsCount != '') {
					setdecimalsCount(parseInt(decimalsCount));
				}

				var decimalsCountID = defaultUnitsList.filter(c => c.side == 999)[0]?.id;
				if (decimalsCountID != null && decimalsCountID != undefined && decimalsCountID != '') {
					setdecimalsCountID(decimalsCountID);
				}

				// });
			} else {
				setDefaultUnitsList([]);
			}

			////console.log('defaultUnitsList.length', defaultUnitsList.length);
			if (defaultUnitsList.length > 0) {
				setDataDefaultUnitsReady(true);
			}
			// else {
			// 	////console.log('before createDefaultUnitsInit');
			// 	createDefaultUnitsInit();
			// }

		})
	}

	// const getProjectListLiferay = () => {
	// 	Liferay.Util.fetch(urlBase + 'projects/', {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		var projectList = response.items;

	// 		if (projectList != null && projectList != 'null' && projectList != undefined) {
	// 			setProjectList(projectList);
	// 		} else {
	// 			setProjectList([]);
	// 		}
	// 		// setNewProject('');
	// 		setDataReady(true);
	// 	})
	// }

	// const getOptionsListLiferay = () => {
	// 	Liferay.Util.fetch(urlBase + 'options/', {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		var optionsList = response.items;


	// 		if (optionsList != null && optionsList != 'null' && optionsList != undefined) {
	// 			setOptionList(optionsList);
	// 		} else {
	// 			setOptionList([]);
	// 		}
	// 		// setNewOption('');
	// 		setOptionsReady(true);
	// 	})
	// }



	// const getDefaultUnitsListLiferay = (indexImage, indexShape) => {
	// 	Liferay.Util.fetch(urlBase + 'defaultunits?pageSize=50', {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		//console.log('getDefaultUnitsList response 1', response);
	// 		var defaultUnitsList = response.items;

	// 		// if (defaultUnitsList.length == 0) {
	// 		// 	createDefaultUnitsInit();

	// 		// }

	// 		if (defaultUnitsList != null && defaultUnitsList != 'null' && defaultUnitsList != undefined && defaultUnitsList.length > 0) {
	// 			//console.log('before setDefaultUnitsList');
	// 			// Liferay.Util.fetch(urlBase + 'defaultunits?page=2', {
	// 			// 	// body: new FormData(form),
	// 			// 	method: 'GET'
	// 			// }).then(function (response) {
	// 			// 	return response.json();
	// 			// }).then(function (response) {
	// 			// 	//console.log('getDefaultUnitsList response 2', response);
	// 			// 	response.items.forEach(element => {
	// 			// 		defaultUnitsList.push(element);
	// 			// 	});
	// 			// 	//console.log('defaultUnitsList 2 final', defaultUnitsList);

	// 			var defunit = defaultUnitsList.filter(c => c.side == 0 && c.shape == 0 && c.systemUnit == 0)[0];
	// 			var selSysUnit = 1;
	// 			if (defunit.defaultUnitVal == 'm | cm') {
	// 				setUnitsM(['m', 'cm']);
	// 				selSysUnit = 0;
	// 			} else {
	// 				setUnitsM(['ft', 'in']);
	// 			}

	// 			if (indexImage == 0) {
	// 				var lengthUnit = defaultUnitsList.filter(c => c.side == 1 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setLengthUnitArray(lengthUnit, indexShape);
	// 				var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setWidthUnitArray(widthUnit, indexShape);
	// 				var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setheightUnitArray(heightUnit, indexShape);
	// 			}
	// 			if (indexImage == 1) {
	// 				var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setheightUnitArray(heightUnit, indexShape);
	// 				var diameterUnit = defaultUnitsList.filter(c => c.side == 4 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setDiameterUnitArray(diameterUnit, indexShape);
	// 			}
	// 			if (indexImage == 2) {
	// 				var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setheightUnitArray(heightUnit, indexShape);
	// 				var d1 = defaultUnitsList.filter(c => c.side == 5 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setOuterDiameterUnitArray(d1, indexShape);
	// 				var d2 = defaultUnitsList.filter(c => c.side == 6 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setInnerDiameterUnitArray(d2, indexShape);
	// 			}
	// 			if (indexImage == 3) {
	// 				var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setWidthUnitArray(widthUnit, indexShape);
	// 				var lengthUnit = defaultUnitsList.filter(c => c.side == 1 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setLengthUnitArray(lengthUnit, indexShape);
	// 				var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setheightUnitArray(heightUnit, indexShape);
	// 			}
	// 			if (indexImage == 4) {
	// 				var outerWidthUnit = defaultUnitsList.filter(c => c.side == 7 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setOuterWidthUnitArray(outerWidthUnit, indexShape);
	// 				var outerLengthUnit = defaultUnitsList.filter(c => c.side == 8 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setOuterLengthUnitArray(outerLengthUnit, indexShape);
	// 				var innerWidthUnit = defaultUnitsList.filter(c => c.side == 9 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setInnerWidthUnitArray(innerWidthUnit, indexShape);
	// 				var innerLengthUnit = defaultUnitsList.filter(c => c.side == 10 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setInnerLengthUnitArray(innerLengthUnit, indexShape);
	// 				var depthUnit = defaultUnitsList.filter(c => c.side == 11 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setDepthUnitArray(depthUnit, indexShape);
	// 			}
	// 			if (indexImage == 5) {
	// 				var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setWidthUnitArray(widthUnit, indexShape);
	// 				var riseUnit = defaultUnitsList.filter(c => c.side == 12 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setRiseUnitArray(riseUnit, indexShape);
	// 				var run = defaultUnitsList.filter(c => c.side == 13 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setRunUnitArray(run, indexShape);
	// 				var platformDepthUnit = defaultUnitsList.filter(c => c.side == 14 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setPlatformDepthUnitArray(platformDepthUnit, indexShape);
	// 			}

	// 			setDefaultUnitsList(defaultUnitsList);

	// 			// });
	// 		} else {
	// 			setDefaultUnitsList([]);
	// 		}

	// 		////console.log('defaultUnitsList.length', defaultUnitsList.length);
	// 		if (defaultUnitsList.length > 0) {
	// 			setDataDefaultUnitsReady(true);
	// 		}
	// 		// else {
	// 		// 	////console.log('before createDefaultUnitsInit');
	// 		// 	createDefaultUnitsInit();
	// 		// }

	// 	})
	// }

	const onChangedSelectedImage = (index, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.selectedImage = index;
				// elementTemp.length = null;
				// // elementTemp.lengthUnit = null;
				// // elementTemp.widthUnit = null;
				// elementTemp.width = null;
				// // elementTemp.diameterUnit = null;
				// elementTemp.diameter = null;
				// // elementTemp.heightUnit = null;
				// elementTemp.height = null;
				// // elementTemp.outerDiameterUnit = null;
				// elementTemp.outerDiameter = null;
				// // elementTemp.innerDiameterUnit = null;
				// elementTemp.innerDiameter = null;
				// // elementTemp.outerWidthUnit = null;
				// elementTemp.outerWidth = null;
				// // elementTemp.innerWidthUnit = null;
				// elementTemp.innerWidth = null;
				// // elementTemp.outerLengthUnit = null;
				// elementTemp.outerLength = null;
				// // elementTemp.innerLengthUnit = null;
				// elementTemp.innerLength = null;
				// // elementTemp.depthUnit = null;
				// elementTemp.depth = null;
				// // elementTemp.riseUnit = null;
				// elementTemp.rise = null;
				// // elementTemp.runUnit = null;
				// elementTemp.run = null;
				// // elementTemp.platformDepthUnit = null;
				// elementTemp.platformDepth = null;
				// elementTemp.numberStairs = null;
				// elementTemp.shapeVolume = null;



				///ON ZERO
				elementTemp.length = 0;
				// elementTemp.lengthUnit = 0;
				// elementTemp.widthUnit = 0;
				elementTemp.width = 0;
				// elementTemp.diameterUnit = 0;
				elementTemp.diameter = 0;
				// elementTemp.heightUnit = 0;
				elementTemp.height = 0;
				// elementTemp.outerDiameterUnit = 0;
				elementTemp.outerDiameter = 0;
				// elementTemp.innerDiameterUnit = 0;
				elementTemp.innerDiameter = 0;
				// elementTemp.outerWidthUnit = 0;
				elementTemp.outerWidth = 0;
				// elementTemp.innerWidthUnit = 0;
				elementTemp.innerWidth = 0;
				// elementTemp.outerLengthUnit = 0;
				elementTemp.outerLength = 0;
				// elementTemp.innerLengthUnit = 0;
				elementTemp.innerLength = 0;
				// elementTemp.depthUnit = 0;
				elementTemp.depth = 0;
				// elementTemp.riseUnit = 0;
				elementTemp.rise = 0;
				// elementTemp.runUnit = 0;
				elementTemp.run = 0;
				// elementTemp.platformDepthUnit = 0;
				elementTemp.platformDepth = 0;
				elementTemp.numberStairs = 0;
				elementTemp.shapeVolume = 0;
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		// setSelectedImage(index);
		getDefaultUnitsList(index, indexShape);
	}
	// const onChangeProject = (id) => {
	// 	setSelectedProjectId(id);
	// 	var filteredList = optionList.filter(c => c.r_project_c_projectId == id);
	// 	setOptionListFiltered(filteredList);
	// }



	const disableNext = () => {
		if (shapesVolumeArray.length > 0) {
			return null;
		} else {
			return 'disabled';
		}
	}

	const shapeArrayValid = () => {
		var valid = true;
		shapesVolumeArray.forEach(element => {
			if (element.shapeVolume <= 0) {
				valid = false;
			}
		});
		var total = calcTotalPlusReserveVolume();
		if (total < minimumVolume) {
			valid = false;
		}

		return valid;
	}

	const deleteShapeValid = () => {
		if (shapesVolumeArray.length > 1) {
			return true;
		} else {
			return false;
		}
	}

	const activateNext = () => {
		// var vol1 = calcTotalPlusReserveVolume();

		// var imageName = images[selectedImage].label;
		// var volume = 0;

		// var lengthVal = length;
		// if (lengthUnit == 'cm') {
		// 	lengthVal = length * 0.01
		// }
		// var widthVal = width;
		// if (widthUnit == 'cm') {
		// 	widthVal = width * 0.01
		// }
		// var depthVal = depth;
		// if (depthUnit == 'cm') {
		// 	depthVal = depth * 0.01
		// }
		// var heightVal = height;
		// if (heightUnit == 'cm') {
		// 	heightVal = height * 0.01
		// }
		// volume = lengthVal * widthVal * depthVal;


		// if (volume < 1) {
		// 	volume = 1;
		// }
		// setTotalVolume(volume);

		// let win = window.parent
		// win.postMessage(postMsg, "https://cxogdev-web.cemexgws.com/");//liferay domain

		var volPlusReserveVal = calcTotalPlusReserveVolume();
		var volVal = calcTotalVolume();
		var resVolVal = calcTotalReserveVolume();
		var imgLabel = images[selectedImage].label;

		//Check minimum volume
		if (volPlusReserveVal < minimumVolume) {
			return;
		}

		var newItems = [];
		shapesVolumeArray.forEach(element => {
			newItems.push({
				shapeVolume: element.shapeVolume,
				shape: images[element.selectedImage].label
			})
		});

		var defunit = defaultUnitsList.filter(c => c.side == 0 && c.shape == 0 && c.systemUnit == 0)[0];
		var unitDesc = '';
		if (defunit.defaultUnitVal == 'm | cm') {
			unitDesc = 'cubic meters';
		} else {
			unitDesc = 'cubic yards';
		}
		// var projectName = projectList.filter(c => c.value == selectedProjectId)[0].label;
		// var optionName = optionList.filter(c => c.id == selectedOptionId)[0].name;
		var projectName = '';
		var optionName = '';
		console.log('postMsg 2')
		let postMsg = {
			// reserveVolume: reserveVolume,
			// reservedVolumeAmount: resVolVal,
			// totalVolume: volVal,
			// totalPlusReserveVolume: volPlusReserveVal,


			reserveVolume: Number(reserveVolume).toFixed(2),
			reservedVolumeAmount: Number(resVolVal).toFixed(2),
			totalVolume: Number(volVal).toFixed(2),
			totalPlusReserveVolume: Number(volPlusReserveVal).toFixed(2),


			// reserveVolume: reserveVolume.toLocaleString(undefined, { maximumFractionDigits: decimalsCount }),
			// reservedVolumeAmount: resVolVal.toLocaleString(undefined, { maximumFractionDigits: decimalsCount }),
			// totalVolume: volVal.toLocaleString(undefined, { maximumFractionDigits: decimalsCount }),
			// totalPlusReserveVolume: volPlusReserveVal.toLocaleString(undefined, { maximumFractionDigits: decimalsCount }),
			project: projectName,
			option: optionName,
			items: newItems,
			unitDesc: unitDesc,
			amountConcrete: volVal.toLocaleString(undefined, { maximumFractionDigits: decimalsCount }) + ' ' + unitDesc + '(+' + reserveVolume + '% additional reserve volume)' + volPlusReserveVal.toLocaleString(undefined, { maximumFractionDigits: decimalsCount }) + ' ' + unitDesc,
			projectApplication: projectName + ' ' + optionName
		};

		// let postMsg = { reservedVolume: resVolVal, totalVolume: volVal, contructionElement: imgLabel };


		// let postMsg = { reservedVolume: volume * (reserveVolume * 0.01), totalVolume: volume, contructionElement: imageName };

		Liferay.fire('getConcreteCalculatorData', postMsg);
		console.log('Message posted', postMsg);

		setNextActivated(true);
	};


	const getOptionsListFiltered = (id) => {
		//console.log('getOptionsListFiltered', id);
		var optionsFiltered = [];
		optionList.forEach(element => {
			//console.log('getOptionsListFiltered  element', element)
			if (element.projectId == id) {
				optionsFiltered.push({
					value: element.id,
					label: element.name,
				});
			}
		});

		var opAlph = optionsFiltered.sort(function (a, b) {
			if (a.label < b.label) {
				return -1;
			}
			if (a.label > b.label) {
				return 1;
			}
			return 0;
		});
		//console.log('opAlph', opAlph);
		return opAlph;
	};


	// const getOptionsListFilteredLiferay = (id) => {
	// 	// var opList = optionList;
	// 	var optionsFiltered = [];
	// 	optionList.forEach(element => {
	// 		if (element.r_project_c_projectId == id) {
	// 			optionsFiltered.push(element);
	// 		}
	// 	});
	// 	return optionsFiltered;
	// };

	const getProjectName = (id) => {
		var name = '';
		projectList.forEach(element => {
			if (element.value == id) {
				name = element.label
			}
		});
		return name;
	};

	const getOptionName = (id) => {
		var name = '';
		optionList.forEach(element => {
			if (element.id == id) {
				name = element.name
			}
		});
		return name;
	};

	const goConfig = () => {
		if (isAdmin == true) {
			setShowConfig(true);
		}
		// else {
		// 	setShowConfig(false);
		// }
	};

	const goBack = (index) => {
		window.location.reload();
	};

	const addNewShape = () => {
		var newArrayTemp = [];
		shapesVolumeArray.forEach(element => {
			newArrayTemp.push(element);
		});
		newArrayTemp.push({
			id: shapesVolumeArray.length + 1,
			// selectedImage: null,
			// length: null,
			// lengthUnit: null,
			// widthUnit: null,
			// width: null,
			// diameterUnit: null,
			// diameter: null,
			// heightUnit: null,
			// height: null,
			// outerDiameterUnit: null,
			// outerDiameter: null,
			// innerDiameterUnit: null,
			// innerDiameter: null,
			// outerWidthUnit: null,
			// outerWidth: null,
			// innerWidthUnit: null,
			// innerWidth: null,
			// outerLengthUnit: null,
			// outerLength: null,
			// innerLengthUnit: null,
			// innerLength: null,
			// depthUnit: null,
			// depth: null,
			// riseUnit: null,
			// rise: null,
			// runUnit: null,
			// run: null,
			// platformDepthUnit: null,
			// platformDepth: null,
			// numberStairs: null,
			// shapeVolume: 0


			//ON ZERO
			selectedImage: 0,
			length: 0,
			lengthUnit: 0,
			widthUnit: 0,
			width: 0,
			diameterUnit: 0,
			diameter: 0,
			heightUnit: 0,
			height: 0,
			outerDiameterUnit: 0,
			outerDiameter: 0,
			innerDiameterUnit: 0,
			innerDiameter: 0,
			outerWidthUnit: 0,
			outerWidth: 0,
			innerWidthUnit: 0,
			innerWidth: 0,
			outerLengthUnit: 0,
			outerLength: 0,
			innerLengthUnit: 0,
			innerLength: 0,
			depthUnit: 0,
			depth: 0,
			riseUnit: 0,
			rise: 0,
			runUnit: 0,
			run: 0,
			platformDepthUnit: 0,
			platformDepth: 0,
			numberStairs: 0,
			shapeVolume: 0
		});
		setShapesVolumeArray(newArrayTemp);
		////console.log('newArrayTemp', newArrayTemp);

		setShapeAdded(shapeAdded + 1);
		setSelectedArrayShapeItem(shapeAdded + 1);
	};

	const calculateShapeVolume = (item) => {
		//length
		var lengthVal = item.length;
		if (item.lengthUnit == 'cm') {
			lengthVal = item.length / 100
		}
		if (item.lengthUnit == 'ft') {
			lengthVal = item.length / 3.281
		}
		if (item.lengthUnit == 'in') {
			lengthVal = item.length / 39.37
		}
		if (item.lengthUnit == 'y') {
			lengthVal = item.length / 1.094
		}
		if (item.lengthUnit == 'mm') {
			lengthVal = item.length / 1000
		}

		//width
		var widthVal = item.width;
		if (item.widthUnit == 'cm') {
			widthVal = item.width / 100
		}
		if (item.widthUnit == 'ft') {
			widthVal = item.width / 3.281
		}
		if (item.widthUnit == 'in') {
			widthVal = item.width / 39.37
		}
		if (item.widthUnit == 'y') {
			widthVal = item.width / 1.094
		}
		if (item.widthUnit == 'mm') {
			widthVal = item.width / 1000
		}

		//height
		var heightVal = item.height;
		if (item.heightUnit == 'cm') {
			heightVal = item.height / 100
		}
		if (item.heightUnit == 'ft') {
			heightVal = item.height / 3.281
		}
		if (item.heightUnit == 'in') {
			heightVal = item.height / 39.37
		}
		if (item.heightUnit == 'y') {
			heightVal = item.height / 1.094
		}
		if (item.heightUnit == 'mm') {
			heightVal = item.height / 1000
		}


		//Diameter
		var diameterVal = item.diameter;
		if (item.diameterUnit == 'cm') {
			diameterVal = item.diameter / 100
		}
		if (item.diameterUnit == 'ft') {
			diameterVal = item.diameter / 3.281
		}
		if (item.diameterUnit == 'in') {
			diameterVal = item.diameter / 39.37
		}
		if (item.diameterUnit == 'y') {
			diameterVal = item.diameter / 1.094
		}
		if (item.diameterUnit == 'mm') {
			diameterVal = item.diameter / 1000
		}


		//outer Diameter
		var outerDiameterVal = item.outerDiameter;
		if (item.outerDiameterUnit == 'cm') {
			outerDiameterVal = item.outerDiameter / 100
		}
		if (item.outerDiameterUnit == 'ft') {
			outerDiameterVal = item.outerDiameter / 3.281
		}
		if (item.outerDiameterUnit == 'in') {
			outerDiameterVal = item.outerDiameter / 39.37
		}
		if (item.outerDiameterUnit == 'y') {
			outerDiameterVal = item.outerDiameter / 1.094
		}
		if (item.outerDiameterUnit == 'mm') {
			outerDiameterVal = item.outerDiameter / 1000
		}


		//inner Diameter
		var innerDiameterVal = item.innerDiameter;
		if (item.innerDiameterUnit == 'cm') {
			innerDiameterVal = item.innerDiameter / 100
		}
		if (item.innerDiameterUnit == 'ft') {
			innerDiameterVal = item.innerDiameter / 3.281
		}
		if (item.innerDiameterUnit == 'in') {
			innerDiameterVal = item.innerDiameter / 39.37
		}
		if (item.innerDiameterUnit == 'y') {
			innerDiameterVal = item.innerDiameter / 1.094
		}
		if (item.innerDiameterUnit == 'mm') {
			innerDiameterVal = item.innerDiameter / 1000
		}

		//Outer length
		var outerLengthVal = item.outerLength;
		if (item.outerLengthUnit == 'cm') {
			outerLengthVal = item.outerLength / 100
		}
		if (item.outerLengthUnit == 'ft') {
			outerLengthVal = item.outerLength / 3.281
		}
		if (item.outerLengthUnit == 'in') {
			outerLengthVal = item.outerLength / 39.37
		}
		if (item.outerLengthUnit == 'y') {
			outerLengthVal = item.outerLength / 1.094
		}
		if (item.outerLengthUnit == 'mm') {
			outerLengthVal = item.outerLength / 1000
		}

		//outer Width
		var outerWidthVal = item.outerWidth;
		if (item.outerWidthUnit == 'cm') {
			outerWidthVal = item.outerWidth / 100
		}
		if (item.outerWidthUnit == 'ft') {
			outerWidthVal = item.outerWidth / 3.281
		}
		if (item.outerWidthUnit == 'in') {
			outerWidthVal = item.outerWidth / 39.37
		}
		if (item.outerWidthUnit == 'y') {
			outerWidthVal = item.outerWidth / 1.094
		}
		if (item.outerWidthUnit == 'mm') {
			outerWidthVal = item.outerWidth / 1000
		}

		//inner Length
		var innerLengthVal = item.innerLength;
		if (item.innerLengthUnit == 'cm') {
			innerLengthVal = item.innerLength / 100
		}
		if (item.innerLengthUnit == 'ft') {
			innerLengthVal = item.innerLength / 3.281
		}
		if (item.innerLengthUnit == 'in') {
			innerLengthVal = item.innerLength / 39.37
		}
		if (item.innerLengthUnit == 'y') {
			innerLengthVal = item.innerLength / 1.094
		}
		if (item.innerLengthUnit == 'mm') {
			innerLengthVal = item.innerLength / 1000
		}


		//inner width
		var innerWidthVal = item.innerWidth;
		if (item.innerWidthUnit == 'cm') {
			innerWidthVal = item.innerWidth / 100
		}
		if (item.innerWidthUnit == 'ft') {
			innerWidthVal = item.innerWidth / 3.281
		}
		if (item.innerWidthUnit == 'in') {
			innerWidthVal = item.innerWidth / 39.37
		}
		if (item.innerWidthUnit == 'y') {
			innerWidthVal = item.innerWidth / 1.094
		}
		if (item.innerWidthUnit == 'mm') {
			innerWidthVal = item.innerWidth / 1000
		}


		//depth
		var depthVal = item.depth;
		if (item.depthUnit == 'cm') {
			depthVal = item.depth / 100
		}
		if (item.depthUnit == 'ft') {
			depthVal = item.depth / 3.281
		}
		if (item.depthUnit == 'in') {
			depthVal = item.depth / 39.37
		}
		if (item.depthUnit == 'y') {
			depthVal = item.depth / 1.094
		}
		if (item.depthUnit == 'mm') {
			depthVal = item.depth / 1000
		}


		//rise
		var riseVal = item.rise;
		if (item.riseUnit == 'cm') {
			riseVal = item.rise / 100
		}
		if (item.riseUnit == 'ft') {
			riseVal = item.rise / 3.281
		}
		if (item.riseUnit == 'in') {
			riseVal = item.rise / 39.37
		}
		if (item.riseUnit == 'y') {
			riseVal = item.rise / 1.094
		}
		if (item.riseUnit == 'mm') {
			riseVal = item.rise / 1000
		}


		//run
		var runVal = item.run;
		if (item.runUnit == 'cm') {
			runVal = item.run / 100
		}
		if (item.runUnit == 'ft') {
			runVal = item.run / 3.281
		}
		if (item.runUnit == 'in') {
			runVal = item.run / 39.37
		}
		if (item.runUnit == 'y') {
			runVal = item.run / 1.094
		}
		if (item.runUnit == 'mm') {
			runVal = item.run / 1000
		}


		//platform depth
		var platformDepthVal = item.platformDepth;
		if (item.platformDepthUnit == 'cm') {
			platformDepthVal = item.platformDepth / 100
		}
		if (item.platformDepthUnit == 'ft') {
			platformDepthVal = item.platformDepth / 3.281
		}
		if (item.platformDepthUnit == 'in') {
			platformDepthVal = item.platformDepth / 39.37
		}
		if (item.platformDepthUnit == 'y') {
			platformDepthVal = item.platformDepth / 1.094
		}
		if (item.platformDepthUnit == 'mm') {
			platformDepthVal = item.platformDepth / 1000
		}


		//Calculate volume
		var vol = 0;
		var defunit = ''
		if (defaultUnitsList != null) {
			defunit = defaultUnitsList.filter(c => c.side == 0 && c.shape == 0 && c.systemUnit == 0)[0];
		}

		if (item.selectedImage == 0) {
			vol = lengthVal * widthVal * heightVal;
		}
		if (item.selectedImage == 1) {
			vol = (((3.141592 * Math.pow(diameterVal, 2)) / 4) * heightVal);
		}
		if (item.selectedImage == 2) {
			vol = (((3.141592 * (Math.pow(outerDiameterVal, 2) - Math.pow(innerDiameterVal, 2))) / 4) * heightVal);
		}
		if (item.selectedImage == 3) {
			vol = lengthVal * widthVal * heightVal;
		}
		if (item.selectedImage == 4) {
			vol = ((outerLengthVal * outerWidthVal) - (innerLengthVal * innerWidthVal)) * depthVal;
		}
		if (item.selectedImage == 5) {

			// for (let index = 0; index < item.numberStairs - 1; index++) {
			// vol += calculateStairsVolume(index, widthVal, riseVal, runVal, platformDepthVal, item.numberStairs);
			// }


			for (let index = 1; index < item.numberStairs; index++) {
				vol += widthVal * riseVal * runVal * index;
			}
			vol += widthVal * riseVal * platformDepthVal * item.numberStairs;

			//OLD			
			// for (let index = 0; index < item.numberStairs - 1; index++) {
			// 	vol += riseVal * runVal * widthVal;
			// }
			// vol += riseVal * platformDepthVal;


			if (defunit.defaultUnitVal != 'm | cm') {
				vol = (vol * 3.281) / 3;
			}

		}

		if (defunit.defaultUnitVal == 'm | cm') {
			if (decimalsCount == 1) {
				return roundToNearestHalf(vol);
			} else {
				return vol;
			}
		} else {
			if (decimalsCount == 1) {
				return roundToNearestHalf(vol * 1.30795062);
			} else {
				return vol * 1.30795062;
			}

		}
	};

	// const calculateStairsVolume = (startNumber, width, rise, run, depth, maxStep) => {
	// 	if (startNumber <= maxStep) {
	// 		return width * rise * run * startNumber;
	// 	} else if (startNumber === maxStep) {
	// 		return width * rise * depth * startNumber;
	// 	} else {
	// 		return 0;
	// 	}
	// }

	const getDefaultUnitDesc = () => {
		if (defaultUnitsList != null) {
			var defunit = defaultUnitsList.filter(c => c.side == 0 && c.shape == 0 && c.systemUnit == 0)[0];
			var selSysUnit = 1;
			if (defunit.defaultUnitVal == 'm | cm') {
				return 'm';
			} else {
				return 'y'
			}
		} else {
			return '';
		}


	}

	const setLengthArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.length = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setLengthUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		////console.log('shapesVolumeArray length', shapesVolumeArray);
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.lengthUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setWidthArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.width = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setWidthUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.widthUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setheightArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.height = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setheightUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.heightUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setDiameterArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.diameter = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setDiameterUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.diameterUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setOuterDiameterArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.outerDiameter = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setOuterDiameterUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.outerDiameterUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setInnerDiameterArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.innerDiameter = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setInnerDiameterUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.innerDiameterUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setOuterWidthArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.outerWidth = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setOuterWidthUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.outerWidthUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setInnerWidthArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.innerWidth = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setInnerWidthUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.innerWidthUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setOuterLengthArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.outerLength = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setOuterLengthUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.outerLengthUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setInnerLengthArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.innerLength = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setInnerLengthUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.innerLengthUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setDepthArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.depth = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setDepthUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.depthUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setRiseArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.rise = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setRiseUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.riseUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setRunArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.run = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setRunUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.runUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setPlatformDepthArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.platformDepth = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setPlatformDepthUnitArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.platformDepthUnit = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const setNumberStairsArray = (val, indexShape) => {
		var newArrayTemp = [];
		var i = 0;
		shapesVolumeArray.forEach(element => {
			var elementTemp = element;
			if (indexShape == i) {
				elementTemp.numberStairs = val;
				elementTemp.shapeVolume = calculateShapeVolume(elementTemp);
			}
			i++
			newArrayTemp.push(elementTemp);
		});
		setShapesVolumeArray(newArrayTemp);
		CheckMinVol();
	};

	const onSelectedProjectChanged = (id) => {
		//console.log('onSelectedProjectChanged', id);
		setSelectedProjectId(id);
		setSelectedOptionId(null);
	};

	// const roundToNDecimals = (number, decimals) => {
	// 			const factor = Math.pow(10, decimals);
	// 	return Math.round(number * factor) / factor;
	// };

	function roundToNearestHalf(value) {
		return Math.ceil(value * 2) / 2;
	}

	const calcTotalPlusReserveVolume = () => {
		var total = 0;
		shapesVolumeArray.forEach(element => {
			total += element.shapeVolume;
		});
		var reserveVolAmnt = total * (reserveVolume * 0.01);

		// return Math.ceil((total + reserveVolAmnt)).toFixed(0);
		var totalFinal = total + reserveVolAmnt;

		if (decimalsCount == 1) {
			return roundToNearestHalf(totalFinal);
		} else {
			return totalFinal;
		}


	};


	const CheckMinVol = () => {
		// console.log('CheckMinVol');
		var total = calcTotalVolume();
		if (total < minimumVolume) {
			if (total == 0) {
				setShowMinVolMessage(false);
				// console.log('setShowMinVolMessage', showMinVolMessage);
			} else {
				setShowMinVolMessage(true);
				// console.log('setShowMinVolMessage', showMinVolMessage);
			}

		} else {
			setShowMinVolMessage(false);
			// console.log('setShowMinVolMessage', showMinVolMessage);
		}
	}

	const calcTotalVolume = () => {
		var total = 0;
		shapesVolumeArray.forEach(element => {
			total += element.shapeVolume;
		});

		return total;
	};

	const calcTotalReserveVolume = () => {
		var total = 0;
		shapesVolumeArray.forEach(element => {
			total += element.shapeVolume;
		});
		var reserveVolAmnt = total * (reserveVolume * 0.01);
		// return  Math.ceil(reserveVolAmnt).toFixed(0);
		return reserveVolAmnt;
	};

	const deleteShapeArrayItem = (id, indexShape) => {
		var newArray = [];
		shapesVolumeArray.forEach(element => {
			if (element.id != id) {
				newArray.push(element);
			}
		});
		setShapesVolumeArray(newArray);
		//console.log('indexShape', indexShape);

		setShapeAdded(shapeAdded - 1);
		setSelectedArrayShapeItem(0);
	};

	// const dropdownIndicatorStyles = (base, state) => {
	// 	let changes = {
	// 		// all your override styles
	// 		backgroundColor: 'blue'
	// 	};
	// 	return Object.assign(base, changes);
	// };

	return (
		<div>
			{isMobile
				?
				//MOBILE VIEW 
				(
					<div>
						<div className='row outfiter mobile-margin'>
							{
								nextActivated == false ? (
									<div className="row  align-items-center justify-content-start mb-3">
										{
											showConfig == true ? (
												<button type="button" className="cmx-button-1 m-2" onClick={() => goBack()}>Go back</button>
											) :
												(
													<p className='h3 cmx-header'>{t('Calculate_your_volume')}</p>
												)
										}
										{
											showConfig == false && isAdmin == true ? (
												<svg className='gear-icon m-2 pb-1' onClick={() => goConfig()} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
													<path d="M12.9046 3.06005C12.6988 3 12.4659 3 12 3C11.5341 3 11.3012 3 11.0954 3.06005C10.7942 3.14794 10.5281 3.32808 10.3346 3.57511C10.2024 3.74388 10.1159 3.96016 9.94291 4.39272C9.69419 5.01452 9.00393 5.33471 8.36857 5.123L7.79779 4.93281C7.3929 4.79785 7.19045 4.73036 6.99196 4.7188C6.70039 4.70181 6.4102 4.77032 6.15701 4.9159C5.98465 5.01501 5.83376 5.16591 5.53197 5.4677C5.21122 5.78845 5.05084 5.94882 4.94896 6.13189C4.79927 6.40084 4.73595 6.70934 4.76759 7.01551C4.78912 7.2239 4.87335 7.43449 5.04182 7.85566C5.30565 8.51523 5.05184 9.26878 4.44272 9.63433L4.16521 9.80087C3.74031 10.0558 3.52786 10.1833 3.37354 10.3588C3.23698 10.5141 3.13401 10.696 3.07109 10.893C3 11.1156 3 11.3658 3 11.8663C3 12.4589 3 12.7551 3.09462 13.0088C3.17823 13.2329 3.31422 13.4337 3.49124 13.5946C3.69158 13.7766 3.96395 13.8856 4.50866 14.1035C5.06534 14.3261 5.35196 14.9441 5.16236 15.5129L4.94721 16.1584C4.79819 16.6054 4.72367 16.829 4.7169 17.0486C4.70875 17.3127 4.77049 17.5742 4.89587 17.8067C5.00015 18.0002 5.16678 18.1668 5.5 18.5C5.83323 18.8332 5.99985 18.9998 6.19325 19.1041C6.4258 19.2295 6.68733 19.2913 6.9514 19.2831C7.17102 19.2763 7.39456 19.2018 7.84164 19.0528L8.36862 18.8771C9.00393 18.6654 9.6942 18.9855 9.94291 19.6073C10.1159 20.0398 10.2024 20.2561 10.3346 20.4249C10.5281 20.6719 10.7942 20.8521 11.0954 20.94C11.3012 21 11.5341 21 12 21C12.4659 21 12.6988 21 12.9046 20.94C13.2058 20.8521 13.4719 20.6719 13.6654 20.4249C13.7976 20.2561 13.8841 20.0398 14.0571 19.6073C14.3058 18.9855 14.9961 18.6654 15.6313 18.8773L16.1579 19.0529C16.605 19.2019 16.8286 19.2764 17.0482 19.2832C17.3123 19.2913 17.5738 19.2296 17.8063 19.1042C17.9997 18.9999 18.1664 18.8333 18.4996 18.5001C18.8328 18.1669 18.9994 18.0002 19.1037 17.8068C19.2291 17.5743 19.2908 17.3127 19.2827 17.0487C19.2759 16.8291 19.2014 16.6055 19.0524 16.1584L18.8374 15.5134C18.6477 14.9444 18.9344 14.3262 19.4913 14.1035C20.036 13.8856 20.3084 13.7766 20.5088 13.5946C20.6858 13.4337 20.8218 13.2329 20.9054 13.0088C21 12.7551 21 12.4589 21 11.8663C21 11.3658 21 11.1156 20.9289 10.893C20.866 10.696 20.763 10.5141 20.6265 10.3588C20.4721 10.1833 20.2597 10.0558 19.8348 9.80087L19.5569 9.63416C18.9478 9.26867 18.6939 8.51514 18.9578 7.85558C19.1262 7.43443 19.2105 7.22383 19.232 7.01543C19.2636 6.70926 19.2003 6.40077 19.0506 6.13181C18.9487 5.94875 18.7884 5.78837 18.4676 5.46762C18.1658 5.16584 18.0149 5.01494 17.8426 4.91583C17.5894 4.77024 17.2992 4.70174 17.0076 4.71872C16.8091 4.73029 16.6067 4.79777 16.2018 4.93273L15.6314 5.12287C14.9961 5.33464 14.3058 5.0145 14.0571 4.39272C13.8841 3.96016 13.7976 3.74388 13.6654 3.57511C13.4719 3.32808 13.2058 3.14794 12.9046 3.06005Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												</svg>
											) : ('')
										}
									</div>
								) : ('')
							}

							{
								showConfig == true ? (
									<div className="row align-items-center justify-content-start mb-3 col-12">
										<HelloFoo />
									</div>
								) : (
									<div className="row align-items-start justify-content-start">
										{
											nextActivated == false ? (
												<div className='col-12'>
													{
														dataDefaultUnitsReady == true ? (
															<form className="form-1">
																{/* <div className="row col-12 align-items-center justify-content-start">
																	<label className='cmx-form-label'>{t('Choose_your_project')}</label>
																	<Select
																		className="select-style col-12"
																		closeMenuOnSelect={true}
																		components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																		placeholder={t('Choose_an_option')}
																		styles={customStyles}
																		options={projectList}
																		onChange={(e) => { onSelectedProjectChanged(e.value) }}
																	/>
																</div>
																{
																	selectedProjectId != null ?
																		(
																			<div className="row col-12 align-items-center justify-content-start">
																				<label className='cmx-form-label'>{t('Choose_an_option')}</label>
																				<Select
																					className="select-style col-12"
																					closeMenuOnSelect={true}
																					components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																					placeholder={t('Choose_an_option')}
																					styles={customStyles}
																					options={getOptionsListFiltered(selectedProjectId)}
																					onChange={(e) => { setSelectedOptionId(e.value) }}
																				/>
																			</div>
																		) : ('')
																} */}


																{shapesVolumeArray.map((shapeVol, indexShape) => (
																	<div key={shapeVol.id}>
																		<div className="row col-12 align-items-center justify-content-between mt-2 mb-1">
																			<p className='cmx-form-label'>{t('Shape')} {lettersArray[indexShape]}</p>
																			{
																				selectedArrayShapeItem != indexShape ? (
																					<svg onClick={(e) => { setSelectedArrayShapeItem(indexShape) }} xmlns="http://www.w3.org/2000/svg" width="11" height="4" viewBox="0 0 11 4" fill="none">
																						<path d="M5.5 4L0.73686 0.250001L10.2631 0.25L5.5 4Z" fill="#0003B1" />
																					</svg>
																				) : ('')
																			}
																			{
																				selectedArrayShapeItem == indexShape ? (
																					<div className="row align-items-center justify-content-between">
																						{
																							deleteShapeValid() == true ?
																								(
																									<svg className='mr-3 cursor-pointer' onClick={(e) => { deleteShapeArrayItem(shapeVol.id, indexShape) }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																										<g id="delete_forever" clip-path="url(#clip0_2221_3582)">
																											<path id="Vector" d="M14.12 10.47L12 12.59L9.87 10.47L8.46 11.88L10.59 14L8.47 16.12L9.88 17.53L12 15.41L14.12 17.53L15.53 16.12L13.41 14L15.53 11.88L14.12 10.47ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5ZM6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9Z" fill="#3999FF" />
																										</g>
																										<defs>
																											<clipPath id="clip0_2221_3582">
																												<rect width="24" height="24" fill="white" />
																											</clipPath>
																										</defs>
																									</svg>
																								) :
																								('')
																						}
																						<div className="blue-arrow pb-3" onClick={(e) => { setSelectedArrayShapeItem(indexShape) }}>
																							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																								<path d="M17 14L12 9L7 14L17 14Z" fill="#0003B1" />
																							</svg>
																						</div>
																					</div>
																				) : ('')
																			}
																		</div>
																		{
																			selectedArrayShapeItem == indexShape ? (
																				<div className="row">
																					<div className="d-flex flex-row justify-content-start mobile-slider mb-3 pb-2">
																						{
																							shapeVol.selectedImage == 0 ?
																								(
																									<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(0, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="92" height="42" viewBox="0 0 92 42" fill="none">
																											<path opacity="0.4" d="M30.8401 1L1.37012 17.54V41L30.8401 24.21V1Z" fill="#1203B8" />
																											<path opacity="0.4" d="M91.0001 1H30.8401V24.21H91.0001V1Z" fill="#1203B8" />
																											<path opacity="0.4" d="M61.29 17.54H1V41H61.29V17.54Z" fill="#1203B8" />
																											<path opacity="0.4" d="M91 1L61.29 17.54V41L91 24.21V1Z" fill="#1203B8" />
																											<path d="M1.37012 17.54V41H61.2901L91.0001 24.21V1H30.8401L1.37012 17.54Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M1.37012 17.54H61.2901L91.0001 1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M61.29 41V17.54" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M91.0002 24.21H89.9202" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M87.7802 24.21H30.8402L3.24023 39.93" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M2.31012 40.46L1.37012 41" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M30.8401 24.21V23.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M30.8401 20.79V3.25" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M30.8401 2.08V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																										</svg>
																										<label className='square-1-selected-label col-12 p-1'>{images[0].label}</label>
																									</div>
																								) :
																								(
																									<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(0, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="92" height="42" viewBox="0 0 92 42" fill="none">
																											<path d="M1 17.54V41H61.16L91 24.21V1H30.59L1 17.54Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M1 17.54H61.16L91 1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M61.1599 41V17.54" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M90.9999 24.21H89.9199" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M87.7699 24.21H30.5899L2.87988 39.94" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M1.94 40.46L1 41" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M30.5901 24.21V23.12" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M30.5901 20.79V3.25" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M30.5901 2.08V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																										</svg>
																										<label className='square-1-label col-12 p-1'>{images[0].label}</label>
																									</div>
																								)
																						}
																						{
																							shapeVol.selectedImage == 1 ?
																								(
																									<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(1, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="92" height="56" viewBox="0 0 92 56" fill="none">
																											<path opacity="0.3" d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47556 70.8528 1 46 1C21.1472 1 1 6.47556 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" fill="#0003B8" />
																											<path opacity="0.6" d="M46 55C70.8528 55 91 49.5244 91 42.77C91 36.0155 70.8528 30.54 46 30.54C21.1472 30.54 1 36.0155 1 42.77C1 49.5244 21.1472 55 46 55Z" fill="#0003B8" />
																											<path opacity="0.5" d="M90.83 14.4301V42.7701C90.83 42.7701 92.33 31.8001 46 30.5401C46 30.5401 3.88 30.5401 1 42.7701V15.5501C1 15.5501 6.84 24.9001 46 25.4701C46 25.4701 84.29 25.4701 90.83 14.4301Z" fill="#0003B8" />
																											<path d="M1 42.77C1 42.29 1.1 41.81 1.3 41.35" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M3.04004 39.11C8.75004 34.14 25.77 30.54 45.89 30.54C67.35 30.54 85.3 34.65 89.73 40.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M90.48 41.34C90.68 41.81 90.78 42.28 90.78 42.76" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M45.89 25.46C70.6821 25.46 90.78 19.9844 90.78 13.23C90.78 6.47556 70.6821 1 45.89 1C21.0979 1 1 6.47556 1 13.23C1 19.9844 21.0979 25.46 45.89 25.46Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M1 13.23V42.76C1 49.52 21.1 54.99 45.89 54.99C70.68 54.99 90.78 49.51 90.78 42.76V13.23" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																										</svg>
																										<label className='square-1-selected-label col-12 p-1'>{images[1].label}</label>
																									</div>
																								) :
																								(
																									<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(1, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="92" height="56" viewBox="0 0 92 56" fill="none">
																											<path d="M1 42.77C1 42.29 1.1 41.81 1.3 41.34" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M3.05005 39.1C8.78005 34.13 25.84 30.53 46 30.53C67.51 30.53 85.5 34.63 89.95 40.12" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M90.7 41.34C90.9 41.81 91 42.28 91 42.77" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47555 70.8528 1 46 1C21.1472 1 1 6.47555 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M1 13.23V42.76C1 49.52 21.15 54.99 46 54.99C70.85 54.99 91 49.51 91 42.76V13.23" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																										</svg>
																										<label className='square-1-label col-12 p-1'>{images[1].label}</label>
																									</div>
																								)
																						}
																						{
																							shapeVol.selectedImage == 2 ?
																								(
																									<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(2, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="92" height="56" viewBox="0 0 92 56" fill="none">
																											<path opacity="0.3" d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47556 70.8528 1 46 1C21.1472 1 1 6.47556 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" fill="#0003B8" />
																											<path opacity="0.6" d="M46 55C70.8528 55 91 49.5244 91 42.77C91 36.0155 70.8528 30.54 46 30.54C21.1472 30.54 1 36.0155 1 42.77C1 49.5244 21.1472 55 46 55Z" fill="#0003B8" />
																											<path opacity="0.5" d="M90.83 14.4301V42.7701C90.83 42.7701 92.33 31.8001 46 30.5401C46 30.5401 3.88 30.5401 1 42.7701V15.5501C1 15.5501 6.84 24.9001 46 25.4701C46 25.4701 84.29 25.4701 90.83 14.4301Z" fill="#0003B8" />
																											<path d="M15.9199 43.3401C15.9199 42.8401 16.1699 42.3601 16.6299 41.8901" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																											<path d="M19.3398 40.2501C24.3698 38.1301 34.4198 36.6801 45.9998 36.6801C58.8098 36.6801 69.7398 38.4501 74.0798 40.9401" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																											<path d="M75.3599 41.8901C75.8299 42.3601 76.0699 42.8401 76.0699 43.3401" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																											<path d="M45.9999 19.35C62.6126 19.35 76.0799 16.3727 76.0799 12.7C76.0799 9.02735 62.6126 6.05005 45.9999 6.05005C29.3872 6.05005 15.9199 9.02735 15.9199 12.7C15.9199 16.3727 29.3872 19.35 45.9999 19.35Z" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M15.9199 13.1801V42.6601C15.9199 46.3301 29.3899 49.3101 45.9999 49.3101C62.6099 49.3101 76.0799 46.3301 76.0799 42.6601V13.1801" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M1.11011 42.77C1.11011 42.29 1.21011 41.81 1.41011 41.35" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M3.15015 39.11C8.86015 34.14 25.8802 30.54 46.0002 30.54C67.4602 30.54 85.4101 34.65 89.8401 40.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M90.5901 41.34C90.7901 41.81 90.8901 42.28 90.8901 42.76" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																											<path d="M46.0001 25.46C70.7922 25.46 90.8901 19.9844 90.8901 13.23C90.8901 6.47556 70.7922 1 46.0001 1C21.208 1 1.11011 6.47556 1.11011 13.23C1.11011 19.9844 21.208 25.46 46.0001 25.46Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M1.11011 13.23V42.76C1.11011 49.52 21.2101 54.99 46.0001 54.99C70.7901 54.99 90.8901 49.51 90.8901 42.76V13.23" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path opacity="0.15" d="M45.9999 49.16C62.6126 49.16 76.0799 46.326 76.0799 42.83C76.0799 39.334 62.6126 36.5 45.9999 36.5C29.3872 36.5 15.9199 39.334 15.9199 42.83C15.9199 46.326 29.3872 49.16 45.9999 49.16Z" fill="#0003B8" />
																											<path opacity="0.25" d="M45.9999 19.03C62.6126 19.03 76.0799 16.196 76.0799 12.7C76.0799 9.20403 62.6126 6.37 45.9999 6.37C29.3872 6.37 15.9199 9.20403 15.9199 12.7C15.9199 16.196 29.3872 19.03 45.9999 19.03Z" fill="#0003B8" />
																										</svg>
																										<label className='square-1-selected-label col-12 p-1'>{images[2].label}</label>
																									</div>
																								) :
																								(
																									<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(2, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="92" height="56" viewBox="0 0 92 56" fill="none">
																											<path d="M1 42.77C1 36.01 21.15 30.54 46 30.54C70.85 30.54 91 36.02 91 42.77" stroke="#0003B8" stroke-miterlimit="10" stroke-dasharray="2 2" />
																											<path d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47555 70.8528 1 46 1C21.1472 1 1 6.47555 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" stroke="#0003B8" stroke-miterlimit="10" />
																											<path d="M1 13.23V42.76C1 49.52 21.15 54.99 46 54.99C70.85 54.99 91 49.51 91 42.76V13.23" stroke="#0003B8" stroke-miterlimit="10" />
																											<path d="M15.8501 43.34C15.8501 39.67 29.3501 36.69 46.0001 36.69C62.6501 36.69 76.1501 39.67 76.1501 43.34" stroke="#0003B8" stroke-miterlimit="10" stroke-dasharray="2 2" />
																											<path d="M46.0001 19.35C62.6515 19.35 76.1501 16.3727 76.1501 12.7C76.1501 9.02729 62.6515 6.04999 46.0001 6.04999C29.3487 6.04999 15.8501 9.02729 15.8501 12.7C15.8501 16.3727 29.3487 19.35 46.0001 19.35Z" stroke="#0003B8" stroke-miterlimit="10" />
																											<path d="M15.8501 13.18V42.66C15.8501 46.33 29.3501 49.31 46.0001 49.31C62.6501 49.31 76.1501 46.33 76.1501 42.66V13.18" stroke="#0003B8" stroke-miterlimit="10" />
																										</svg>
																										<label className='square-1-label col-12 p-1'>{images[2].label}</label>
																									</div>
																								)
																						}


																						{
																							shapeVol.selectedImage == 3 ?
																								(
																									<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(3, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="92" height="42" viewBox="0 0 92 42" fill="none">
																											<path opacity="0.3" d="M83.65 9.58997H1V41H83.65V9.58997Z" fill="#0003B8" />
																											<path opacity="0.6" d="M90.9999 1L83.6499 9.59V41L90.9999 32.41V1Z" fill="#0003B8" />
																											<path opacity="0.5" d="M8.42001 1L1 9.59H83.65L91 1H8.42001Z" fill="#0003B8" />
																											<path d="M83.65 9.58997H1V41H83.65V9.58997Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M83.6499 41L90.9999 32.41V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M83.58 9.59L91 1H8.42001L1 9.59" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																										</svg>
																										<label className='square-1-selected-label col-12 p-1'>{images[3].label}</label>
																									</div>
																								) :
																								(
																									<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(3, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="92" height="42" viewBox="0 0 92 42" fill="none">
																											<path d="M83.65 9.58997H1V41H83.65V9.58997Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M83.6499 41L90.9999 32.41V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M83.58 9.59L91 1H8.42001L1 9.59" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																										</svg>
																										<label className='square-1-label col-12 p-1'>{images[3].label}</label>
																									</div>
																								)
																						}


																						{
																							shapeVol.selectedImage == 4 ?
																								(
																									<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(4, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="92" height="30" viewBox="0 0 92 30" fill="none">
																											<path opacity="0.3" d="M71.7799 19.95H1.3999V29H71.7799V19.95Z" fill="#0003B8" />
																											<path opacity="0.6" d="M91 10.05V1L71.77 19.95V29L91 10.05Z" fill="#0003B8" />
																											<path opacity="0.5" d="M20.07 1.27001L1 19.96H71.38L90.61 1.01001L20.08 1.28001L20.07 1.27001ZM68.77 16.61H9.82001L22.25 4.51001L80.99 4.65001L68.77 16.61Z" fill="#0003B8" />
																											<path opacity="0.7" d="M20.62 6.48999V10.05L14.15 16.39H10.22L20.62 6.48999Z" fill="#0003B8" />
																											<path opacity="0.7" d="M75.4801 10.05L81.3901 4.65002L22.6501 4.52002L20.6201 6.49002V10.05H75.4801Z" fill="#0003B8" />
																											<path d="M71.7799 19.95H1.3999V29H71.7799V19.95Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M90.5799 1L71.7699 19.95H1.3999L20.4699 1.27L90.5799 1Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M69.1599 16.61H10.22L22.65 4.52002H81.52L69.1599 16.61Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M91 1V10.05L71.77 29V19.95" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M20.6199 6.48999V10.05L75.9999 9.92999" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M14.0598 16.61L20.6198 10.05" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																										</svg>
																										<label className='square-1-selected-label col-12 p-1'>{images[4].label}</label>
																									</div>
																								) :
																								(
																									<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(4, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="92" height="30" viewBox="0 0 92 30" fill="none">
																											<path d="M71.69 19.95H1V29H71.69V19.95Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M1 19.95L20.16 1.27L90.57 1L71.69 19.95" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M69.0699 16.61H9.85986L22.3499 4.52002H81.4799L69.0699 16.61Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M90.9999 1V10.05L71.6899 29V19.95" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M20.3101 6.48999V10.05L75.9301 9.92998" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																											<path d="M13.71 16.61L20.31 10.05" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																										</svg>
																										<label className='square-1-label col-12 p-1'>{images[4].label}</label>
																									</div>
																								)
																						}

																						{
																							shapeVol.selectedImage == 5 ?
																								(
																									<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(5, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="90" height="60" viewBox="0 0 310 310" fill="none">
																											<line x1="3.67224" y1="155.012" x2="2.49996" y2="305.007" stroke="#0000B3" stroke-width="3" />
																											<line x1="211" y1="306.5" x2="1" y2="306.5" stroke="#0000B3" stroke-width="3" />
																											<path d="M72 155L2 155" stroke="#0000B3" stroke-width="3" />
																											<line x1="141" y1="206.5" x2="71" y2="206.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="211" y1="255.5" x2="141" y2="255.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="294" y1="131.5" x2="224" y2="131.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="225" y1="81.5001" x2="155" y2="81.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="156" y1="30.5001" x2="86" y2="30.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="70.5" y1="205" x2="70.5" y2="155" stroke="#0000B3" stroke-width="3" />
																											<path d="M141 255V205" stroke="#0000B3" stroke-width="3" />
																											<line x1="209.5" y1="305" x2="209.5" y2="255" stroke="#0000B3" stroke-width="3" />
																											<line x1="223.5" y1="130" x2="223.5" y2="80" stroke="#0000B3" stroke-width="3" />
																											<line x1="236" y1="129.5" x2="226" y2="129.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="236" y1="82.5" x2="226" y2="82.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="229.5" y1="128" x2="229.5" y2="81" stroke="#0000B3" stroke-width="3" />
																											<line x1="225.5" y1="67" x2="225.5" y2="77" stroke="#0000B3" stroke-width="3" />
																											<line x1="158.5" y1="67" x2="158.5" y2="77" stroke="#0000B3" stroke-width="3" />
																											<line x1="224" y1="73.5" x2="157" y2="73.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="156.5" y1="13" x2="156.5" y2="23" stroke="#0000B3" stroke-width="3" />
																											<line x1="89.5" y1="13" x2="89.5" y2="23" stroke="#0000B3" stroke-width="3" />
																											<line x1="155" y1="19.5" x2="88" y2="19.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="154.5" y1="80" x2="154.5" y2="30" stroke="#0000B3" stroke-width="3" />
																											<line x1="1.75328" y1="153.838" x2="85.1608" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																											<line x1="70.7533" y1="153.838" x2="154.161" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																											<line x1="70.7533" y1="204.838" x2="154.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																											<line x1="139.753" y1="204.838" x2="223.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																											<line x1="140.753" y1="253.838" x2="224.161" y2="129.166" stroke="#0000B3" stroke-width="3" />
																											<line x1="225.5" y1="302" x2="225.5" y2="312" stroke="#0000B3" stroke-width="3" />
																											<line x1="307.5" y1="189" x2="307.5" y2="179" stroke="#0000B3" stroke-width="3" />
																											<line x1="293.5" y1="180" x2="293.5" y2="130" stroke="#0000B3" stroke-width="3" />
																											<line x1="209.753" y1="254.838" x2="293.161" y2="130.166" stroke="#0000B3" stroke-width="3" />
																											<line x1="209.757" y1="304.161" x2="294.164" y2="179.161" stroke="#0000B3" stroke-width="3" />
																											<line x1="223.757" y1="307.161" x2="308.164" y2="182.161" stroke="#0000B3" stroke-width="3" />
																											<path d="M269.202 258L267.213 250.727H268.108L269.628 256.651H269.699L271.247 250.727H272.241L273.79 256.651H273.861L275.381 250.727H276.276L274.287 258H273.378L271.773 252.205H271.716L270.111 258H269.202ZM277.259 258V252.545H278.097V258H277.259ZM277.685 251.636C277.522 251.636 277.381 251.581 277.263 251.469C277.147 251.358 277.089 251.224 277.089 251.068C277.089 250.912 277.147 250.778 277.263 250.667C277.381 250.556 277.522 250.5 277.685 250.5C277.849 250.5 277.988 250.556 278.104 250.667C278.223 250.778 278.282 250.912 278.282 251.068C278.282 251.224 278.223 251.358 278.104 251.469C277.988 251.581 277.849 251.636 277.685 251.636ZM281.692 258.114C281.237 258.114 280.836 257.999 280.488 257.769C280.14 257.537 279.868 257.21 279.671 256.789C279.475 256.365 279.377 255.865 279.377 255.287C279.377 254.714 279.475 254.217 279.671 253.795C279.868 253.374 280.141 253.049 280.492 252.819C280.842 252.589 281.247 252.474 281.706 252.474C282.061 252.474 282.342 252.534 282.548 252.652C282.756 252.768 282.915 252.901 283.024 253.05C283.135 253.196 283.221 253.317 283.283 253.412H283.354V250.727H284.192V258H283.382V257.162H283.283C283.221 257.261 283.134 257.387 283.02 257.538C282.906 257.687 282.744 257.821 282.534 257.94C282.323 258.056 282.042 258.114 281.692 258.114ZM281.806 257.361C282.142 257.361 282.426 257.273 282.658 257.098C282.89 256.92 283.066 256.675 283.187 256.363C283.308 256.048 283.368 255.685 283.368 255.273C283.368 254.866 283.309 254.509 283.191 254.204C283.072 253.896 282.897 253.657 282.665 253.487C282.433 253.314 282.146 253.227 281.806 253.227C281.45 253.227 281.155 253.318 280.918 253.501C280.683 253.681 280.507 253.926 280.389 254.236C280.273 254.544 280.215 254.889 280.215 255.273C280.215 255.661 280.274 256.014 280.392 256.331C280.513 256.646 280.691 256.897 280.925 257.084C281.162 257.268 281.455 257.361 281.806 257.361ZM288.215 252.545V253.256H285.389V252.545H288.215ZM286.213 251.239H287.051V256.438C287.051 256.674 287.085 256.852 287.154 256.97C287.225 257.086 287.315 257.164 287.423 257.205C287.535 257.242 287.652 257.261 287.775 257.261C287.867 257.261 287.943 257.257 288.002 257.247C288.061 257.235 288.109 257.226 288.144 257.219L288.315 257.972C288.258 257.993 288.179 258.014 288.077 258.036C287.975 258.059 287.846 258.071 287.69 258.071C287.453 258.071 287.221 258.02 286.994 257.918C286.769 257.817 286.582 257.661 286.433 257.453C286.286 257.245 286.213 256.982 286.213 256.665V251.239ZM290.431 254.719V258H289.593V250.727H290.431V253.398H290.502C290.63 253.116 290.822 252.892 291.078 252.727C291.336 252.558 291.679 252.474 292.107 252.474C292.479 252.474 292.805 252.549 293.084 252.698C293.363 252.845 293.58 253.071 293.734 253.376C293.89 253.679 293.968 254.065 293.968 254.534V258H293.13V254.591C293.13 254.158 293.018 253.823 292.793 253.586C292.57 253.347 292.261 253.227 291.866 253.227C291.591 253.227 291.345 253.285 291.127 253.401C290.912 253.517 290.741 253.687 290.616 253.909C290.493 254.132 290.431 254.402 290.431 254.719Z" fill="#0000B3" />
																											<path d="M233.881 108V100.727H236.338C236.906 100.727 237.373 100.824 237.737 101.018C238.102 101.21 238.372 101.474 238.547 101.81C238.722 102.147 238.81 102.529 238.81 102.957C238.81 103.386 238.722 103.766 238.547 104.097C238.372 104.429 238.103 104.689 237.741 104.879C237.379 105.066 236.916 105.159 236.352 105.159H234.364V104.364H236.324C236.712 104.364 237.025 104.307 237.261 104.193C237.5 104.08 237.673 103.919 237.78 103.71C237.889 103.5 237.943 103.249 237.943 102.957C237.943 102.666 237.889 102.412 237.78 102.194C237.671 101.976 237.497 101.808 237.258 101.69C237.019 101.569 236.703 101.509 236.31 101.509H234.761V108H233.881ZM237.304 104.733L239.094 108H238.071L236.31 104.733H237.304ZM240.164 108V102.545H241.002V108H240.164ZM240.59 101.636C240.426 101.636 240.285 101.581 240.167 101.469C240.051 101.358 239.993 101.224 239.993 101.068C239.993 100.912 240.051 100.778 240.167 100.667C240.285 100.556 240.426 100.5 240.59 100.5C240.753 100.5 240.893 100.556 241.009 100.667C241.127 100.778 241.186 100.912 241.186 101.068C241.186 101.224 241.127 101.358 241.009 101.469C240.893 101.581 240.753 101.636 240.59 101.636ZM246.4 103.767L245.647 103.98C245.6 103.855 245.53 103.733 245.438 103.614C245.348 103.494 245.225 103.394 245.069 103.316C244.912 103.238 244.712 103.199 244.468 103.199C244.135 103.199 243.856 103.276 243.634 103.43C243.414 103.581 243.304 103.774 243.304 104.009C243.304 104.217 243.379 104.381 243.531 104.502C243.682 104.623 243.919 104.723 244.241 104.804L245.051 105.003C245.538 105.121 245.902 105.302 246.141 105.546C246.38 105.788 246.5 106.099 246.5 106.48C246.5 106.793 246.41 107.072 246.23 107.318C246.052 107.564 245.804 107.759 245.484 107.901C245.164 108.043 244.793 108.114 244.369 108.114C243.813 108.114 243.352 107.993 242.988 107.751C242.623 107.51 242.392 107.157 242.295 106.693L243.091 106.494C243.166 106.788 243.31 107.008 243.52 107.155C243.733 107.302 244.011 107.375 244.355 107.375C244.745 107.375 245.056 107.292 245.285 107.126C245.517 106.958 245.633 106.757 245.633 106.523C245.633 106.333 245.567 106.175 245.434 106.047C245.302 105.917 245.098 105.82 244.824 105.756L243.914 105.543C243.415 105.424 243.048 105.241 242.814 104.992C242.582 104.741 242.466 104.428 242.466 104.051C242.466 103.743 242.552 103.471 242.725 103.234C242.9 102.998 243.138 102.812 243.439 102.677C243.742 102.542 244.085 102.474 244.468 102.474C245.008 102.474 245.432 102.593 245.74 102.83C246.05 103.066 246.27 103.379 246.4 103.767ZM250.048 108.114C249.523 108.114 249.069 107.998 248.688 107.766C248.309 107.531 248.017 107.205 247.811 106.786C247.607 106.364 247.506 105.874 247.506 105.315C247.506 104.757 247.607 104.264 247.811 103.838C248.017 103.41 248.303 103.076 248.67 102.837C249.04 102.595 249.47 102.474 249.963 102.474C250.247 102.474 250.528 102.522 250.805 102.616C251.081 102.711 251.334 102.865 251.561 103.078C251.788 103.289 251.969 103.568 252.104 103.916C252.239 104.264 252.307 104.693 252.307 105.202V105.557H248.102V104.832H251.454C251.454 104.525 251.393 104.25 251.27 104.009C251.149 103.767 250.976 103.576 250.751 103.437C250.529 103.297 250.266 103.227 249.963 103.227C249.629 103.227 249.34 103.31 249.096 103.476C248.855 103.639 248.669 103.852 248.539 104.115C248.409 104.378 248.344 104.66 248.344 104.96V105.443C248.344 105.855 248.415 106.204 248.557 106.491C248.701 106.775 248.901 106.991 249.157 107.141C249.412 107.287 249.71 107.361 250.048 107.361C250.268 107.361 250.467 107.33 250.645 107.268C250.825 107.205 250.98 107.11 251.11 106.984C251.24 106.857 251.341 106.698 251.412 106.509L252.221 106.736C252.136 107.01 251.993 107.252 251.792 107.46C251.59 107.666 251.342 107.827 251.046 107.943C250.75 108.057 250.417 108.114 250.048 108.114Z" fill="#0000B3" />
																											<path d="M176.881 67V59.7273H179.338C179.906 59.7273 180.373 59.8243 180.737 60.0185C181.102 60.2102 181.372 60.4742 181.547 60.8104C181.722 61.1465 181.81 61.5289 181.81 61.9574C181.81 62.3859 181.722 62.7659 181.547 63.0973C181.372 63.4287 181.103 63.6892 180.741 63.8786C180.379 64.0656 179.916 64.1591 179.352 64.1591H177.364V63.3636H179.324C179.712 63.3636 180.025 63.3068 180.261 63.1932C180.5 63.0795 180.673 62.9186 180.78 62.7102C180.889 62.4995 180.943 62.2486 180.943 61.9574C180.943 61.6662 180.889 61.4117 180.78 61.1939C180.671 60.9761 180.497 60.808 180.258 60.6896C180.019 60.5689 179.703 60.5085 179.31 60.5085H177.761V67H176.881ZM180.304 63.733L182.094 67H181.071L179.31 63.733H180.304ZM186.601 64.7699V61.5455H187.439V67H186.601V66.0767H186.544C186.416 66.3537 186.218 66.5893 185.948 66.7834C185.678 66.9751 185.337 67.071 184.925 67.071C184.584 67.071 184.281 66.9964 184.016 66.8473C183.751 66.6958 183.542 66.4685 183.391 66.1655C183.239 65.8601 183.164 65.4754 183.164 65.0114V61.5455H184.002V64.9545C184.002 65.3523 184.113 65.6695 184.335 65.9062C184.56 66.143 184.847 66.2614 185.195 66.2614C185.403 66.2614 185.615 66.2081 185.83 66.1016C186.048 65.995 186.231 65.8317 186.377 65.6115C186.526 65.3913 186.601 65.1108 186.601 64.7699ZM189.812 63.7188V67H188.974V61.5455H189.784V62.3977H189.855C189.983 62.1207 190.177 61.8982 190.437 61.7301C190.698 61.5597 191.034 61.4744 191.446 61.4744C191.815 61.4744 192.138 61.5502 192.415 61.7017C192.692 61.8509 192.908 62.0781 193.061 62.3835C193.215 62.6866 193.292 63.0701 193.292 63.5341V67H192.454V63.5909C192.454 63.1624 192.343 62.8286 192.12 62.5895C191.898 62.348 191.592 62.2273 191.204 62.2273C190.937 62.2273 190.698 62.2853 190.487 62.4013C190.279 62.5173 190.114 62.6866 189.993 62.9091C189.873 63.1316 189.812 63.4015 189.812 63.7188Z" fill="#0000B3" />
																											<path d="M88.7098 8V0.727273H91.1672C91.7377 0.727273 92.2041 0.830255 92.5663 1.03622C92.9309 1.23982 93.2008 1.51562 93.376 1.86364C93.5512 2.21165 93.6388 2.59991 93.6388 3.02841C93.6388 3.45691 93.5512 3.84635 93.376 4.19673C93.2032 4.54711 92.9356 4.82647 92.5734 5.0348C92.2112 5.24077 91.7472 5.34375 91.1814 5.34375H89.42V4.5625H91.153C91.5436 4.5625 91.8573 4.49503 92.094 4.36009C92.3308 4.22514 92.5024 4.04285 92.6089 3.81321C92.7178 3.5812 92.7723 3.3196 92.7723 3.02841C92.7723 2.73722 92.7178 2.4768 92.6089 2.24716C92.5024 2.01752 92.3296 1.83759 92.0905 1.70739C91.8514 1.57481 91.5341 1.50852 91.1388 1.50852H89.5905V8H88.7098ZM95.7819 0.727273V8H94.9438V0.727273H95.7819ZM98.922 8.12784C98.5763 8.12784 98.2626 8.06274 97.9809 7.93253C97.6992 7.79995 97.4755 7.60938 97.3097 7.3608C97.144 7.10985 97.0612 6.80682 97.0612 6.4517C97.0612 6.1392 97.1227 5.88589 97.2458 5.69176C97.3689 5.49527 97.5335 5.34138 97.7394 5.23011C97.9454 5.11884 98.1727 5.03598 98.4213 4.98153C98.6722 4.92472 98.9243 4.87973 99.1776 4.84659C99.5091 4.80398 99.7778 4.77202 99.9838 4.75071C100.192 4.72704 100.344 4.68797 100.438 4.63352C100.535 4.57907 100.584 4.48437 100.584 4.34943V4.32102C100.584 3.97064 100.488 3.69839 100.296 3.50426C100.107 3.31013 99.8192 3.21307 99.4333 3.21307C99.0332 3.21307 98.7195 3.30066 98.4923 3.47585C98.265 3.65104 98.1052 3.83807 98.0129 4.03693L97.2174 3.75284C97.3595 3.4214 97.5489 3.16335 97.7856 2.97869C98.0247 2.79167 98.2851 2.66146 98.5669 2.58807C98.8509 2.51231 99.1303 2.47443 99.4049 2.47443C99.5801 2.47443 99.7813 2.49574 100.009 2.53835C100.238 2.5786 100.46 2.66264 100.673 2.79048C100.888 2.91832 101.067 3.11127 101.209 3.36932C101.351 3.62737 101.422 3.97301 101.422 4.40625V8H100.584V7.26136H100.541C100.484 7.37973 100.39 7.50639 100.257 7.64134C100.125 7.77628 99.9482 7.8911 99.7281 7.9858C99.5079 8.08049 99.2392 8.12784 98.922 8.12784ZM99.0498 7.375C99.3812 7.375 99.6606 7.3099 99.8879 7.17969C100.118 7.04948 100.29 6.88139 100.406 6.67543C100.525 6.46946 100.584 6.25284 100.584 6.02557V5.25852C100.548 5.30114 100.47 5.3402 100.35 5.37571C100.231 5.40885 100.094 5.43845 99.9376 5.46449C99.7837 5.48816 99.6334 5.50947 99.4866 5.52841C99.3422 5.54498 99.225 5.55919 99.135 5.57102C98.9172 5.59943 98.7136 5.6456 98.5242 5.70952C98.3372 5.77107 98.1857 5.86458 98.0697 5.99006C97.9561 6.11316 97.8992 6.28125 97.8992 6.49432C97.8992 6.78551 98.007 7.00568 98.2224 7.15483C98.4402 7.30161 98.716 7.375 99.0498 7.375ZM105.324 2.54545V3.25568H102.497V2.54545H105.324ZM103.321 1.23864H104.159V6.4375C104.159 6.67424 104.193 6.8518 104.262 6.97017C104.333 7.08617 104.423 7.1643 104.532 7.20455C104.643 7.24242 104.76 7.26136 104.883 7.26136C104.976 7.26136 105.052 7.25663 105.111 7.24716C105.17 7.23532 105.217 7.22585 105.253 7.21875L105.423 7.97159C105.366 7.9929 105.287 8.0142 105.185 8.03551C105.083 8.05919 104.954 8.07102 104.798 8.07102C104.561 8.07102 104.329 8.02012 104.102 7.91832C103.877 7.81652 103.69 7.66146 103.541 7.45312C103.394 7.24479 103.321 6.98201 103.321 6.66477V1.23864ZM109.013 2.54545V3.25568H106.073V2.54545H109.013ZM106.954 8V1.79261C106.954 1.48011 107.027 1.2197 107.174 1.01136C107.321 0.80303 107.511 0.64678 107.746 0.542613C107.98 0.438446 108.227 0.386363 108.488 0.386363C108.694 0.386363 108.862 0.402935 108.992 0.436079C109.122 0.469223 109.219 0.5 109.283 0.528409L109.042 1.25284C108.999 1.23864 108.94 1.22088 108.864 1.19957C108.791 1.17827 108.694 1.16761 108.573 1.16761C108.296 1.16761 108.096 1.23745 107.973 1.37713C107.852 1.51681 107.792 1.72159 107.792 1.99148V8H106.954ZM112.179 8.11364C111.687 8.11364 111.255 7.99645 110.883 7.76207C110.514 7.5277 110.225 7.19981 110.017 6.77841C109.811 6.35701 109.708 5.86458 109.708 5.30114C109.708 4.73295 109.811 4.23698 110.017 3.81321C110.225 3.38944 110.514 3.06037 110.883 2.82599C111.255 2.59162 111.687 2.47443 112.179 2.47443C112.672 2.47443 113.103 2.59162 113.472 2.82599C113.844 3.06037 114.132 3.38944 114.338 3.81321C114.547 4.23698 114.651 4.73295 114.651 5.30114C114.651 5.86458 114.547 6.35701 114.338 6.77841C114.132 7.19981 113.844 7.5277 113.472 7.76207C113.103 7.99645 112.672 8.11364 112.179 8.11364ZM112.179 7.3608C112.553 7.3608 112.861 7.26491 113.103 7.07315C113.344 6.88139 113.523 6.62926 113.639 6.31676C113.755 6.00426 113.813 5.66572 113.813 5.30114C113.813 4.93655 113.755 4.59683 113.639 4.28196C113.523 3.96709 113.344 3.71259 113.103 3.51847C112.861 3.32434 112.553 3.22727 112.179 3.22727C111.805 3.22727 111.497 3.32434 111.256 3.51847C111.014 3.71259 110.836 3.96709 110.72 4.28196C110.604 4.59683 110.546 4.93655 110.546 5.30114C110.546 5.66572 110.604 6.00426 110.72 6.31676C110.836 6.62926 111.014 6.88139 111.256 7.07315C111.497 7.26491 111.805 7.3608 112.179 7.3608ZM115.93 8V2.54545H116.74V3.36932H116.797C116.896 3.09943 117.076 2.88045 117.336 2.71236C117.597 2.54427 117.89 2.46023 118.217 2.46023C118.279 2.46023 118.356 2.46141 118.448 2.46378C118.54 2.46615 118.61 2.4697 118.657 2.47443V3.3267C118.629 3.3196 118.564 3.30895 118.462 3.29474C118.363 3.27817 118.257 3.26989 118.146 3.26989C117.881 3.26989 117.644 3.32552 117.436 3.43679C117.23 3.54569 117.066 3.69721 116.946 3.89134C116.827 4.0831 116.768 4.30208 116.768 4.5483V8H115.93ZM119.651 8V2.54545H120.46V3.39773H120.532C120.645 3.10653 120.829 2.88045 121.082 2.71946C121.335 2.55611 121.639 2.47443 121.995 2.47443C122.354 2.47443 122.654 2.55611 122.893 2.71946C123.134 2.88045 123.323 3.10653 123.458 3.39773H123.514C123.654 3.116 123.864 2.89228 124.143 2.72656C124.422 2.55848 124.757 2.47443 125.148 2.47443C125.636 2.47443 126.035 2.62713 126.345 2.93253C126.655 3.23556 126.81 3.70786 126.81 4.34943V8H125.972V4.34943C125.972 3.94697 125.862 3.65933 125.642 3.48651C125.421 3.31368 125.162 3.22727 124.864 3.22727C124.48 3.22727 124.183 3.34328 123.973 3.57528C123.762 3.80492 123.657 4.09612 123.657 4.44886V8H122.804V4.2642C122.804 3.95407 122.704 3.70431 122.502 3.51491C122.301 3.32315 122.042 3.22727 121.725 3.22727C121.507 3.22727 121.303 3.28527 121.114 3.40128C120.927 3.51728 120.775 3.67827 120.659 3.88423C120.546 4.08783 120.489 4.32339 120.489 4.59091V8H119.651ZM133.214 8.11364C132.76 8.11364 132.359 7.99882 132.011 7.76918C131.663 7.53717 131.39 7.21046 131.194 6.78906C130.997 6.36529 130.899 5.86458 130.899 5.28693C130.899 4.71402 130.997 4.21686 131.194 3.79545C131.39 3.37405 131.664 3.04853 132.014 2.81889C132.364 2.58925 132.769 2.47443 133.229 2.47443C133.584 2.47443 133.864 2.53362 134.07 2.65199C134.279 2.76799 134.437 2.90057 134.546 3.04972C134.657 3.1965 134.744 3.31723 134.805 3.41193H134.876V0.727273H135.714V8H134.905V7.16193H134.805C134.744 7.26136 134.656 7.38684 134.543 7.53835C134.429 7.6875 134.267 7.82126 134.056 7.93963C133.845 8.05563 133.565 8.11364 133.214 8.11364ZM133.328 7.3608C133.664 7.3608 133.948 7.2732 134.18 7.09801C134.412 6.92045 134.589 6.67543 134.709 6.36293C134.83 6.04806 134.891 5.68466 134.891 5.27273C134.891 4.86553 134.831 4.50923 134.713 4.20384C134.595 3.89607 134.419 3.65696 134.187 3.48651C133.955 3.31368 133.669 3.22727 133.328 3.22727C132.973 3.22727 132.677 3.31842 132.44 3.50071C132.206 3.68063 132.03 3.92566 131.911 4.2358C131.795 4.54356 131.737 4.8892 131.737 5.27273C131.737 5.66098 131.796 6.01373 131.915 6.33097C132.035 6.64583 132.213 6.89678 132.447 7.08381C132.684 7.26847 132.978 7.3608 133.328 7.3608ZM139.653 8.11364C139.127 8.11364 138.674 7.99763 138.293 7.76562C137.914 7.53125 137.621 7.20455 137.415 6.78551C137.212 6.36411 137.11 5.87405 137.11 5.31534C137.11 4.75663 137.212 4.2642 137.415 3.83807C137.621 3.40956 137.908 3.07576 138.275 2.83665C138.644 2.59517 139.075 2.47443 139.567 2.47443C139.851 2.47443 140.132 2.52178 140.409 2.61648C140.686 2.71117 140.938 2.86506 141.165 3.07812C141.393 3.28883 141.574 3.56818 141.709 3.91619C141.844 4.2642 141.911 4.69271 141.911 5.2017V5.55682H137.707V4.83239H141.059C141.059 4.52462 140.997 4.25 140.874 4.00852C140.753 3.76705 140.581 3.57647 140.356 3.43679C140.133 3.29711 139.87 3.22727 139.567 3.22727C139.234 3.22727 138.945 3.31013 138.701 3.47585C138.459 3.6392 138.274 3.85227 138.143 4.11506C138.013 4.37784 137.948 4.65956 137.948 4.96023V5.44318C137.948 5.85511 138.019 6.20431 138.161 6.49077C138.306 6.77486 138.506 6.99148 138.761 7.14062C139.017 7.28741 139.314 7.3608 139.653 7.3608C139.873 7.3608 140.072 7.33002 140.249 7.26847C140.429 7.20455 140.584 7.10985 140.714 6.98438C140.845 6.85653 140.945 6.69792 141.016 6.50852L141.826 6.7358C141.741 7.01042 141.597 7.25189 141.396 7.46023C141.195 7.66619 140.946 7.82718 140.65 7.94318C140.355 8.05682 140.022 8.11364 139.653 8.11364ZM143.186 10.0455V2.54545H143.996V3.41193H144.095C144.157 3.31723 144.242 3.1965 144.351 3.04972C144.462 2.90057 144.621 2.76799 144.827 2.65199C145.035 2.53362 145.317 2.47443 145.672 2.47443C146.131 2.47443 146.536 2.58925 146.886 2.81889C147.237 3.04853 147.51 3.37405 147.707 3.79545C147.903 4.21686 148.001 4.71402 148.001 5.28693C148.001 5.86458 147.903 6.36529 147.707 6.78906C147.51 7.21046 147.238 7.53717 146.89 7.76918C146.542 7.99882 146.141 8.11364 145.686 8.11364C145.336 8.11364 145.055 8.05563 144.844 7.93963C144.634 7.82126 144.472 7.6875 144.358 7.53835C144.244 7.38684 144.157 7.26136 144.095 7.16193H144.024V10.0455H143.186ZM144.01 5.27273C144.01 5.68466 144.07 6.04806 144.191 6.36293C144.312 6.67543 144.488 6.92045 144.72 7.09801C144.952 7.2732 145.236 7.3608 145.572 7.3608C145.923 7.3608 146.215 7.26847 146.449 7.08381C146.686 6.89678 146.864 6.64583 146.982 6.33097C147.103 6.01373 147.163 5.66098 147.163 5.27273C147.163 4.8892 147.104 4.54356 146.986 4.2358C146.87 3.92566 146.693 3.68063 146.457 3.50071C146.222 3.31842 145.927 3.22727 145.572 3.22727C145.231 3.22727 144.945 3.31368 144.713 3.48651C144.481 3.65696 144.306 3.89607 144.187 4.20384C144.069 4.50923 144.01 4.86553 144.01 5.27273ZM151.652 2.54545V3.25568H148.825V2.54545H151.652ZM149.649 1.23864H150.487V6.4375C150.487 6.67424 150.521 6.8518 150.59 6.97017C150.661 7.08617 150.751 7.1643 150.86 7.20455C150.971 7.24242 151.088 7.26136 151.212 7.26136C151.304 7.26136 151.38 7.25663 151.439 7.24716C151.498 7.23532 151.545 7.22585 151.581 7.21875L151.751 7.97159C151.695 7.9929 151.615 8.0142 151.513 8.03551C151.412 8.05919 151.283 8.07102 151.126 8.07102C150.89 8.07102 150.658 8.02012 150.43 7.91832C150.205 7.81652 150.018 7.66146 149.869 7.45312C149.722 7.24479 149.649 6.98201 149.649 6.66477V1.23864ZM153.868 4.71875V8H153.03V0.727273H153.868V3.39773H153.939C154.067 3.116 154.258 2.89228 154.514 2.72656C154.772 2.55848 155.115 2.47443 155.544 2.47443C155.916 2.47443 156.241 2.54901 156.521 2.69815C156.8 2.84493 157.016 3.07102 157.17 3.37642C157.327 3.67945 157.405 4.06534 157.405 4.53409V8H156.567V4.59091C156.567 4.15767 156.454 3.82268 156.229 3.58594C156.007 3.34683 155.698 3.22727 155.302 3.22727C155.028 3.22727 154.782 3.28527 154.564 3.40128C154.348 3.51728 154.178 3.68655 154.052 3.90909C153.929 4.13163 153.868 4.40152 153.868 4.71875Z" fill="#0000B3" />
																										</svg>
																										<label className='square-1-selected-label col-12 p-1'>{images[5].label}</label>
																									</div>
																								) :
																								(
																									<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(5, indexShape)}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="90" height="60" viewBox="0 0 310 310" fill="none">
																											<line x1="3.67224" y1="155.012" x2="2.49996" y2="305.007" stroke="#0000B3" stroke-width="3" />
																											<line x1="211" y1="306.5" x2="1" y2="306.5" stroke="#0000B3" stroke-width="3" />
																											<path d="M72 155L2 155" stroke="#0000B3" stroke-width="3" />
																											<line x1="141" y1="206.5" x2="71" y2="206.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="211" y1="255.5" x2="141" y2="255.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="294" y1="131.5" x2="224" y2="131.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="225" y1="81.5001" x2="155" y2="81.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="156" y1="30.5001" x2="86" y2="30.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="70.5" y1="205" x2="70.5" y2="155" stroke="#0000B3" stroke-width="3" />
																											<path d="M141 255V205" stroke="#0000B3" stroke-width="3" />
																											<line x1="209.5" y1="305" x2="209.5" y2="255" stroke="#0000B3" stroke-width="3" />
																											<line x1="223.5" y1="130" x2="223.5" y2="80" stroke="#0000B3" stroke-width="3" />
																											<line x1="236" y1="129.5" x2="226" y2="129.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="236" y1="82.5" x2="226" y2="82.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="229.5" y1="128" x2="229.5" y2="81" stroke="#0000B3" stroke-width="3" />
																											<line x1="225.5" y1="67" x2="225.5" y2="77" stroke="#0000B3" stroke-width="3" />
																											<line x1="158.5" y1="67" x2="158.5" y2="77" stroke="#0000B3" stroke-width="3" />
																											<line x1="224" y1="73.5" x2="157" y2="73.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="156.5" y1="13" x2="156.5" y2="23" stroke="#0000B3" stroke-width="3" />
																											<line x1="89.5" y1="13" x2="89.5" y2="23" stroke="#0000B3" stroke-width="3" />
																											<line x1="155" y1="19.5" x2="88" y2="19.5" stroke="#0000B3" stroke-width="3" />
																											<line x1="154.5" y1="80" x2="154.5" y2="30" stroke="#0000B3" stroke-width="3" />
																											<line x1="1.75328" y1="153.838" x2="85.1608" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																											<line x1="70.7533" y1="153.838" x2="154.161" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																											<line x1="70.7533" y1="204.838" x2="154.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																											<line x1="139.753" y1="204.838" x2="223.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																											<line x1="140.753" y1="253.838" x2="224.161" y2="129.166" stroke="#0000B3" stroke-width="3" />
																											<line x1="225.5" y1="302" x2="225.5" y2="312" stroke="#0000B3" stroke-width="3" />
																											<line x1="307.5" y1="189" x2="307.5" y2="179" stroke="#0000B3" stroke-width="3" />
																											<line x1="293.5" y1="180" x2="293.5" y2="130" stroke="#0000B3" stroke-width="3" />
																											<line x1="209.753" y1="254.838" x2="293.161" y2="130.166" stroke="#0000B3" stroke-width="3" />
																											<line x1="209.757" y1="304.161" x2="294.164" y2="179.161" stroke="#0000B3" stroke-width="3" />
																											<line x1="223.757" y1="307.161" x2="308.164" y2="182.161" stroke="#0000B3" stroke-width="3" />
																											<path d="M269.202 258L267.213 250.727H268.108L269.628 256.651H269.699L271.247 250.727H272.241L273.79 256.651H273.861L275.381 250.727H276.276L274.287 258H273.378L271.773 252.205H271.716L270.111 258H269.202ZM277.259 258V252.545H278.097V258H277.259ZM277.685 251.636C277.522 251.636 277.381 251.581 277.263 251.469C277.147 251.358 277.089 251.224 277.089 251.068C277.089 250.912 277.147 250.778 277.263 250.667C277.381 250.556 277.522 250.5 277.685 250.5C277.849 250.5 277.988 250.556 278.104 250.667C278.223 250.778 278.282 250.912 278.282 251.068C278.282 251.224 278.223 251.358 278.104 251.469C277.988 251.581 277.849 251.636 277.685 251.636ZM281.692 258.114C281.237 258.114 280.836 257.999 280.488 257.769C280.14 257.537 279.868 257.21 279.671 256.789C279.475 256.365 279.377 255.865 279.377 255.287C279.377 254.714 279.475 254.217 279.671 253.795C279.868 253.374 280.141 253.049 280.492 252.819C280.842 252.589 281.247 252.474 281.706 252.474C282.061 252.474 282.342 252.534 282.548 252.652C282.756 252.768 282.915 252.901 283.024 253.05C283.135 253.196 283.221 253.317 283.283 253.412H283.354V250.727H284.192V258H283.382V257.162H283.283C283.221 257.261 283.134 257.387 283.02 257.538C282.906 257.687 282.744 257.821 282.534 257.94C282.323 258.056 282.042 258.114 281.692 258.114ZM281.806 257.361C282.142 257.361 282.426 257.273 282.658 257.098C282.89 256.92 283.066 256.675 283.187 256.363C283.308 256.048 283.368 255.685 283.368 255.273C283.368 254.866 283.309 254.509 283.191 254.204C283.072 253.896 282.897 253.657 282.665 253.487C282.433 253.314 282.146 253.227 281.806 253.227C281.45 253.227 281.155 253.318 280.918 253.501C280.683 253.681 280.507 253.926 280.389 254.236C280.273 254.544 280.215 254.889 280.215 255.273C280.215 255.661 280.274 256.014 280.392 256.331C280.513 256.646 280.691 256.897 280.925 257.084C281.162 257.268 281.455 257.361 281.806 257.361ZM288.215 252.545V253.256H285.389V252.545H288.215ZM286.213 251.239H287.051V256.438C287.051 256.674 287.085 256.852 287.154 256.97C287.225 257.086 287.315 257.164 287.423 257.205C287.535 257.242 287.652 257.261 287.775 257.261C287.867 257.261 287.943 257.257 288.002 257.247C288.061 257.235 288.109 257.226 288.144 257.219L288.315 257.972C288.258 257.993 288.179 258.014 288.077 258.036C287.975 258.059 287.846 258.071 287.69 258.071C287.453 258.071 287.221 258.02 286.994 257.918C286.769 257.817 286.582 257.661 286.433 257.453C286.286 257.245 286.213 256.982 286.213 256.665V251.239ZM290.431 254.719V258H289.593V250.727H290.431V253.398H290.502C290.63 253.116 290.822 252.892 291.078 252.727C291.336 252.558 291.679 252.474 292.107 252.474C292.479 252.474 292.805 252.549 293.084 252.698C293.363 252.845 293.58 253.071 293.734 253.376C293.89 253.679 293.968 254.065 293.968 254.534V258H293.13V254.591C293.13 254.158 293.018 253.823 292.793 253.586C292.57 253.347 292.261 253.227 291.866 253.227C291.591 253.227 291.345 253.285 291.127 253.401C290.912 253.517 290.741 253.687 290.616 253.909C290.493 254.132 290.431 254.402 290.431 254.719Z" fill="#0000B3" />
																											<path d="M233.881 108V100.727H236.338C236.906 100.727 237.373 100.824 237.737 101.018C238.102 101.21 238.372 101.474 238.547 101.81C238.722 102.147 238.81 102.529 238.81 102.957C238.81 103.386 238.722 103.766 238.547 104.097C238.372 104.429 238.103 104.689 237.741 104.879C237.379 105.066 236.916 105.159 236.352 105.159H234.364V104.364H236.324C236.712 104.364 237.025 104.307 237.261 104.193C237.5 104.08 237.673 103.919 237.78 103.71C237.889 103.5 237.943 103.249 237.943 102.957C237.943 102.666 237.889 102.412 237.78 102.194C237.671 101.976 237.497 101.808 237.258 101.69C237.019 101.569 236.703 101.509 236.31 101.509H234.761V108H233.881ZM237.304 104.733L239.094 108H238.071L236.31 104.733H237.304ZM240.164 108V102.545H241.002V108H240.164ZM240.59 101.636C240.426 101.636 240.285 101.581 240.167 101.469C240.051 101.358 239.993 101.224 239.993 101.068C239.993 100.912 240.051 100.778 240.167 100.667C240.285 100.556 240.426 100.5 240.59 100.5C240.753 100.5 240.893 100.556 241.009 100.667C241.127 100.778 241.186 100.912 241.186 101.068C241.186 101.224 241.127 101.358 241.009 101.469C240.893 101.581 240.753 101.636 240.59 101.636ZM246.4 103.767L245.647 103.98C245.6 103.855 245.53 103.733 245.438 103.614C245.348 103.494 245.225 103.394 245.069 103.316C244.912 103.238 244.712 103.199 244.468 103.199C244.135 103.199 243.856 103.276 243.634 103.43C243.414 103.581 243.304 103.774 243.304 104.009C243.304 104.217 243.379 104.381 243.531 104.502C243.682 104.623 243.919 104.723 244.241 104.804L245.051 105.003C245.538 105.121 245.902 105.302 246.141 105.546C246.38 105.788 246.5 106.099 246.5 106.48C246.5 106.793 246.41 107.072 246.23 107.318C246.052 107.564 245.804 107.759 245.484 107.901C245.164 108.043 244.793 108.114 244.369 108.114C243.813 108.114 243.352 107.993 242.988 107.751C242.623 107.51 242.392 107.157 242.295 106.693L243.091 106.494C243.166 106.788 243.31 107.008 243.52 107.155C243.733 107.302 244.011 107.375 244.355 107.375C244.745 107.375 245.056 107.292 245.285 107.126C245.517 106.958 245.633 106.757 245.633 106.523C245.633 106.333 245.567 106.175 245.434 106.047C245.302 105.917 245.098 105.82 244.824 105.756L243.914 105.543C243.415 105.424 243.048 105.241 242.814 104.992C242.582 104.741 242.466 104.428 242.466 104.051C242.466 103.743 242.552 103.471 242.725 103.234C242.9 102.998 243.138 102.812 243.439 102.677C243.742 102.542 244.085 102.474 244.468 102.474C245.008 102.474 245.432 102.593 245.74 102.83C246.05 103.066 246.27 103.379 246.4 103.767ZM250.048 108.114C249.523 108.114 249.069 107.998 248.688 107.766C248.309 107.531 248.017 107.205 247.811 106.786C247.607 106.364 247.506 105.874 247.506 105.315C247.506 104.757 247.607 104.264 247.811 103.838C248.017 103.41 248.303 103.076 248.67 102.837C249.04 102.595 249.47 102.474 249.963 102.474C250.247 102.474 250.528 102.522 250.805 102.616C251.081 102.711 251.334 102.865 251.561 103.078C251.788 103.289 251.969 103.568 252.104 103.916C252.239 104.264 252.307 104.693 252.307 105.202V105.557H248.102V104.832H251.454C251.454 104.525 251.393 104.25 251.27 104.009C251.149 103.767 250.976 103.576 250.751 103.437C250.529 103.297 250.266 103.227 249.963 103.227C249.629 103.227 249.34 103.31 249.096 103.476C248.855 103.639 248.669 103.852 248.539 104.115C248.409 104.378 248.344 104.66 248.344 104.96V105.443C248.344 105.855 248.415 106.204 248.557 106.491C248.701 106.775 248.901 106.991 249.157 107.141C249.412 107.287 249.71 107.361 250.048 107.361C250.268 107.361 250.467 107.33 250.645 107.268C250.825 107.205 250.98 107.11 251.11 106.984C251.24 106.857 251.341 106.698 251.412 106.509L252.221 106.736C252.136 107.01 251.993 107.252 251.792 107.46C251.59 107.666 251.342 107.827 251.046 107.943C250.75 108.057 250.417 108.114 250.048 108.114Z" fill="#0000B3" />
																											<path d="M176.881 67V59.7273H179.338C179.906 59.7273 180.373 59.8243 180.737 60.0185C181.102 60.2102 181.372 60.4742 181.547 60.8104C181.722 61.1465 181.81 61.5289 181.81 61.9574C181.81 62.3859 181.722 62.7659 181.547 63.0973C181.372 63.4287 181.103 63.6892 180.741 63.8786C180.379 64.0656 179.916 64.1591 179.352 64.1591H177.364V63.3636H179.324C179.712 63.3636 180.025 63.3068 180.261 63.1932C180.5 63.0795 180.673 62.9186 180.78 62.7102C180.889 62.4995 180.943 62.2486 180.943 61.9574C180.943 61.6662 180.889 61.4117 180.78 61.1939C180.671 60.9761 180.497 60.808 180.258 60.6896C180.019 60.5689 179.703 60.5085 179.31 60.5085H177.761V67H176.881ZM180.304 63.733L182.094 67H181.071L179.31 63.733H180.304ZM186.601 64.7699V61.5455H187.439V67H186.601V66.0767H186.544C186.416 66.3537 186.218 66.5893 185.948 66.7834C185.678 66.9751 185.337 67.071 184.925 67.071C184.584 67.071 184.281 66.9964 184.016 66.8473C183.751 66.6958 183.542 66.4685 183.391 66.1655C183.239 65.8601 183.164 65.4754 183.164 65.0114V61.5455H184.002V64.9545C184.002 65.3523 184.113 65.6695 184.335 65.9062C184.56 66.143 184.847 66.2614 185.195 66.2614C185.403 66.2614 185.615 66.2081 185.83 66.1016C186.048 65.995 186.231 65.8317 186.377 65.6115C186.526 65.3913 186.601 65.1108 186.601 64.7699ZM189.812 63.7188V67H188.974V61.5455H189.784V62.3977H189.855C189.983 62.1207 190.177 61.8982 190.437 61.7301C190.698 61.5597 191.034 61.4744 191.446 61.4744C191.815 61.4744 192.138 61.5502 192.415 61.7017C192.692 61.8509 192.908 62.0781 193.061 62.3835C193.215 62.6866 193.292 63.0701 193.292 63.5341V67H192.454V63.5909C192.454 63.1624 192.343 62.8286 192.12 62.5895C191.898 62.348 191.592 62.2273 191.204 62.2273C190.937 62.2273 190.698 62.2853 190.487 62.4013C190.279 62.5173 190.114 62.6866 189.993 62.9091C189.873 63.1316 189.812 63.4015 189.812 63.7188Z" fill="#0000B3" />
																											<path d="M88.7098 8V0.727273H91.1672C91.7377 0.727273 92.2041 0.830255 92.5663 1.03622C92.9309 1.23982 93.2008 1.51562 93.376 1.86364C93.5512 2.21165 93.6388 2.59991 93.6388 3.02841C93.6388 3.45691 93.5512 3.84635 93.376 4.19673C93.2032 4.54711 92.9356 4.82647 92.5734 5.0348C92.2112 5.24077 91.7472 5.34375 91.1814 5.34375H89.42V4.5625H91.153C91.5436 4.5625 91.8573 4.49503 92.094 4.36009C92.3308 4.22514 92.5024 4.04285 92.6089 3.81321C92.7178 3.5812 92.7723 3.3196 92.7723 3.02841C92.7723 2.73722 92.7178 2.4768 92.6089 2.24716C92.5024 2.01752 92.3296 1.83759 92.0905 1.70739C91.8514 1.57481 91.5341 1.50852 91.1388 1.50852H89.5905V8H88.7098ZM95.7819 0.727273V8H94.9438V0.727273H95.7819ZM98.922 8.12784C98.5763 8.12784 98.2626 8.06274 97.9809 7.93253C97.6992 7.79995 97.4755 7.60938 97.3097 7.3608C97.144 7.10985 97.0612 6.80682 97.0612 6.4517C97.0612 6.1392 97.1227 5.88589 97.2458 5.69176C97.3689 5.49527 97.5335 5.34138 97.7394 5.23011C97.9454 5.11884 98.1727 5.03598 98.4213 4.98153C98.6722 4.92472 98.9243 4.87973 99.1776 4.84659C99.5091 4.80398 99.7778 4.77202 99.9838 4.75071C100.192 4.72704 100.344 4.68797 100.438 4.63352C100.535 4.57907 100.584 4.48437 100.584 4.34943V4.32102C100.584 3.97064 100.488 3.69839 100.296 3.50426C100.107 3.31013 99.8192 3.21307 99.4333 3.21307C99.0332 3.21307 98.7195 3.30066 98.4923 3.47585C98.265 3.65104 98.1052 3.83807 98.0129 4.03693L97.2174 3.75284C97.3595 3.4214 97.5489 3.16335 97.7856 2.97869C98.0247 2.79167 98.2851 2.66146 98.5669 2.58807C98.8509 2.51231 99.1303 2.47443 99.4049 2.47443C99.5801 2.47443 99.7813 2.49574 100.009 2.53835C100.238 2.5786 100.46 2.66264 100.673 2.79048C100.888 2.91832 101.067 3.11127 101.209 3.36932C101.351 3.62737 101.422 3.97301 101.422 4.40625V8H100.584V7.26136H100.541C100.484 7.37973 100.39 7.50639 100.257 7.64134C100.125 7.77628 99.9482 7.8911 99.7281 7.9858C99.5079 8.08049 99.2392 8.12784 98.922 8.12784ZM99.0498 7.375C99.3812 7.375 99.6606 7.3099 99.8879 7.17969C100.118 7.04948 100.29 6.88139 100.406 6.67543C100.525 6.46946 100.584 6.25284 100.584 6.02557V5.25852C100.548 5.30114 100.47 5.3402 100.35 5.37571C100.231 5.40885 100.094 5.43845 99.9376 5.46449C99.7837 5.48816 99.6334 5.50947 99.4866 5.52841C99.3422 5.54498 99.225 5.55919 99.135 5.57102C98.9172 5.59943 98.7136 5.6456 98.5242 5.70952C98.3372 5.77107 98.1857 5.86458 98.0697 5.99006C97.9561 6.11316 97.8992 6.28125 97.8992 6.49432C97.8992 6.78551 98.007 7.00568 98.2224 7.15483C98.4402 7.30161 98.716 7.375 99.0498 7.375ZM105.324 2.54545V3.25568H102.497V2.54545H105.324ZM103.321 1.23864H104.159V6.4375C104.159 6.67424 104.193 6.8518 104.262 6.97017C104.333 7.08617 104.423 7.1643 104.532 7.20455C104.643 7.24242 104.76 7.26136 104.883 7.26136C104.976 7.26136 105.052 7.25663 105.111 7.24716C105.17 7.23532 105.217 7.22585 105.253 7.21875L105.423 7.97159C105.366 7.9929 105.287 8.0142 105.185 8.03551C105.083 8.05919 104.954 8.07102 104.798 8.07102C104.561 8.07102 104.329 8.02012 104.102 7.91832C103.877 7.81652 103.69 7.66146 103.541 7.45312C103.394 7.24479 103.321 6.98201 103.321 6.66477V1.23864ZM109.013 2.54545V3.25568H106.073V2.54545H109.013ZM106.954 8V1.79261C106.954 1.48011 107.027 1.2197 107.174 1.01136C107.321 0.80303 107.511 0.64678 107.746 0.542613C107.98 0.438446 108.227 0.386363 108.488 0.386363C108.694 0.386363 108.862 0.402935 108.992 0.436079C109.122 0.469223 109.219 0.5 109.283 0.528409L109.042 1.25284C108.999 1.23864 108.94 1.22088 108.864 1.19957C108.791 1.17827 108.694 1.16761 108.573 1.16761C108.296 1.16761 108.096 1.23745 107.973 1.37713C107.852 1.51681 107.792 1.72159 107.792 1.99148V8H106.954ZM112.179 8.11364C111.687 8.11364 111.255 7.99645 110.883 7.76207C110.514 7.5277 110.225 7.19981 110.017 6.77841C109.811 6.35701 109.708 5.86458 109.708 5.30114C109.708 4.73295 109.811 4.23698 110.017 3.81321C110.225 3.38944 110.514 3.06037 110.883 2.82599C111.255 2.59162 111.687 2.47443 112.179 2.47443C112.672 2.47443 113.103 2.59162 113.472 2.82599C113.844 3.06037 114.132 3.38944 114.338 3.81321C114.547 4.23698 114.651 4.73295 114.651 5.30114C114.651 5.86458 114.547 6.35701 114.338 6.77841C114.132 7.19981 113.844 7.5277 113.472 7.76207C113.103 7.99645 112.672 8.11364 112.179 8.11364ZM112.179 7.3608C112.553 7.3608 112.861 7.26491 113.103 7.07315C113.344 6.88139 113.523 6.62926 113.639 6.31676C113.755 6.00426 113.813 5.66572 113.813 5.30114C113.813 4.93655 113.755 4.59683 113.639 4.28196C113.523 3.96709 113.344 3.71259 113.103 3.51847C112.861 3.32434 112.553 3.22727 112.179 3.22727C111.805 3.22727 111.497 3.32434 111.256 3.51847C111.014 3.71259 110.836 3.96709 110.72 4.28196C110.604 4.59683 110.546 4.93655 110.546 5.30114C110.546 5.66572 110.604 6.00426 110.72 6.31676C110.836 6.62926 111.014 6.88139 111.256 7.07315C111.497 7.26491 111.805 7.3608 112.179 7.3608ZM115.93 8V2.54545H116.74V3.36932H116.797C116.896 3.09943 117.076 2.88045 117.336 2.71236C117.597 2.54427 117.89 2.46023 118.217 2.46023C118.279 2.46023 118.356 2.46141 118.448 2.46378C118.54 2.46615 118.61 2.4697 118.657 2.47443V3.3267C118.629 3.3196 118.564 3.30895 118.462 3.29474C118.363 3.27817 118.257 3.26989 118.146 3.26989C117.881 3.26989 117.644 3.32552 117.436 3.43679C117.23 3.54569 117.066 3.69721 116.946 3.89134C116.827 4.0831 116.768 4.30208 116.768 4.5483V8H115.93ZM119.651 8V2.54545H120.46V3.39773H120.532C120.645 3.10653 120.829 2.88045 121.082 2.71946C121.335 2.55611 121.639 2.47443 121.995 2.47443C122.354 2.47443 122.654 2.55611 122.893 2.71946C123.134 2.88045 123.323 3.10653 123.458 3.39773H123.514C123.654 3.116 123.864 2.89228 124.143 2.72656C124.422 2.55848 124.757 2.47443 125.148 2.47443C125.636 2.47443 126.035 2.62713 126.345 2.93253C126.655 3.23556 126.81 3.70786 126.81 4.34943V8H125.972V4.34943C125.972 3.94697 125.862 3.65933 125.642 3.48651C125.421 3.31368 125.162 3.22727 124.864 3.22727C124.48 3.22727 124.183 3.34328 123.973 3.57528C123.762 3.80492 123.657 4.09612 123.657 4.44886V8H122.804V4.2642C122.804 3.95407 122.704 3.70431 122.502 3.51491C122.301 3.32315 122.042 3.22727 121.725 3.22727C121.507 3.22727 121.303 3.28527 121.114 3.40128C120.927 3.51728 120.775 3.67827 120.659 3.88423C120.546 4.08783 120.489 4.32339 120.489 4.59091V8H119.651ZM133.214 8.11364C132.76 8.11364 132.359 7.99882 132.011 7.76918C131.663 7.53717 131.39 7.21046 131.194 6.78906C130.997 6.36529 130.899 5.86458 130.899 5.28693C130.899 4.71402 130.997 4.21686 131.194 3.79545C131.39 3.37405 131.664 3.04853 132.014 2.81889C132.364 2.58925 132.769 2.47443 133.229 2.47443C133.584 2.47443 133.864 2.53362 134.07 2.65199C134.279 2.76799 134.437 2.90057 134.546 3.04972C134.657 3.1965 134.744 3.31723 134.805 3.41193H134.876V0.727273H135.714V8H134.905V7.16193H134.805C134.744 7.26136 134.656 7.38684 134.543 7.53835C134.429 7.6875 134.267 7.82126 134.056 7.93963C133.845 8.05563 133.565 8.11364 133.214 8.11364ZM133.328 7.3608C133.664 7.3608 133.948 7.2732 134.18 7.09801C134.412 6.92045 134.589 6.67543 134.709 6.36293C134.83 6.04806 134.891 5.68466 134.891 5.27273C134.891 4.86553 134.831 4.50923 134.713 4.20384C134.595 3.89607 134.419 3.65696 134.187 3.48651C133.955 3.31368 133.669 3.22727 133.328 3.22727C132.973 3.22727 132.677 3.31842 132.44 3.50071C132.206 3.68063 132.03 3.92566 131.911 4.2358C131.795 4.54356 131.737 4.8892 131.737 5.27273C131.737 5.66098 131.796 6.01373 131.915 6.33097C132.035 6.64583 132.213 6.89678 132.447 7.08381C132.684 7.26847 132.978 7.3608 133.328 7.3608ZM139.653 8.11364C139.127 8.11364 138.674 7.99763 138.293 7.76562C137.914 7.53125 137.621 7.20455 137.415 6.78551C137.212 6.36411 137.11 5.87405 137.11 5.31534C137.11 4.75663 137.212 4.2642 137.415 3.83807C137.621 3.40956 137.908 3.07576 138.275 2.83665C138.644 2.59517 139.075 2.47443 139.567 2.47443C139.851 2.47443 140.132 2.52178 140.409 2.61648C140.686 2.71117 140.938 2.86506 141.165 3.07812C141.393 3.28883 141.574 3.56818 141.709 3.91619C141.844 4.2642 141.911 4.69271 141.911 5.2017V5.55682H137.707V4.83239H141.059C141.059 4.52462 140.997 4.25 140.874 4.00852C140.753 3.76705 140.581 3.57647 140.356 3.43679C140.133 3.29711 139.87 3.22727 139.567 3.22727C139.234 3.22727 138.945 3.31013 138.701 3.47585C138.459 3.6392 138.274 3.85227 138.143 4.11506C138.013 4.37784 137.948 4.65956 137.948 4.96023V5.44318C137.948 5.85511 138.019 6.20431 138.161 6.49077C138.306 6.77486 138.506 6.99148 138.761 7.14062C139.017 7.28741 139.314 7.3608 139.653 7.3608C139.873 7.3608 140.072 7.33002 140.249 7.26847C140.429 7.20455 140.584 7.10985 140.714 6.98438C140.845 6.85653 140.945 6.69792 141.016 6.50852L141.826 6.7358C141.741 7.01042 141.597 7.25189 141.396 7.46023C141.195 7.66619 140.946 7.82718 140.65 7.94318C140.355 8.05682 140.022 8.11364 139.653 8.11364ZM143.186 10.0455V2.54545H143.996V3.41193H144.095C144.157 3.31723 144.242 3.1965 144.351 3.04972C144.462 2.90057 144.621 2.76799 144.827 2.65199C145.035 2.53362 145.317 2.47443 145.672 2.47443C146.131 2.47443 146.536 2.58925 146.886 2.81889C147.237 3.04853 147.51 3.37405 147.707 3.79545C147.903 4.21686 148.001 4.71402 148.001 5.28693C148.001 5.86458 147.903 6.36529 147.707 6.78906C147.51 7.21046 147.238 7.53717 146.89 7.76918C146.542 7.99882 146.141 8.11364 145.686 8.11364C145.336 8.11364 145.055 8.05563 144.844 7.93963C144.634 7.82126 144.472 7.6875 144.358 7.53835C144.244 7.38684 144.157 7.26136 144.095 7.16193H144.024V10.0455H143.186ZM144.01 5.27273C144.01 5.68466 144.07 6.04806 144.191 6.36293C144.312 6.67543 144.488 6.92045 144.72 7.09801C144.952 7.2732 145.236 7.3608 145.572 7.3608C145.923 7.3608 146.215 7.26847 146.449 7.08381C146.686 6.89678 146.864 6.64583 146.982 6.33097C147.103 6.01373 147.163 5.66098 147.163 5.27273C147.163 4.8892 147.104 4.54356 146.986 4.2358C146.87 3.92566 146.693 3.68063 146.457 3.50071C146.222 3.31842 145.927 3.22727 145.572 3.22727C145.231 3.22727 144.945 3.31368 144.713 3.48651C144.481 3.65696 144.306 3.89607 144.187 4.20384C144.069 4.50923 144.01 4.86553 144.01 5.27273ZM151.652 2.54545V3.25568H148.825V2.54545H151.652ZM149.649 1.23864H150.487V6.4375C150.487 6.67424 150.521 6.8518 150.59 6.97017C150.661 7.08617 150.751 7.1643 150.86 7.20455C150.971 7.24242 151.088 7.26136 151.212 7.26136C151.304 7.26136 151.38 7.25663 151.439 7.24716C151.498 7.23532 151.545 7.22585 151.581 7.21875L151.751 7.97159C151.695 7.9929 151.615 8.0142 151.513 8.03551C151.412 8.05919 151.283 8.07102 151.126 8.07102C150.89 8.07102 150.658 8.02012 150.43 7.91832C150.205 7.81652 150.018 7.66146 149.869 7.45312C149.722 7.24479 149.649 6.98201 149.649 6.66477V1.23864ZM153.868 4.71875V8H153.03V0.727273H153.868V3.39773H153.939C154.067 3.116 154.258 2.89228 154.514 2.72656C154.772 2.55848 155.115 2.47443 155.544 2.47443C155.916 2.47443 156.241 2.54901 156.521 2.69815C156.8 2.84493 157.016 3.07102 157.17 3.37642C157.327 3.67945 157.405 4.06534 157.405 4.53409V8H156.567V4.59091C156.567 4.15767 156.454 3.82268 156.229 3.58594C156.007 3.34683 155.698 3.22727 155.302 3.22727C155.028 3.22727 154.782 3.28527 154.564 3.40128C154.348 3.51728 154.178 3.68655 154.052 3.90909C153.929 4.13163 153.868 4.40152 153.868 4.71875Z" fill="#0000B3" />
																										</svg>
																										<label className='square-1-label col-12 p-1'>{images[5].label}</label>
																									</div>
																								)
																						}
																					</div>

																					{/* <div className="col-12 m-0 p-0 align-items-start justify-content-start"> */}

																					<div className="row">
																						{
																							shapeVol.selectedImage == 0 ? (
																								<div className="col-12 m-0 p-0 align-items-center justify-content-start">
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Length')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="length"
																												value={shapeVol.length == 0 ? '' : shapeVol.length}
																												onChange={(e) => { setLengthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.lengthUnit, label: shapeVol.lengthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setLengthUnitArray(e.value, indexShape) }}
																											/>

																											{/* <select styles={{ dropdownIndicator: dropdownIndicatorStyles }}
																															className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setLengthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.lengthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Width')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="width"
																												value={shapeVol.width == 0 ? '' : shapeVol.width}
																												placeholder=''
																												onChange={(e) => { setWidthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.widthUnit, label: shapeVol.widthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setWidthUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setWidthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.widthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="height"
																												value={shapeVol.height == 0 ? '' : shapeVol.height}
																												placeholder=''
																												onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.heightUnit, label: shapeVol.heightUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setheightUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.heightUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																						{
																							shapeVol.selectedImage == 1 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="height"
																												value={shapeVol.height == 0 ? '' : shapeVol.height}
																												onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.heightUnit, label: shapeVol.heightUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setheightUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.heightUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Diameter')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="diameter"
																												value={shapeVol.diameter == 0 ? '' : shapeVol.diameter}
																												onChange={(e) => { setDiameterArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.diameterUnit, label: shapeVol.diameterUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setDiameterUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setDiameterUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.diameterUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																						{
																							shapeVol.selectedImage == 2 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Outer_diameter')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="outerDiameter"
																												value={shapeVol.outerDiameter == 0 ? '' : shapeVol.outerDiameter}
																												onChange={(e) => { setOuterDiameterArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.outerDiameterUnit, label: shapeVol.outerDiameterUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setOuterDiameterUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setOuterDiameterUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.outerDiameterUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Inner_diameter')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="innerDiameter"
																												value={shapeVol.innerDiameter == 0 ? '' : shapeVol.innerDiameter}
																												onChange={(e) => { setInnerDiameterArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.innerDiameterUnit, label: shapeVol.innerDiameterUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setInnerDiameterUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setInnerDiameterUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.innerDiameterUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="height"
																												value={shapeVol.height == 0 ? '' : shapeVol.height}
																												onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.heightUnit, label: shapeVol.heightUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setheightUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.heightUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																						{
																							shapeVol.selectedImage == 3 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Width')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="width"
																												value={shapeVol.width == 0 ? '' : shapeVol.width}
																												onChange={(e) => { setWidthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.widthUnit, label: shapeVol.widthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setWidthUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setWidthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.widthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Length')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="length"
																												value={shapeVol.length == 0 ? '' : shapeVol.length}
																												onChange={(e) => { setLengthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.lengthUnit, label: shapeVol.lengthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setLengthUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setLengthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.lengthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="height"
																												value={shapeVol.height == 0 ? '' : shapeVol.height}
																												onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.heightUnit, label: shapeVol.heightUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setheightUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.heightUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																						{
																							shapeVol.selectedImage == 4 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Outer_width')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="outerWidth"
																												value={shapeVol.outerWidth == 0 ? '' : shapeVol.outerWidth}
																												onChange={(e) => { setOuterWidthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.outerWidthUnit, label: shapeVol.outerWidthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setOuterWidthUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setOuterWidthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.outerWidthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Outer_length')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="outerLength"
																												value={shapeVol.outerLength == 0 ? '' : shapeVol.outerLength}
																												onChange={(e) => { setOuterLengthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.outerLengthUnit, label: shapeVol.outerLengthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setOuterLengthUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setOuterLengthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.outerLengthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Inner_width')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="innerWidth"
																												value={shapeVol.innerWidth == 0 ? '' : shapeVol.innerWidth}
																												onChange={(e) => { setInnerWidthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.innerWidthUnit, label: shapeVol.innerWidthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setInnerWidthUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setInnerWidthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.innerWidthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Inner_length')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="innerLength"
																												value={shapeVol.innerLength == 0 ? '' : shapeVol.innerLength}
																												onChange={(e) => { setInnerLengthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6 align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.innerLengthUnit, label: shapeVol.innerLengthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setInnerLengthUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setInnerLengthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.innerLengthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Depth')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="depth"
																												value={shapeVol.depth == 0 ? '' : shapeVol.depth}
																												onChange={(e) => { setDepthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.depthUnit, label: shapeVol.depthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setDepthUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setDepthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.depthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																						{
																							shapeVol.selectedImage == 5 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row align-items-center justify-content-start mb-1">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Width')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="width"
																												value={shapeVol.width == 0 ? '' : shapeVol.width}
																												onChange={(e) => { setWidthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6 align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.widthUnit, label: shapeVol.widthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setWidthUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setWidthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.widthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Rise')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="rise"
																												value={shapeVol.rise == 0 ? '' : shapeVol.rise}
																												onChange={(e) => { setRiseArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.riseUnit, label: shapeVol.riseUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setRiseUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setRiseUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.riseUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Run')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="run"
																												value={shapeVol.run == 0 ? '' : shapeVol.run}
																												onChange={(e) => { setRunArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.runUnit, label: shapeVol.runUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setRunUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setRunUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.runUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Platform_depth')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="platformDepth"
																												value={shapeVol.platformDepth == 0 ? '' : shapeVol.platformDepth}
																												onChange={(e) => { setPlatformDepthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<Select
																												className="select-style col-12"
																												closeMenuOnSelect={true}
																												components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																												value={{ value: shapeVol.platformDepthUnit, label: shapeVol.platformDepthUnit }}
																												styles={customStyles}
																												options={unitsM}
																												onChange={(e) => { setPlatformDepthUnitArray(e.value, indexShape) }}
																											/>
																											{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setPlatformDepthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.platformDepthUnit}>{unit}</option>
																															))}
																														</select> */}
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Number_of_stairs')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="numberStairs"
																												value={shapeVol.numberStairs == 0 ? '' : shapeVol.numberStairs}
																												onChange={(e) => { setNumberStairsArray(e.target.value, indexShape) }}
																											/>
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																					</div>

																					{/* <div className="row">
																						{
																							shapeVol.selectedImage == 0 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Length')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="length"
																												value={shapeVol.length == 0 ? '' : shapeVol.length}
																												onChange={(e) => { setLengthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setLengthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.lengthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Width')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="width"
																												value={shapeVol.width == 0 ? '' : shapeVol.width}
																												onChange={(e) => { setWidthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setWidthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.widthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="height"
																												value={shapeVol.height == 0 ? '' : shapeVol.height}
																												onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.heightUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																						{
																							shapeVol.selectedImage == 1 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="height"
																												value={shapeVol.height == 0 ? '' : shapeVol.height}
																												onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.heightUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Diameter')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="diameter"
																												value={shapeVol.diameter == 0 ? '' : shapeVol.diameter}
																												onChange={(e) => { setDiameterArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setDiameterUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.diameterUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																						{
																							shapeVol.selectedImage == 2 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>Outer {t('Diameter')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="outerDiameter"
																												value={shapeVol.outerDiameter == 0 ? '' : shapeVol.outerDiameter}
																												onChange={(e) => { setOuterDiameterArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setOuterDiameterUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.outerDiameterUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>Inner {t('Diameter')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="innerDiameter"
																												value={shapeVol.innerDiameter == 0 ? '' : shapeVol.innerDiameter}
																												onChange={(e) => { setInnerDiameterArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setInnerDiameterUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.innerDiameterUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="height"
																												value={shapeVol.height == 0 ? '' : shapeVol.height}
																												onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.heightUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																						{
																							shapeVol.selectedImage == 3 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Width')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="width"
																												value={shapeVol.width == 0 ? '' : shapeVol.width}
																												onChange={(e) => { setWidthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setWidthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.widthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Length')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="length"
																												value={shapeVol.length == 0 ? '' : shapeVol.length}
																												onChange={(e) => { setLengthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setLengthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.lengthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="height"
																												value={shapeVol.height == 0 ? '' : shapeVol.height}
																												onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.heightUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																						{
																							shapeVol.selectedImage == 4 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>Outer {t('Width')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="outerWidth"
																												value={shapeVol.outerWidth == 0 ? '' : shapeVol.outerWidth}
																												onChange={(e) => { setOuterWidthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setOuterWidthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.outerWidthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>Outer {t('Length')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="outerLength"
																												value={shapeVol.outerLength == 0 ? '' : shapeVol.outerLength}
																												onChange={(e) => { setOuterLengthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setOuterLengthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.outerLengthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>Inner {t('Width')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="innerWidth"
																												value={shapeVol.innerWidth == 0 ? '' : shapeVol.innerWidth}
																												onChange={(e) => { setInnerWidthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setInnerWidthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.innerWidthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>Inner {t('Length')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="innerLength"
																												value={shapeVol.innerLength == 0 ? '' : shapeVol.innerLength}
																												onChange={(e) => { setInnerLengthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6 align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setInnerLengthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.innerLengthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Depth')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="depth"
																												value={shapeVol.depth == 0 ? '' : shapeVol.depth}
																												onChange={(e) => { setDepthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setDepthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.depthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																						{
																							shapeVol.selectedImage == 5 ? (
																								<div className="col-12 align-items-center justify-content-start">
																									<div className="row align-items-center justify-content-start mb-1">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Width')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="width"
																												value={shapeVol.width == 0 ? '' : shapeVol.width}
																												onChange={(e) => { setWidthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6 align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setWidthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.widthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Rise')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="rise"
																												value={shapeVol.rise == 0 ? '' : shapeVol.rise}
																												onChange={(e) => { setRiseArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setRiseUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.riseUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Run')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="run"
																												value={shapeVol.run == 0 ? '' : shapeVol.run}
																												onChange={(e) => { setRunArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setRunUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.runUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>Platform {t('Depth')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="platformDepth"
																												value={shapeVol.platformDepth == 0 ? '' : shapeVol.platformDepth}
																												onChange={(e) => { setPlatformDepthArray(e.target.value, indexShape) }}
																											/>
																										</div>
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																											<select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setPlatformDepthUnitArray(e.target.value, indexShape) }}>
																												<option className="option-style" selected>{t('Choose_an_option')}</option>
																												{unitsM.map((unit) => (
																													<option className="option-style" key={unit} value={unit}
																														selected={unit == shapeVol.platformDepthUnit}>{unit}</option>
																												))}
																											</select>
																										</div>
																									</div>
																									<div className="row   align-items-center justify-content-start mb-3 mt-3">
																										<div className='col-6   align-items-center justify-content-start'>
																											<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Number_of_stairs')}</label>
																											<input
																												type="number"
																												className="option-style cmx-form-control col-12 p-1 pl-2"
																												id="numberStairs"
																												value={shapeVol.numberStairs}
																												onChange={(e) => { setNumberStairsArray(e.target.value, indexShape) }}
																											/>
																										</div>
																									</div>
																								</div>

																							) : ('')
																						}
																					</div> */}
																				</div>
																			) : ('')
																		}
																	</div>
																))}

																<div className="col row align-items-end justify-content-end mt-3 mb-3">
																	<p className='add-shape-text row align-items-end justify-content-end cursor-pointer mr-3'
																		onClick={(e) => { addNewShape() }}>
																		+ {t('Add_shape')}
																	</p>
																</div>
															</form>
														) : ('')
													}

												</div>
											) : ('')
										}

										<div className='col-12'>
											<div className="col-12 detail-section p-3">
												{
													selectedProjectId != null ? (
														<p className='detail-title col-12 mb-2'>{t('Project')}</p>
													) : ('')
												}
												<div className="row mb-2">
													{
														selectedProjectId != null ? (
															<p className='chip-1 m-2 h6 col-auto'><strong>{getProjectName(selectedProjectId)}</strong></p>
														) : ('')
													}
													{
														selectedOptionId != null ? (
															< p className='chip-1 m-2 h6 col-auto'><strong>{getOptionName(selectedOptionId)}</strong></p>
														) : ('')
													}
												</div>
												<p className='detail-header col-12 mb-2'>{t('Order_detail')}</p>
												{shapesVolumeArray.map((shapeVol, index) => (
													<div key={shapeVol.id} className="row align-items-center justify-content-between">

														<div className='square-small row align-items-center justify-content-center m-1'>
															{
																shapeVol.selectedImage == 0 ?
																	(
																		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 92 42" fill="none">
																			<path opacity="0.4" d="M30.8401 1L1.37012 17.54V41L30.8401 24.21V1Z" fill="#1203B8" />
																			<path opacity="0.4" d="M91.0001 1H30.8401V24.21H91.0001V1Z" fill="#1203B8" />
																			<path opacity="0.4" d="M61.29 17.54H1V41H61.29V17.54Z" fill="#1203B8" />
																			<path opacity="0.4" d="M91 1L61.29 17.54V41L91 24.21V1Z" fill="#1203B8" />
																			<path d="M1.37012 17.54V41H61.2901L91.0001 24.21V1H30.8401L1.37012 17.54Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M1.37012 17.54H61.2901L91.0001 1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M61.29 41V17.54" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M91.0002 24.21H89.9202" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M87.7802 24.21H30.8402L3.24023 39.93" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M2.31012 40.46L1.37012 41" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M30.8401 24.21V23.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M30.8401 20.79V3.25" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M30.8401 2.08V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																		</svg>
																	) :
																	('')
															}
															{
																shapeVol.selectedImage == 1 ?
																	(
																		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 92 56" fill="none">
																			<path opacity="0.3" d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47556 70.8528 1 46 1C21.1472 1 1 6.47556 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" fill="#0003B8" />
																			<path opacity="0.6" d="M46 55C70.8528 55 91 49.5244 91 42.77C91 36.0155 70.8528 30.54 46 30.54C21.1472 30.54 1 36.0155 1 42.77C1 49.5244 21.1472 55 46 55Z" fill="#0003B8" />
																			<path opacity="0.5" d="M90.83 14.4301V42.7701C90.83 42.7701 92.33 31.8001 46 30.5401C46 30.5401 3.88 30.5401 1 42.7701V15.5501C1 15.5501 6.84 24.9001 46 25.4701C46 25.4701 84.29 25.4701 90.83 14.4301Z" fill="#0003B8" />
																			<path d="M1 42.77C1 42.29 1.1 41.81 1.3 41.35" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M3.04004 39.11C8.75004 34.14 25.77 30.54 45.89 30.54C67.35 30.54 85.3 34.65 89.73 40.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M90.48 41.34C90.68 41.81 90.78 42.28 90.78 42.76" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M45.89 25.46C70.6821 25.46 90.78 19.9844 90.78 13.23C90.78 6.47556 70.6821 1 45.89 1C21.0979 1 1 6.47556 1 13.23C1 19.9844 21.0979 25.46 45.89 25.46Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M1 13.23V42.76C1 49.52 21.1 54.99 45.89 54.99C70.68 54.99 90.78 49.51 90.78 42.76V13.23" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																		</svg>
																	) :
																	('')
															}
															{
																shapeVol.selectedImage == 2 ?
																	(
																		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 92 56" fill="none">
																			<path opacity="0.3" d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47556 70.8528 1 46 1C21.1472 1 1 6.47556 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" fill="#0003B8" />
																			<path opacity="0.6" d="M46 55C70.8528 55 91 49.5244 91 42.77C91 36.0155 70.8528 30.54 46 30.54C21.1472 30.54 1 36.0155 1 42.77C1 49.5244 21.1472 55 46 55Z" fill="#0003B8" />
																			<path opacity="0.5" d="M90.83 14.4301V42.7701C90.83 42.7701 92.33 31.8001 46 30.5401C46 30.5401 3.88 30.5401 1 42.7701V15.5501C1 15.5501 6.84 24.9001 46 25.4701C46 25.4701 84.29 25.4701 90.83 14.4301Z" fill="#0003B8" />
																			<path d="M15.9199 43.3401C15.9199 42.8401 16.1699 42.3601 16.6299 41.8901" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																			<path d="M19.3398 40.2501C24.3698 38.1301 34.4198 36.6801 45.9998 36.6801C58.8098 36.6801 69.7398 38.4501 74.0798 40.9401" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																			<path d="M75.3599 41.8901C75.8299 42.3601 76.0699 42.8401 76.0699 43.3401" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																			<path d="M45.9999 19.35C62.6126 19.35 76.0799 16.3727 76.0799 12.7C76.0799 9.02735 62.6126 6.05005 45.9999 6.05005C29.3872 6.05005 15.9199 9.02735 15.9199 12.7C15.9199 16.3727 29.3872 19.35 45.9999 19.35Z" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M15.9199 13.1801V42.6601C15.9199 46.3301 29.3899 49.3101 45.9999 49.3101C62.6099 49.3101 76.0799 46.3301 76.0799 42.6601V13.1801" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M1.11011 42.77C1.11011 42.29 1.21011 41.81 1.41011 41.35" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M3.15015 39.11C8.86015 34.14 25.8802 30.54 46.0002 30.54C67.4602 30.54 85.4101 34.65 89.8401 40.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M90.5901 41.34C90.7901 41.81 90.8901 42.28 90.8901 42.76" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																			<path d="M46.0001 25.46C70.7922 25.46 90.8901 19.9844 90.8901 13.23C90.8901 6.47556 70.7922 1 46.0001 1C21.208 1 1.11011 6.47556 1.11011 13.23C1.11011 19.9844 21.208 25.46 46.0001 25.46Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M1.11011 13.23V42.76C1.11011 49.52 21.2101 54.99 46.0001 54.99C70.7901 54.99 90.8901 49.51 90.8901 42.76V13.23" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path opacity="0.15" d="M45.9999 49.16C62.6126 49.16 76.0799 46.326 76.0799 42.83C76.0799 39.334 62.6126 36.5 45.9999 36.5C29.3872 36.5 15.9199 39.334 15.9199 42.83C15.9199 46.326 29.3872 49.16 45.9999 49.16Z" fill="#0003B8" />
																			<path opacity="0.25" d="M45.9999 19.03C62.6126 19.03 76.0799 16.196 76.0799 12.7C76.0799 9.20403 62.6126 6.37 45.9999 6.37C29.3872 6.37 15.9199 9.20403 15.9199 12.7C15.9199 16.196 29.3872 19.03 45.9999 19.03Z" fill="#0003B8" />
																		</svg>
																	) :
																	('')
															}
															{
																shapeVol.selectedImage == 3 ?
																	(
																		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 92 42" fill="none">
																			<path opacity="0.3" d="M83.65 9.58997H1V41H83.65V9.58997Z" fill="#0003B8" />
																			<path opacity="0.6" d="M90.9999 1L83.6499 9.59V41L90.9999 32.41V1Z" fill="#0003B8" />
																			<path opacity="0.5" d="M8.42001 1L1 9.59H83.65L91 1H8.42001Z" fill="#0003B8" />
																			<path d="M83.65 9.58997H1V41H83.65V9.58997Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M83.6499 41L90.9999 32.41V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M83.58 9.59L91 1H8.42001L1 9.59" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																		</svg>
																	) :
																	('')
															}
															{
																shapeVol.selectedImage == 4 ?
																	(
																		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 92 30" fill="none">
																			<path opacity="0.3" d="M71.7799 19.95H1.3999V29H71.7799V19.95Z" fill="#0003B8" />
																			<path opacity="0.6" d="M91 10.05V1L71.77 19.95V29L91 10.05Z" fill="#0003B8" />
																			<path opacity="0.5" d="M20.07 1.27001L1 19.96H71.38L90.61 1.01001L20.08 1.28001L20.07 1.27001ZM68.77 16.61H9.82001L22.25 4.51001L80.99 4.65001L68.77 16.61Z" fill="#0003B8" />
																			<path opacity="0.7" d="M20.62 6.48999V10.05L14.15 16.39H10.22L20.62 6.48999Z" fill="#0003B8" />
																			<path opacity="0.7" d="M75.4801 10.05L81.3901 4.65002L22.6501 4.52002L20.6201 6.49002V10.05H75.4801Z" fill="#0003B8" />
																			<path d="M71.7799 19.95H1.3999V29H71.7799V19.95Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M90.5799 1L71.7699 19.95H1.3999L20.4699 1.27L90.5799 1Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M69.1599 16.61H10.22L22.65 4.52002H81.52L69.1599 16.61Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M91 1V10.05L71.77 29V19.95" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M20.6199 6.48999V10.05L75.9999 9.92999" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																			<path d="M14.0598 16.61L20.6198 10.05" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																		</svg>
																	) :
																	('')
															}
															{
																shapeVol.selectedImage == 5 ?
																	(
																		<svg xmlns="http://www.w3.org/2000/svg" width="90" height="60" viewBox="0 0 310 310" fill="none">
																			<line x1="3.67224" y1="155.012" x2="2.49996" y2="305.007" stroke="#0000B3" stroke-width="3" />
																			<line x1="211" y1="306.5" x2="1" y2="306.5" stroke="#0000B3" stroke-width="3" />
																			<path d="M72 155L2 155" stroke="#0000B3" stroke-width="3" />
																			<line x1="141" y1="206.5" x2="71" y2="206.5" stroke="#0000B3" stroke-width="3" />
																			<line x1="211" y1="255.5" x2="141" y2="255.5" stroke="#0000B3" stroke-width="3" />
																			<line x1="294" y1="131.5" x2="224" y2="131.5" stroke="#0000B3" stroke-width="3" />
																			<line x1="225" y1="81.5001" x2="155" y2="81.5" stroke="#0000B3" stroke-width="3" />
																			<line x1="156" y1="30.5001" x2="86" y2="30.5" stroke="#0000B3" stroke-width="3" />
																			<line x1="70.5" y1="205" x2="70.5" y2="155" stroke="#0000B3" stroke-width="3" />
																			<path d="M141 255V205" stroke="#0000B3" stroke-width="3" />
																			<line x1="209.5" y1="305" x2="209.5" y2="255" stroke="#0000B3" stroke-width="3" />
																			<line x1="223.5" y1="130" x2="223.5" y2="80" stroke="#0000B3" stroke-width="3" />
																			<line x1="236" y1="129.5" x2="226" y2="129.5" stroke="#0000B3" stroke-width="3" />
																			<line x1="236" y1="82.5" x2="226" y2="82.5" stroke="#0000B3" stroke-width="3" />
																			<line x1="229.5" y1="128" x2="229.5" y2="81" stroke="#0000B3" stroke-width="3" />
																			<line x1="225.5" y1="67" x2="225.5" y2="77" stroke="#0000B3" stroke-width="3" />
																			<line x1="158.5" y1="67" x2="158.5" y2="77" stroke="#0000B3" stroke-width="3" />
																			<line x1="224" y1="73.5" x2="157" y2="73.5" stroke="#0000B3" stroke-width="3" />
																			<line x1="156.5" y1="13" x2="156.5" y2="23" stroke="#0000B3" stroke-width="3" />
																			<line x1="89.5" y1="13" x2="89.5" y2="23" stroke="#0000B3" stroke-width="3" />
																			<line x1="155" y1="19.5" x2="88" y2="19.5" stroke="#0000B3" stroke-width="3" />
																			<line x1="154.5" y1="80" x2="154.5" y2="30" stroke="#0000B3" stroke-width="3" />
																			<line x1="1.75328" y1="153.838" x2="85.1608" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																			<line x1="70.7533" y1="153.838" x2="154.161" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																			<line x1="70.7533" y1="204.838" x2="154.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																			<line x1="139.753" y1="204.838" x2="223.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																			<line x1="140.753" y1="253.838" x2="224.161" y2="129.166" stroke="#0000B3" stroke-width="3" />
																			<line x1="225.5" y1="302" x2="225.5" y2="312" stroke="#0000B3" stroke-width="3" />
																			<line x1="307.5" y1="189" x2="307.5" y2="179" stroke="#0000B3" stroke-width="3" />
																			<line x1="293.5" y1="180" x2="293.5" y2="130" stroke="#0000B3" stroke-width="3" />
																			<line x1="209.753" y1="254.838" x2="293.161" y2="130.166" stroke="#0000B3" stroke-width="3" />
																			<line x1="209.757" y1="304.161" x2="294.164" y2="179.161" stroke="#0000B3" stroke-width="3" />
																			<line x1="223.757" y1="307.161" x2="308.164" y2="182.161" stroke="#0000B3" stroke-width="3" />
																			<path d="M269.202 258L267.213 250.727H268.108L269.628 256.651H269.699L271.247 250.727H272.241L273.79 256.651H273.861L275.381 250.727H276.276L274.287 258H273.378L271.773 252.205H271.716L270.111 258H269.202ZM277.259 258V252.545H278.097V258H277.259ZM277.685 251.636C277.522 251.636 277.381 251.581 277.263 251.469C277.147 251.358 277.089 251.224 277.089 251.068C277.089 250.912 277.147 250.778 277.263 250.667C277.381 250.556 277.522 250.5 277.685 250.5C277.849 250.5 277.988 250.556 278.104 250.667C278.223 250.778 278.282 250.912 278.282 251.068C278.282 251.224 278.223 251.358 278.104 251.469C277.988 251.581 277.849 251.636 277.685 251.636ZM281.692 258.114C281.237 258.114 280.836 257.999 280.488 257.769C280.14 257.537 279.868 257.21 279.671 256.789C279.475 256.365 279.377 255.865 279.377 255.287C279.377 254.714 279.475 254.217 279.671 253.795C279.868 253.374 280.141 253.049 280.492 252.819C280.842 252.589 281.247 252.474 281.706 252.474C282.061 252.474 282.342 252.534 282.548 252.652C282.756 252.768 282.915 252.901 283.024 253.05C283.135 253.196 283.221 253.317 283.283 253.412H283.354V250.727H284.192V258H283.382V257.162H283.283C283.221 257.261 283.134 257.387 283.02 257.538C282.906 257.687 282.744 257.821 282.534 257.94C282.323 258.056 282.042 258.114 281.692 258.114ZM281.806 257.361C282.142 257.361 282.426 257.273 282.658 257.098C282.89 256.92 283.066 256.675 283.187 256.363C283.308 256.048 283.368 255.685 283.368 255.273C283.368 254.866 283.309 254.509 283.191 254.204C283.072 253.896 282.897 253.657 282.665 253.487C282.433 253.314 282.146 253.227 281.806 253.227C281.45 253.227 281.155 253.318 280.918 253.501C280.683 253.681 280.507 253.926 280.389 254.236C280.273 254.544 280.215 254.889 280.215 255.273C280.215 255.661 280.274 256.014 280.392 256.331C280.513 256.646 280.691 256.897 280.925 257.084C281.162 257.268 281.455 257.361 281.806 257.361ZM288.215 252.545V253.256H285.389V252.545H288.215ZM286.213 251.239H287.051V256.438C287.051 256.674 287.085 256.852 287.154 256.97C287.225 257.086 287.315 257.164 287.423 257.205C287.535 257.242 287.652 257.261 287.775 257.261C287.867 257.261 287.943 257.257 288.002 257.247C288.061 257.235 288.109 257.226 288.144 257.219L288.315 257.972C288.258 257.993 288.179 258.014 288.077 258.036C287.975 258.059 287.846 258.071 287.69 258.071C287.453 258.071 287.221 258.02 286.994 257.918C286.769 257.817 286.582 257.661 286.433 257.453C286.286 257.245 286.213 256.982 286.213 256.665V251.239ZM290.431 254.719V258H289.593V250.727H290.431V253.398H290.502C290.63 253.116 290.822 252.892 291.078 252.727C291.336 252.558 291.679 252.474 292.107 252.474C292.479 252.474 292.805 252.549 293.084 252.698C293.363 252.845 293.58 253.071 293.734 253.376C293.89 253.679 293.968 254.065 293.968 254.534V258H293.13V254.591C293.13 254.158 293.018 253.823 292.793 253.586C292.57 253.347 292.261 253.227 291.866 253.227C291.591 253.227 291.345 253.285 291.127 253.401C290.912 253.517 290.741 253.687 290.616 253.909C290.493 254.132 290.431 254.402 290.431 254.719Z" fill="#0000B3" />
																			<path d="M233.881 108V100.727H236.338C236.906 100.727 237.373 100.824 237.737 101.018C238.102 101.21 238.372 101.474 238.547 101.81C238.722 102.147 238.81 102.529 238.81 102.957C238.81 103.386 238.722 103.766 238.547 104.097C238.372 104.429 238.103 104.689 237.741 104.879C237.379 105.066 236.916 105.159 236.352 105.159H234.364V104.364H236.324C236.712 104.364 237.025 104.307 237.261 104.193C237.5 104.08 237.673 103.919 237.78 103.71C237.889 103.5 237.943 103.249 237.943 102.957C237.943 102.666 237.889 102.412 237.78 102.194C237.671 101.976 237.497 101.808 237.258 101.69C237.019 101.569 236.703 101.509 236.31 101.509H234.761V108H233.881ZM237.304 104.733L239.094 108H238.071L236.31 104.733H237.304ZM240.164 108V102.545H241.002V108H240.164ZM240.59 101.636C240.426 101.636 240.285 101.581 240.167 101.469C240.051 101.358 239.993 101.224 239.993 101.068C239.993 100.912 240.051 100.778 240.167 100.667C240.285 100.556 240.426 100.5 240.59 100.5C240.753 100.5 240.893 100.556 241.009 100.667C241.127 100.778 241.186 100.912 241.186 101.068C241.186 101.224 241.127 101.358 241.009 101.469C240.893 101.581 240.753 101.636 240.59 101.636ZM246.4 103.767L245.647 103.98C245.6 103.855 245.53 103.733 245.438 103.614C245.348 103.494 245.225 103.394 245.069 103.316C244.912 103.238 244.712 103.199 244.468 103.199C244.135 103.199 243.856 103.276 243.634 103.43C243.414 103.581 243.304 103.774 243.304 104.009C243.304 104.217 243.379 104.381 243.531 104.502C243.682 104.623 243.919 104.723 244.241 104.804L245.051 105.003C245.538 105.121 245.902 105.302 246.141 105.546C246.38 105.788 246.5 106.099 246.5 106.48C246.5 106.793 246.41 107.072 246.23 107.318C246.052 107.564 245.804 107.759 245.484 107.901C245.164 108.043 244.793 108.114 244.369 108.114C243.813 108.114 243.352 107.993 242.988 107.751C242.623 107.51 242.392 107.157 242.295 106.693L243.091 106.494C243.166 106.788 243.31 107.008 243.52 107.155C243.733 107.302 244.011 107.375 244.355 107.375C244.745 107.375 245.056 107.292 245.285 107.126C245.517 106.958 245.633 106.757 245.633 106.523C245.633 106.333 245.567 106.175 245.434 106.047C245.302 105.917 245.098 105.82 244.824 105.756L243.914 105.543C243.415 105.424 243.048 105.241 242.814 104.992C242.582 104.741 242.466 104.428 242.466 104.051C242.466 103.743 242.552 103.471 242.725 103.234C242.9 102.998 243.138 102.812 243.439 102.677C243.742 102.542 244.085 102.474 244.468 102.474C245.008 102.474 245.432 102.593 245.74 102.83C246.05 103.066 246.27 103.379 246.4 103.767ZM250.048 108.114C249.523 108.114 249.069 107.998 248.688 107.766C248.309 107.531 248.017 107.205 247.811 106.786C247.607 106.364 247.506 105.874 247.506 105.315C247.506 104.757 247.607 104.264 247.811 103.838C248.017 103.41 248.303 103.076 248.67 102.837C249.04 102.595 249.47 102.474 249.963 102.474C250.247 102.474 250.528 102.522 250.805 102.616C251.081 102.711 251.334 102.865 251.561 103.078C251.788 103.289 251.969 103.568 252.104 103.916C252.239 104.264 252.307 104.693 252.307 105.202V105.557H248.102V104.832H251.454C251.454 104.525 251.393 104.25 251.27 104.009C251.149 103.767 250.976 103.576 250.751 103.437C250.529 103.297 250.266 103.227 249.963 103.227C249.629 103.227 249.34 103.31 249.096 103.476C248.855 103.639 248.669 103.852 248.539 104.115C248.409 104.378 248.344 104.66 248.344 104.96V105.443C248.344 105.855 248.415 106.204 248.557 106.491C248.701 106.775 248.901 106.991 249.157 107.141C249.412 107.287 249.71 107.361 250.048 107.361C250.268 107.361 250.467 107.33 250.645 107.268C250.825 107.205 250.98 107.11 251.11 106.984C251.24 106.857 251.341 106.698 251.412 106.509L252.221 106.736C252.136 107.01 251.993 107.252 251.792 107.46C251.59 107.666 251.342 107.827 251.046 107.943C250.75 108.057 250.417 108.114 250.048 108.114Z" fill="#0000B3" />
																			<path d="M176.881 67V59.7273H179.338C179.906 59.7273 180.373 59.8243 180.737 60.0185C181.102 60.2102 181.372 60.4742 181.547 60.8104C181.722 61.1465 181.81 61.5289 181.81 61.9574C181.81 62.3859 181.722 62.7659 181.547 63.0973C181.372 63.4287 181.103 63.6892 180.741 63.8786C180.379 64.0656 179.916 64.1591 179.352 64.1591H177.364V63.3636H179.324C179.712 63.3636 180.025 63.3068 180.261 63.1932C180.5 63.0795 180.673 62.9186 180.78 62.7102C180.889 62.4995 180.943 62.2486 180.943 61.9574C180.943 61.6662 180.889 61.4117 180.78 61.1939C180.671 60.9761 180.497 60.808 180.258 60.6896C180.019 60.5689 179.703 60.5085 179.31 60.5085H177.761V67H176.881ZM180.304 63.733L182.094 67H181.071L179.31 63.733H180.304ZM186.601 64.7699V61.5455H187.439V67H186.601V66.0767H186.544C186.416 66.3537 186.218 66.5893 185.948 66.7834C185.678 66.9751 185.337 67.071 184.925 67.071C184.584 67.071 184.281 66.9964 184.016 66.8473C183.751 66.6958 183.542 66.4685 183.391 66.1655C183.239 65.8601 183.164 65.4754 183.164 65.0114V61.5455H184.002V64.9545C184.002 65.3523 184.113 65.6695 184.335 65.9062C184.56 66.143 184.847 66.2614 185.195 66.2614C185.403 66.2614 185.615 66.2081 185.83 66.1016C186.048 65.995 186.231 65.8317 186.377 65.6115C186.526 65.3913 186.601 65.1108 186.601 64.7699ZM189.812 63.7188V67H188.974V61.5455H189.784V62.3977H189.855C189.983 62.1207 190.177 61.8982 190.437 61.7301C190.698 61.5597 191.034 61.4744 191.446 61.4744C191.815 61.4744 192.138 61.5502 192.415 61.7017C192.692 61.8509 192.908 62.0781 193.061 62.3835C193.215 62.6866 193.292 63.0701 193.292 63.5341V67H192.454V63.5909C192.454 63.1624 192.343 62.8286 192.12 62.5895C191.898 62.348 191.592 62.2273 191.204 62.2273C190.937 62.2273 190.698 62.2853 190.487 62.4013C190.279 62.5173 190.114 62.6866 189.993 62.9091C189.873 63.1316 189.812 63.4015 189.812 63.7188Z" fill="#0000B3" />
																			<path d="M88.7098 8V0.727273H91.1672C91.7377 0.727273 92.2041 0.830255 92.5663 1.03622C92.9309 1.23982 93.2008 1.51562 93.376 1.86364C93.5512 2.21165 93.6388 2.59991 93.6388 3.02841C93.6388 3.45691 93.5512 3.84635 93.376 4.19673C93.2032 4.54711 92.9356 4.82647 92.5734 5.0348C92.2112 5.24077 91.7472 5.34375 91.1814 5.34375H89.42V4.5625H91.153C91.5436 4.5625 91.8573 4.49503 92.094 4.36009C92.3308 4.22514 92.5024 4.04285 92.6089 3.81321C92.7178 3.5812 92.7723 3.3196 92.7723 3.02841C92.7723 2.73722 92.7178 2.4768 92.6089 2.24716C92.5024 2.01752 92.3296 1.83759 92.0905 1.70739C91.8514 1.57481 91.5341 1.50852 91.1388 1.50852H89.5905V8H88.7098ZM95.7819 0.727273V8H94.9438V0.727273H95.7819ZM98.922 8.12784C98.5763 8.12784 98.2626 8.06274 97.9809 7.93253C97.6992 7.79995 97.4755 7.60938 97.3097 7.3608C97.144 7.10985 97.0612 6.80682 97.0612 6.4517C97.0612 6.1392 97.1227 5.88589 97.2458 5.69176C97.3689 5.49527 97.5335 5.34138 97.7394 5.23011C97.9454 5.11884 98.1727 5.03598 98.4213 4.98153C98.6722 4.92472 98.9243 4.87973 99.1776 4.84659C99.5091 4.80398 99.7778 4.77202 99.9838 4.75071C100.192 4.72704 100.344 4.68797 100.438 4.63352C100.535 4.57907 100.584 4.48437 100.584 4.34943V4.32102C100.584 3.97064 100.488 3.69839 100.296 3.50426C100.107 3.31013 99.8192 3.21307 99.4333 3.21307C99.0332 3.21307 98.7195 3.30066 98.4923 3.47585C98.265 3.65104 98.1052 3.83807 98.0129 4.03693L97.2174 3.75284C97.3595 3.4214 97.5489 3.16335 97.7856 2.97869C98.0247 2.79167 98.2851 2.66146 98.5669 2.58807C98.8509 2.51231 99.1303 2.47443 99.4049 2.47443C99.5801 2.47443 99.7813 2.49574 100.009 2.53835C100.238 2.5786 100.46 2.66264 100.673 2.79048C100.888 2.91832 101.067 3.11127 101.209 3.36932C101.351 3.62737 101.422 3.97301 101.422 4.40625V8H100.584V7.26136H100.541C100.484 7.37973 100.39 7.50639 100.257 7.64134C100.125 7.77628 99.9482 7.8911 99.7281 7.9858C99.5079 8.08049 99.2392 8.12784 98.922 8.12784ZM99.0498 7.375C99.3812 7.375 99.6606 7.3099 99.8879 7.17969C100.118 7.04948 100.29 6.88139 100.406 6.67543C100.525 6.46946 100.584 6.25284 100.584 6.02557V5.25852C100.548 5.30114 100.47 5.3402 100.35 5.37571C100.231 5.40885 100.094 5.43845 99.9376 5.46449C99.7837 5.48816 99.6334 5.50947 99.4866 5.52841C99.3422 5.54498 99.225 5.55919 99.135 5.57102C98.9172 5.59943 98.7136 5.6456 98.5242 5.70952C98.3372 5.77107 98.1857 5.86458 98.0697 5.99006C97.9561 6.11316 97.8992 6.28125 97.8992 6.49432C97.8992 6.78551 98.007 7.00568 98.2224 7.15483C98.4402 7.30161 98.716 7.375 99.0498 7.375ZM105.324 2.54545V3.25568H102.497V2.54545H105.324ZM103.321 1.23864H104.159V6.4375C104.159 6.67424 104.193 6.8518 104.262 6.97017C104.333 7.08617 104.423 7.1643 104.532 7.20455C104.643 7.24242 104.76 7.26136 104.883 7.26136C104.976 7.26136 105.052 7.25663 105.111 7.24716C105.17 7.23532 105.217 7.22585 105.253 7.21875L105.423 7.97159C105.366 7.9929 105.287 8.0142 105.185 8.03551C105.083 8.05919 104.954 8.07102 104.798 8.07102C104.561 8.07102 104.329 8.02012 104.102 7.91832C103.877 7.81652 103.69 7.66146 103.541 7.45312C103.394 7.24479 103.321 6.98201 103.321 6.66477V1.23864ZM109.013 2.54545V3.25568H106.073V2.54545H109.013ZM106.954 8V1.79261C106.954 1.48011 107.027 1.2197 107.174 1.01136C107.321 0.80303 107.511 0.64678 107.746 0.542613C107.98 0.438446 108.227 0.386363 108.488 0.386363C108.694 0.386363 108.862 0.402935 108.992 0.436079C109.122 0.469223 109.219 0.5 109.283 0.528409L109.042 1.25284C108.999 1.23864 108.94 1.22088 108.864 1.19957C108.791 1.17827 108.694 1.16761 108.573 1.16761C108.296 1.16761 108.096 1.23745 107.973 1.37713C107.852 1.51681 107.792 1.72159 107.792 1.99148V8H106.954ZM112.179 8.11364C111.687 8.11364 111.255 7.99645 110.883 7.76207C110.514 7.5277 110.225 7.19981 110.017 6.77841C109.811 6.35701 109.708 5.86458 109.708 5.30114C109.708 4.73295 109.811 4.23698 110.017 3.81321C110.225 3.38944 110.514 3.06037 110.883 2.82599C111.255 2.59162 111.687 2.47443 112.179 2.47443C112.672 2.47443 113.103 2.59162 113.472 2.82599C113.844 3.06037 114.132 3.38944 114.338 3.81321C114.547 4.23698 114.651 4.73295 114.651 5.30114C114.651 5.86458 114.547 6.35701 114.338 6.77841C114.132 7.19981 113.844 7.5277 113.472 7.76207C113.103 7.99645 112.672 8.11364 112.179 8.11364ZM112.179 7.3608C112.553 7.3608 112.861 7.26491 113.103 7.07315C113.344 6.88139 113.523 6.62926 113.639 6.31676C113.755 6.00426 113.813 5.66572 113.813 5.30114C113.813 4.93655 113.755 4.59683 113.639 4.28196C113.523 3.96709 113.344 3.71259 113.103 3.51847C112.861 3.32434 112.553 3.22727 112.179 3.22727C111.805 3.22727 111.497 3.32434 111.256 3.51847C111.014 3.71259 110.836 3.96709 110.72 4.28196C110.604 4.59683 110.546 4.93655 110.546 5.30114C110.546 5.66572 110.604 6.00426 110.72 6.31676C110.836 6.62926 111.014 6.88139 111.256 7.07315C111.497 7.26491 111.805 7.3608 112.179 7.3608ZM115.93 8V2.54545H116.74V3.36932H116.797C116.896 3.09943 117.076 2.88045 117.336 2.71236C117.597 2.54427 117.89 2.46023 118.217 2.46023C118.279 2.46023 118.356 2.46141 118.448 2.46378C118.54 2.46615 118.61 2.4697 118.657 2.47443V3.3267C118.629 3.3196 118.564 3.30895 118.462 3.29474C118.363 3.27817 118.257 3.26989 118.146 3.26989C117.881 3.26989 117.644 3.32552 117.436 3.43679C117.23 3.54569 117.066 3.69721 116.946 3.89134C116.827 4.0831 116.768 4.30208 116.768 4.5483V8H115.93ZM119.651 8V2.54545H120.46V3.39773H120.532C120.645 3.10653 120.829 2.88045 121.082 2.71946C121.335 2.55611 121.639 2.47443 121.995 2.47443C122.354 2.47443 122.654 2.55611 122.893 2.71946C123.134 2.88045 123.323 3.10653 123.458 3.39773H123.514C123.654 3.116 123.864 2.89228 124.143 2.72656C124.422 2.55848 124.757 2.47443 125.148 2.47443C125.636 2.47443 126.035 2.62713 126.345 2.93253C126.655 3.23556 126.81 3.70786 126.81 4.34943V8H125.972V4.34943C125.972 3.94697 125.862 3.65933 125.642 3.48651C125.421 3.31368 125.162 3.22727 124.864 3.22727C124.48 3.22727 124.183 3.34328 123.973 3.57528C123.762 3.80492 123.657 4.09612 123.657 4.44886V8H122.804V4.2642C122.804 3.95407 122.704 3.70431 122.502 3.51491C122.301 3.32315 122.042 3.22727 121.725 3.22727C121.507 3.22727 121.303 3.28527 121.114 3.40128C120.927 3.51728 120.775 3.67827 120.659 3.88423C120.546 4.08783 120.489 4.32339 120.489 4.59091V8H119.651ZM133.214 8.11364C132.76 8.11364 132.359 7.99882 132.011 7.76918C131.663 7.53717 131.39 7.21046 131.194 6.78906C130.997 6.36529 130.899 5.86458 130.899 5.28693C130.899 4.71402 130.997 4.21686 131.194 3.79545C131.39 3.37405 131.664 3.04853 132.014 2.81889C132.364 2.58925 132.769 2.47443 133.229 2.47443C133.584 2.47443 133.864 2.53362 134.07 2.65199C134.279 2.76799 134.437 2.90057 134.546 3.04972C134.657 3.1965 134.744 3.31723 134.805 3.41193H134.876V0.727273H135.714V8H134.905V7.16193H134.805C134.744 7.26136 134.656 7.38684 134.543 7.53835C134.429 7.6875 134.267 7.82126 134.056 7.93963C133.845 8.05563 133.565 8.11364 133.214 8.11364ZM133.328 7.3608C133.664 7.3608 133.948 7.2732 134.18 7.09801C134.412 6.92045 134.589 6.67543 134.709 6.36293C134.83 6.04806 134.891 5.68466 134.891 5.27273C134.891 4.86553 134.831 4.50923 134.713 4.20384C134.595 3.89607 134.419 3.65696 134.187 3.48651C133.955 3.31368 133.669 3.22727 133.328 3.22727C132.973 3.22727 132.677 3.31842 132.44 3.50071C132.206 3.68063 132.03 3.92566 131.911 4.2358C131.795 4.54356 131.737 4.8892 131.737 5.27273C131.737 5.66098 131.796 6.01373 131.915 6.33097C132.035 6.64583 132.213 6.89678 132.447 7.08381C132.684 7.26847 132.978 7.3608 133.328 7.3608ZM139.653 8.11364C139.127 8.11364 138.674 7.99763 138.293 7.76562C137.914 7.53125 137.621 7.20455 137.415 6.78551C137.212 6.36411 137.11 5.87405 137.11 5.31534C137.11 4.75663 137.212 4.2642 137.415 3.83807C137.621 3.40956 137.908 3.07576 138.275 2.83665C138.644 2.59517 139.075 2.47443 139.567 2.47443C139.851 2.47443 140.132 2.52178 140.409 2.61648C140.686 2.71117 140.938 2.86506 141.165 3.07812C141.393 3.28883 141.574 3.56818 141.709 3.91619C141.844 4.2642 141.911 4.69271 141.911 5.2017V5.55682H137.707V4.83239H141.059C141.059 4.52462 140.997 4.25 140.874 4.00852C140.753 3.76705 140.581 3.57647 140.356 3.43679C140.133 3.29711 139.87 3.22727 139.567 3.22727C139.234 3.22727 138.945 3.31013 138.701 3.47585C138.459 3.6392 138.274 3.85227 138.143 4.11506C138.013 4.37784 137.948 4.65956 137.948 4.96023V5.44318C137.948 5.85511 138.019 6.20431 138.161 6.49077C138.306 6.77486 138.506 6.99148 138.761 7.14062C139.017 7.28741 139.314 7.3608 139.653 7.3608C139.873 7.3608 140.072 7.33002 140.249 7.26847C140.429 7.20455 140.584 7.10985 140.714 6.98438C140.845 6.85653 140.945 6.69792 141.016 6.50852L141.826 6.7358C141.741 7.01042 141.597 7.25189 141.396 7.46023C141.195 7.66619 140.946 7.82718 140.65 7.94318C140.355 8.05682 140.022 8.11364 139.653 8.11364ZM143.186 10.0455V2.54545H143.996V3.41193H144.095C144.157 3.31723 144.242 3.1965 144.351 3.04972C144.462 2.90057 144.621 2.76799 144.827 2.65199C145.035 2.53362 145.317 2.47443 145.672 2.47443C146.131 2.47443 146.536 2.58925 146.886 2.81889C147.237 3.04853 147.51 3.37405 147.707 3.79545C147.903 4.21686 148.001 4.71402 148.001 5.28693C148.001 5.86458 147.903 6.36529 147.707 6.78906C147.51 7.21046 147.238 7.53717 146.89 7.76918C146.542 7.99882 146.141 8.11364 145.686 8.11364C145.336 8.11364 145.055 8.05563 144.844 7.93963C144.634 7.82126 144.472 7.6875 144.358 7.53835C144.244 7.38684 144.157 7.26136 144.095 7.16193H144.024V10.0455H143.186ZM144.01 5.27273C144.01 5.68466 144.07 6.04806 144.191 6.36293C144.312 6.67543 144.488 6.92045 144.72 7.09801C144.952 7.2732 145.236 7.3608 145.572 7.3608C145.923 7.3608 146.215 7.26847 146.449 7.08381C146.686 6.89678 146.864 6.64583 146.982 6.33097C147.103 6.01373 147.163 5.66098 147.163 5.27273C147.163 4.8892 147.104 4.54356 146.986 4.2358C146.87 3.92566 146.693 3.68063 146.457 3.50071C146.222 3.31842 145.927 3.22727 145.572 3.22727C145.231 3.22727 144.945 3.31368 144.713 3.48651C144.481 3.65696 144.306 3.89607 144.187 4.20384C144.069 4.50923 144.01 4.86553 144.01 5.27273ZM151.652 2.54545V3.25568H148.825V2.54545H151.652ZM149.649 1.23864H150.487V6.4375C150.487 6.67424 150.521 6.8518 150.59 6.97017C150.661 7.08617 150.751 7.1643 150.86 7.20455C150.971 7.24242 151.088 7.26136 151.212 7.26136C151.304 7.26136 151.38 7.25663 151.439 7.24716C151.498 7.23532 151.545 7.22585 151.581 7.21875L151.751 7.97159C151.695 7.9929 151.615 8.0142 151.513 8.03551C151.412 8.05919 151.283 8.07102 151.126 8.07102C150.89 8.07102 150.658 8.02012 150.43 7.91832C150.205 7.81652 150.018 7.66146 149.869 7.45312C149.722 7.24479 149.649 6.98201 149.649 6.66477V1.23864ZM153.868 4.71875V8H153.03V0.727273H153.868V3.39773H153.939C154.067 3.116 154.258 2.89228 154.514 2.72656C154.772 2.55848 155.115 2.47443 155.544 2.47443C155.916 2.47443 156.241 2.54901 156.521 2.69815C156.8 2.84493 157.016 3.07102 157.17 3.37642C157.327 3.67945 157.405 4.06534 157.405 4.53409V8H156.567V4.59091C156.567 4.15767 156.454 3.82268 156.229 3.58594C156.007 3.34683 155.698 3.22727 155.302 3.22727C155.028 3.22727 154.782 3.28527 154.564 3.40128C154.348 3.51728 154.178 3.68655 154.052 3.90909C153.929 4.13163 153.868 4.40152 153.868 4.71875Z" fill="#0000B3" />
																		</svg>
																	) :
																	('')
															}
														</div>

														<p className='order-detail-item-mobile col-3 mt-3'>
															{images[shapeVol.selectedImage].label}
														</p>
														<p className='order-detail-amount-mobile col-6 mt-3'>
															{shapeVol.shapeVolume.toLocaleString(undefined, { maximumFractionDigits: decimalsCount })} {getDefaultUnitDesc()} <sup>3</sup>
														</p>
													</div>
												))}
												<div className="row align-items-center justify-content-start">
													<div className='align-items-start justify-content-start col-5 p-1'>
														<label className='detail-label-mobile col-12 pl-1'>{t('Reserve_volume')}</label>
														<div className='cmx-form-control '>
															<input
																type="number"
																className="cmx-form-control-percentage col-6 pr-2"
																id="reserveVolume"
																value={reserveVolume}
																disabled={nextActivated}
																onChange={(e) => { setReserveVolume(e.target.value) }}
															/>
															<label className='cmx-form-label col-1 pl-3 ml-3'>%</label>
														</div>
													</div>
													<p className='order-detail-amount-reserve col-7'>
														+{calcTotalReserveVolume().toLocaleString(undefined, { maximumFractionDigits: decimalsCount })} {getDefaultUnitDesc()} <sup>3</sup>
													</p>
												</div>
												<div className="row align-items-center justify-content-start">
													<p className='order-detail-total-label-mobile col-5 mt-3 mb-3'>{t('Total_volume')}</p>
													<p className='cmx-display-1-mobile col-7'>{calcTotalPlusReserveVolume().toLocaleString(undefined, { maximumFractionDigits: decimalsCount })} {getDefaultUnitDesc()} <sup>3</sup></p>
												</div>
											</div>
											{
												nextActivated == false ? (
													<div className="row col-12 align-items-center justify-content-end">
														<button type="button" className={shapeArrayValid() == true ?
															"cmx-btn mt-3 m-0 col-12 row align-items-center justify-content-center" :
															"cmx-btn-disabled mt-3 m-0 col-12 row align-items-center justify-content-center"}
															onClick={() => activateNext()}
															disabled={shapeArrayValid() == true ? false : true}>
															<p className="cmx-btn-text pt-1">{t('Next')}</p>
														</button>
														{
															showMinVolMessage ? (
																< p className='min-vol-message col-12 mt-1'>
																	* {t('minimum_volume_message') + ' ' + minimumVolume + getDefaultUnitDesc()} <sup>3</sup>
																</p>
															) : ('')
														}

													</div>
													// <button type="button" className={shapeArrayValid() == true ?
													// 	"cmx-btn mt-3 m-0 col-12 row align-items-center justify-content-center" :
													// 	"cmx-btn-disabled mt-3 m-0 col-12 row align-items-center justify-content-center"}
													// 	onClick={() => activateNext()}
													// 	disabled={shapeArrayValid() == true ? false : true}>
													// 	<p className="cmx-btn-text pt-1">{t('Next')}</p>
													// </button>

												) : ('')
											}

										</div>
									</div>
								)
							}
						</div>
					</div>
				)
				:











				// DESKTOP VIEW
				(
					<div>
						{
							dataDefaultUnitsReady == true && t != null && langKeysReady == true ?
								(
									<div className='row outfiter desktop-margin m-0'>
										{
											nextActivated == false ? (
												<div className={showConfig == true ? "row p-0 align-items-center justify-content-end col-12" :
													"row p-0 align-items-center justify-content-start mb-3 col-12"}>
													{
														showConfig == true ? (
															<button type="button" className="cmx-button-1-back" onClick={() => goBack()}>Go back</button>
														) :
															(
																<p className='h1 cmx-header'>{t('Calculate_your_volume')}</p>
															)
													}
													{
														showConfig == false && isAdmin == true ? (
															<svg className='gear-icon m-2 pb-1' onClick={() => goConfig()} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																<path d="M12.9046 3.06005C12.6988 3 12.4659 3 12 3C11.5341 3 11.3012 3 11.0954 3.06005C10.7942 3.14794 10.5281 3.32808 10.3346 3.57511C10.2024 3.74388 10.1159 3.96016 9.94291 4.39272C9.69419 5.01452 9.00393 5.33471 8.36857 5.123L7.79779 4.93281C7.3929 4.79785 7.19045 4.73036 6.99196 4.7188C6.70039 4.70181 6.4102 4.77032 6.15701 4.9159C5.98465 5.01501 5.83376 5.16591 5.53197 5.4677C5.21122 5.78845 5.05084 5.94882 4.94896 6.13189C4.79927 6.40084 4.73595 6.70934 4.76759 7.01551C4.78912 7.2239 4.87335 7.43449 5.04182 7.85566C5.30565 8.51523 5.05184 9.26878 4.44272 9.63433L4.16521 9.80087C3.74031 10.0558 3.52786 10.1833 3.37354 10.3588C3.23698 10.5141 3.13401 10.696 3.07109 10.893C3 11.1156 3 11.3658 3 11.8663C3 12.4589 3 12.7551 3.09462 13.0088C3.17823 13.2329 3.31422 13.4337 3.49124 13.5946C3.69158 13.7766 3.96395 13.8856 4.50866 14.1035C5.06534 14.3261 5.35196 14.9441 5.16236 15.5129L4.94721 16.1584C4.79819 16.6054 4.72367 16.829 4.7169 17.0486C4.70875 17.3127 4.77049 17.5742 4.89587 17.8067C5.00015 18.0002 5.16678 18.1668 5.5 18.5C5.83323 18.8332 5.99985 18.9998 6.19325 19.1041C6.4258 19.2295 6.68733 19.2913 6.9514 19.2831C7.17102 19.2763 7.39456 19.2018 7.84164 19.0528L8.36862 18.8771C9.00393 18.6654 9.6942 18.9855 9.94291 19.6073C10.1159 20.0398 10.2024 20.2561 10.3346 20.4249C10.5281 20.6719 10.7942 20.8521 11.0954 20.94C11.3012 21 11.5341 21 12 21C12.4659 21 12.6988 21 12.9046 20.94C13.2058 20.8521 13.4719 20.6719 13.6654 20.4249C13.7976 20.2561 13.8841 20.0398 14.0571 19.6073C14.3058 18.9855 14.9961 18.6654 15.6313 18.8773L16.1579 19.0529C16.605 19.2019 16.8286 19.2764 17.0482 19.2832C17.3123 19.2913 17.5738 19.2296 17.8063 19.1042C17.9997 18.9999 18.1664 18.8333 18.4996 18.5001C18.8328 18.1669 18.9994 18.0002 19.1037 17.8068C19.2291 17.5743 19.2908 17.3127 19.2827 17.0487C19.2759 16.8291 19.2014 16.6055 19.0524 16.1584L18.8374 15.5134C18.6477 14.9444 18.9344 14.3262 19.4913 14.1035C20.036 13.8856 20.3084 13.7766 20.5088 13.5946C20.6858 13.4337 20.8218 13.2329 20.9054 13.0088C21 12.7551 21 12.4589 21 11.8663C21 11.3658 21 11.1156 20.9289 10.893C20.866 10.696 20.763 10.5141 20.6265 10.3588C20.4721 10.1833 20.2597 10.0558 19.8348 9.80087L19.5569 9.63416C18.9478 9.26867 18.6939 8.51514 18.9578 7.85558C19.1262 7.43443 19.2105 7.22383 19.232 7.01543C19.2636 6.70926 19.2003 6.40077 19.0506 6.13181C18.9487 5.94875 18.7884 5.78837 18.4676 5.46762C18.1658 5.16584 18.0149 5.01494 17.8426 4.91583C17.5894 4.77024 17.2992 4.70174 17.0076 4.71872C16.8091 4.73029 16.6067 4.79777 16.2018 4.93273L15.6314 5.12287C14.9961 5.33464 14.3058 5.0145 14.0571 4.39272C13.8841 3.96016 13.7976 3.74388 13.6654 3.57511C13.4719 3.32808 13.2058 3.14794 12.9046 3.06005Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
															</svg>
														) : ('')
													}
												</div>
											) : ('')
										}

										{
											showConfig == true ? (
												<div className="row  align-items-center justify-content-start mb-3 ml-0 mr-0 mt-0 col-12">
													<HelloFoo />
												</div>
											) : (
												<div className="row align-items-start justify-content-start m-0">
													{
														nextActivated == false && langKeysReady == true ? (
															<div className='col-6 m-0 p-0'>
																{
																	dataDefaultUnitsReady == true ? (
																		<form className="form-1">
																			{shapesVolumeArray.map((shapeVol, indexShape) => (
																				<div key={shapeVol.id}>
																					<div className="row  align-items-center justify-content-between mt-2 mb-1">
																						<p className='cmx-form-label'>{t('Shape')} {lettersArray[indexShape]}</p>
																						{
																							selectedArrayShapeItem != indexShape ? (
																								<div className="blue-arrow pb-3" onClick={(e) => { setSelectedArrayShapeItem(indexShape) }}>
																									<svg xmlns="http://www.w3.org/2000/svg" width="11" height="4" viewBox="0 0 11 4" fill="none">
																										<path d="M5.5 4L0.73686 0.250001L10.2631 0.25L5.5 4Z" fill="#0003B1" />
																									</svg>
																								</div>

																							) : ('')
																						}
																						{
																							selectedArrayShapeItem == indexShape ? (
																								<div className="row align-items-center justify-content-between">
																									{
																										deleteShapeValid() == true ?
																											(
																												<svg className='mr-3 cursor-pointer' onClick={(e) => { deleteShapeArrayItem(shapeVol.id, indexShape) }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																													<g id="delete_forever" clip-path="url(#clip0_2221_3582)">
																														<path id="Vector" d="M14.12 10.47L12 12.59L9.87 10.47L8.46 11.88L10.59 14L8.47 16.12L9.88 17.53L12 15.41L14.12 17.53L15.53 16.12L13.41 14L15.53 11.88L14.12 10.47ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5ZM6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9Z" fill="#3999FF" />
																													</g>
																													<defs>
																														<clipPath id="clip0_2221_3582">
																															<rect width="24" height="24" fill="white" />
																														</clipPath>
																													</defs>
																												</svg>
																											) :
																											('')
																									}

																									<div className="blue-arrow pb-3" onClick={(e) => { setSelectedArrayShapeItem(indexShape) }}>
																										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																											<path d="M17 14L12 9L7 14L17 14Z" fill="#0003B1" />
																										</svg>
																									</div>
																								</div>
																							) : ('')
																						}
																					</div>
																					{
																						selectedArrayShapeItem == indexShape ? (
																							<div className="row">
																								<div className="d-flex flex-row justify-content-start desktop-slider mb-3 pb-2">
																									{
																										shapeVol.selectedImage == 0 ?
																											(
																												<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(0, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="92" height="42" viewBox="0 0 92 42" fill="none">
																														<path opacity="0.4" d="M30.8401 1L1.37012 17.54V41L30.8401 24.21V1Z" fill="#1203B8" />
																														<path opacity="0.4" d="M91.0001 1H30.8401V24.21H91.0001V1Z" fill="#1203B8" />
																														<path opacity="0.4" d="M61.29 17.54H1V41H61.29V17.54Z" fill="#1203B8" />
																														<path opacity="0.4" d="M91 1L61.29 17.54V41L91 24.21V1Z" fill="#1203B8" />
																														<path d="M1.37012 17.54V41H61.2901L91.0001 24.21V1H30.8401L1.37012 17.54Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M1.37012 17.54H61.2901L91.0001 1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M61.29 41V17.54" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M91.0002 24.21H89.9202" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M87.7802 24.21H30.8402L3.24023 39.93" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M2.31012 40.46L1.37012 41" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M30.8401 24.21V23.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M30.8401 20.79V3.25" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M30.8401 2.08V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																													</svg>
																													<label className='square-1-selected-label col-12 p-1'>{images[0].label}</label>
																												</div>
																											) :
																											(
																												<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(0, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="92" height="42" viewBox="0 0 92 42" fill="none">
																														<path d="M1 17.54V41H61.16L91 24.21V1H30.59L1 17.54Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M1 17.54H61.16L91 1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M61.1599 41V17.54" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M90.9999 24.21H89.9199" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M87.7699 24.21H30.5899L2.87988 39.94" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M1.94 40.46L1 41" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M30.5901 24.21V23.12" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M30.5901 20.79V3.25" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M30.5901 2.08V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																													</svg>
																													<label className='square-1-label col-12 p-1'>{images[0].label}</label>
																												</div>
																											)
																									}
																									{
																										shapeVol.selectedImage == 1 ?
																											(
																												<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(1, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="92" height="56" viewBox="0 0 92 56" fill="none">
																														<path opacity="0.3" d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47556 70.8528 1 46 1C21.1472 1 1 6.47556 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" fill="#0003B8" />
																														<path opacity="0.6" d="M46 55C70.8528 55 91 49.5244 91 42.77C91 36.0155 70.8528 30.54 46 30.54C21.1472 30.54 1 36.0155 1 42.77C1 49.5244 21.1472 55 46 55Z" fill="#0003B8" />
																														<path opacity="0.5" d="M90.83 14.4301V42.7701C90.83 42.7701 92.33 31.8001 46 30.5401C46 30.5401 3.88 30.5401 1 42.7701V15.5501C1 15.5501 6.84 24.9001 46 25.4701C46 25.4701 84.29 25.4701 90.83 14.4301Z" fill="#0003B8" />
																														<path d="M1 42.77C1 42.29 1.1 41.81 1.3 41.35" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M3.04004 39.11C8.75004 34.14 25.77 30.54 45.89 30.54C67.35 30.54 85.3 34.65 89.73 40.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M90.48 41.34C90.68 41.81 90.78 42.28 90.78 42.76" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M45.89 25.46C70.6821 25.46 90.78 19.9844 90.78 13.23C90.78 6.47556 70.6821 1 45.89 1C21.0979 1 1 6.47556 1 13.23C1 19.9844 21.0979 25.46 45.89 25.46Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M1 13.23V42.76C1 49.52 21.1 54.99 45.89 54.99C70.68 54.99 90.78 49.51 90.78 42.76V13.23" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																													</svg>
																													<label className='square-1-selected-label col-12 p-1'>{images[1].label}</label>
																												</div>
																											) :
																											(
																												<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(1, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="92" height="56" viewBox="0 0 92 56" fill="none">
																														<path d="M1 42.77C1 42.29 1.1 41.81 1.3 41.34" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M3.05005 39.1C8.78005 34.13 25.84 30.53 46 30.53C67.51 30.53 85.5 34.63 89.95 40.12" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M90.7 41.34C90.9 41.81 91 42.28 91 42.77" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47555 70.8528 1 46 1C21.1472 1 1 6.47555 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M1 13.23V42.76C1 49.52 21.15 54.99 46 54.99C70.85 54.99 91 49.51 91 42.76V13.23" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																													</svg>
																													<label className='square-1-label col-12 p-1'>{images[1].label}</label>
																												</div>
																											)
																									}
																									{
																										shapeVol.selectedImage == 2 ?
																											(
																												<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(2, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="92" height="56" viewBox="0 0 92 56" fill="none">
																														<path opacity="0.3" d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47556 70.8528 1 46 1C21.1472 1 1 6.47556 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" fill="#0003B8" />
																														<path opacity="0.6" d="M46 55C70.8528 55 91 49.5244 91 42.77C91 36.0155 70.8528 30.54 46 30.54C21.1472 30.54 1 36.0155 1 42.77C1 49.5244 21.1472 55 46 55Z" fill="#0003B8" />
																														<path opacity="0.5" d="M90.83 14.4301V42.7701C90.83 42.7701 92.33 31.8001 46 30.5401C46 30.5401 3.88 30.5401 1 42.7701V15.5501C1 15.5501 6.84 24.9001 46 25.4701C46 25.4701 84.29 25.4701 90.83 14.4301Z" fill="#0003B8" />
																														<path d="M15.9199 43.3401C15.9199 42.8401 16.1699 42.3601 16.6299 41.8901" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																														<path d="M19.3398 40.2501C24.3698 38.1301 34.4198 36.6801 45.9998 36.6801C58.8098 36.6801 69.7398 38.4501 74.0798 40.9401" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																														<path d="M75.3599 41.8901C75.8299 42.3601 76.0699 42.8401 76.0699 43.3401" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																														<path d="M45.9999 19.35C62.6126 19.35 76.0799 16.3727 76.0799 12.7C76.0799 9.02735 62.6126 6.05005 45.9999 6.05005C29.3872 6.05005 15.9199 9.02735 15.9199 12.7C15.9199 16.3727 29.3872 19.35 45.9999 19.35Z" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M15.9199 13.1801V42.6601C15.9199 46.3301 29.3899 49.3101 45.9999 49.3101C62.6099 49.3101 76.0799 46.3301 76.0799 42.6601V13.1801" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M1.11011 42.77C1.11011 42.29 1.21011 41.81 1.41011 41.35" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M3.15015 39.11C8.86015 34.14 25.8802 30.54 46.0002 30.54C67.4602 30.54 85.4101 34.65 89.8401 40.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M90.5901 41.34C90.7901 41.81 90.8901 42.28 90.8901 42.76" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																														<path d="M46.0001 25.46C70.7922 25.46 90.8901 19.9844 90.8901 13.23C90.8901 6.47556 70.7922 1 46.0001 1C21.208 1 1.11011 6.47556 1.11011 13.23C1.11011 19.9844 21.208 25.46 46.0001 25.46Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M1.11011 13.23V42.76C1.11011 49.52 21.2101 54.99 46.0001 54.99C70.7901 54.99 90.8901 49.51 90.8901 42.76V13.23" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path opacity="0.15" d="M45.9999 49.16C62.6126 49.16 76.0799 46.326 76.0799 42.83C76.0799 39.334 62.6126 36.5 45.9999 36.5C29.3872 36.5 15.9199 39.334 15.9199 42.83C15.9199 46.326 29.3872 49.16 45.9999 49.16Z" fill="#0003B8" />
																														<path opacity="0.25" d="M45.9999 19.03C62.6126 19.03 76.0799 16.196 76.0799 12.7C76.0799 9.20403 62.6126 6.37 45.9999 6.37C29.3872 6.37 15.9199 9.20403 15.9199 12.7C15.9199 16.196 29.3872 19.03 45.9999 19.03Z" fill="#0003B8" />
																													</svg>
																													<label className='square-1-selected-label col-12 p-1'>{images[2].label}</label>
																												</div>
																											) :
																											(
																												<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(2, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="92" height="56" viewBox="0 0 92 56" fill="none">
																														<path d="M1 42.77C1 36.01 21.15 30.54 46 30.54C70.85 30.54 91 36.02 91 42.77" stroke="#0003B8" stroke-miterlimit="10" stroke-dasharray="2 2" />
																														<path d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47555 70.8528 1 46 1C21.1472 1 1 6.47555 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" stroke="#0003B8" stroke-miterlimit="10" />
																														<path d="M1 13.23V42.76C1 49.52 21.15 54.99 46 54.99C70.85 54.99 91 49.51 91 42.76V13.23" stroke="#0003B8" stroke-miterlimit="10" />
																														<path d="M15.8501 43.34C15.8501 39.67 29.3501 36.69 46.0001 36.69C62.6501 36.69 76.1501 39.67 76.1501 43.34" stroke="#0003B8" stroke-miterlimit="10" stroke-dasharray="2 2" />
																														<path d="M46.0001 19.35C62.6515 19.35 76.1501 16.3727 76.1501 12.7C76.1501 9.02729 62.6515 6.04999 46.0001 6.04999C29.3487 6.04999 15.8501 9.02729 15.8501 12.7C15.8501 16.3727 29.3487 19.35 46.0001 19.35Z" stroke="#0003B8" stroke-miterlimit="10" />
																														<path d="M15.8501 13.18V42.66C15.8501 46.33 29.3501 49.31 46.0001 49.31C62.6501 49.31 76.1501 46.33 76.1501 42.66V13.18" stroke="#0003B8" stroke-miterlimit="10" />
																													</svg>
																													<label className='square-1-label col-12 p-1'>{images[2].label}</label>
																												</div>
																											)
																									}


																									{
																										shapeVol.selectedImage == 3 ?
																											(
																												<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(3, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="92" height="42" viewBox="0 0 92 42" fill="none">
																														<path opacity="0.3" d="M83.65 9.58997H1V41H83.65V9.58997Z" fill="#0003B8" />
																														<path opacity="0.6" d="M90.9999 1L83.6499 9.59V41L90.9999 32.41V1Z" fill="#0003B8" />
																														<path opacity="0.5" d="M8.42001 1L1 9.59H83.65L91 1H8.42001Z" fill="#0003B8" />
																														<path d="M83.65 9.58997H1V41H83.65V9.58997Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M83.6499 41L90.9999 32.41V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M83.58 9.59L91 1H8.42001L1 9.59" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																													</svg>
																													<label className='square-1-selected-label col-12 p-1'>{images[3].label}</label>
																												</div>
																											) :
																											(
																												<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(3, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="92" height="42" viewBox="0 0 92 42" fill="none">
																														<path d="M83.65 9.58997H1V41H83.65V9.58997Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M83.6499 41L90.9999 32.41V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M83.58 9.59L91 1H8.42001L1 9.59" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																													</svg>
																													<label className='square-1-label col-12 p-1'>{images[3].label}</label>
																												</div>
																											)
																									}


																									{
																										shapeVol.selectedImage == 4 ?
																											(
																												<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(4, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="92" height="30" viewBox="0 0 92 30" fill="none">
																														<path opacity="0.3" d="M71.7799 19.95H1.3999V29H71.7799V19.95Z" fill="#0003B8" />
																														<path opacity="0.6" d="M91 10.05V1L71.77 19.95V29L91 10.05Z" fill="#0003B8" />
																														<path opacity="0.5" d="M20.07 1.27001L1 19.96H71.38L90.61 1.01001L20.08 1.28001L20.07 1.27001ZM68.77 16.61H9.82001L22.25 4.51001L80.99 4.65001L68.77 16.61Z" fill="#0003B8" />
																														<path opacity="0.7" d="M20.62 6.48999V10.05L14.15 16.39H10.22L20.62 6.48999Z" fill="#0003B8" />
																														<path opacity="0.7" d="M75.4801 10.05L81.3901 4.65002L22.6501 4.52002L20.6201 6.49002V10.05H75.4801Z" fill="#0003B8" />
																														<path d="M71.7799 19.95H1.3999V29H71.7799V19.95Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M90.5799 1L71.7699 19.95H1.3999L20.4699 1.27L90.5799 1Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M69.1599 16.61H10.22L22.65 4.52002H81.52L69.1599 16.61Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M91 1V10.05L71.77 29V19.95" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M20.6199 6.48999V10.05L75.9999 9.92999" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M14.0598 16.61L20.6198 10.05" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																													</svg>
																													<label className='square-1-selected-label col-12 p-1'>{images[4].label}</label>
																												</div>
																											) :
																											(
																												<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(4, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="92" height="30" viewBox="0 0 92 30" fill="none">
																														<path d="M71.69 19.95H1V29H71.69V19.95Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M1 19.95L20.16 1.27L90.57 1L71.69 19.95" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M69.0699 16.61H9.85986L22.3499 4.52002H81.4799L69.0699 16.61Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M90.9999 1V10.05L71.6899 29V19.95" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M20.3101 6.48999V10.05L75.9301 9.92998" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																														<path d="M13.71 16.61L20.31 10.05" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																													</svg>
																													<label className='square-1-label col-12 p-1'>{images[4].label}</label>
																												</div>
																											)
																									}

																									{
																										shapeVol.selectedImage == 5 ?
																											(
																												<div className='m-1 p-3 square-1-selected row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(5, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="90" height="60" viewBox="0 0 310 310" fill="none">
																														<line x1="3.67224" y1="155.012" x2="2.49996" y2="305.007" stroke="#0000B3" stroke-width="3" />
																														<line x1="211" y1="306.5" x2="1" y2="306.5" stroke="#0000B3" stroke-width="3" />
																														<path d="M72 155L2 155" stroke="#0000B3" stroke-width="3" />
																														<line x1="141" y1="206.5" x2="71" y2="206.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="211" y1="255.5" x2="141" y2="255.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="294" y1="131.5" x2="224" y2="131.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="225" y1="81.5001" x2="155" y2="81.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="156" y1="30.5001" x2="86" y2="30.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="70.5" y1="205" x2="70.5" y2="155" stroke="#0000B3" stroke-width="3" />
																														<path d="M141 255V205" stroke="#0000B3" stroke-width="3" />
																														<line x1="209.5" y1="305" x2="209.5" y2="255" stroke="#0000B3" stroke-width="3" />
																														<line x1="223.5" y1="130" x2="223.5" y2="80" stroke="#0000B3" stroke-width="3" />
																														<line x1="236" y1="129.5" x2="226" y2="129.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="236" y1="82.5" x2="226" y2="82.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="229.5" y1="128" x2="229.5" y2="81" stroke="#0000B3" stroke-width="3" />
																														<line x1="225.5" y1="67" x2="225.5" y2="77" stroke="#0000B3" stroke-width="3" />
																														<line x1="158.5" y1="67" x2="158.5" y2="77" stroke="#0000B3" stroke-width="3" />
																														<line x1="224" y1="73.5" x2="157" y2="73.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="156.5" y1="13" x2="156.5" y2="23" stroke="#0000B3" stroke-width="3" />
																														<line x1="89.5" y1="13" x2="89.5" y2="23" stroke="#0000B3" stroke-width="3" />
																														<line x1="155" y1="19.5" x2="88" y2="19.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="154.5" y1="80" x2="154.5" y2="30" stroke="#0000B3" stroke-width="3" />
																														<line x1="1.75328" y1="153.838" x2="85.1608" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																														<line x1="70.7533" y1="153.838" x2="154.161" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																														<line x1="70.7533" y1="204.838" x2="154.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																														<line x1="139.753" y1="204.838" x2="223.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																														<line x1="140.753" y1="253.838" x2="224.161" y2="129.166" stroke="#0000B3" stroke-width="3" />
																														<line x1="225.5" y1="302" x2="225.5" y2="312" stroke="#0000B3" stroke-width="3" />
																														<line x1="307.5" y1="189" x2="307.5" y2="179" stroke="#0000B3" stroke-width="3" />
																														<line x1="293.5" y1="180" x2="293.5" y2="130" stroke="#0000B3" stroke-width="3" />
																														<line x1="209.753" y1="254.838" x2="293.161" y2="130.166" stroke="#0000B3" stroke-width="3" />
																														<line x1="209.757" y1="304.161" x2="294.164" y2="179.161" stroke="#0000B3" stroke-width="3" />
																														<line x1="223.757" y1="307.161" x2="308.164" y2="182.161" stroke="#0000B3" stroke-width="3" />
																														<path d="M269.202 258L267.213 250.727H268.108L269.628 256.651H269.699L271.247 250.727H272.241L273.79 256.651H273.861L275.381 250.727H276.276L274.287 258H273.378L271.773 252.205H271.716L270.111 258H269.202ZM277.259 258V252.545H278.097V258H277.259ZM277.685 251.636C277.522 251.636 277.381 251.581 277.263 251.469C277.147 251.358 277.089 251.224 277.089 251.068C277.089 250.912 277.147 250.778 277.263 250.667C277.381 250.556 277.522 250.5 277.685 250.5C277.849 250.5 277.988 250.556 278.104 250.667C278.223 250.778 278.282 250.912 278.282 251.068C278.282 251.224 278.223 251.358 278.104 251.469C277.988 251.581 277.849 251.636 277.685 251.636ZM281.692 258.114C281.237 258.114 280.836 257.999 280.488 257.769C280.14 257.537 279.868 257.21 279.671 256.789C279.475 256.365 279.377 255.865 279.377 255.287C279.377 254.714 279.475 254.217 279.671 253.795C279.868 253.374 280.141 253.049 280.492 252.819C280.842 252.589 281.247 252.474 281.706 252.474C282.061 252.474 282.342 252.534 282.548 252.652C282.756 252.768 282.915 252.901 283.024 253.05C283.135 253.196 283.221 253.317 283.283 253.412H283.354V250.727H284.192V258H283.382V257.162H283.283C283.221 257.261 283.134 257.387 283.02 257.538C282.906 257.687 282.744 257.821 282.534 257.94C282.323 258.056 282.042 258.114 281.692 258.114ZM281.806 257.361C282.142 257.361 282.426 257.273 282.658 257.098C282.89 256.92 283.066 256.675 283.187 256.363C283.308 256.048 283.368 255.685 283.368 255.273C283.368 254.866 283.309 254.509 283.191 254.204C283.072 253.896 282.897 253.657 282.665 253.487C282.433 253.314 282.146 253.227 281.806 253.227C281.45 253.227 281.155 253.318 280.918 253.501C280.683 253.681 280.507 253.926 280.389 254.236C280.273 254.544 280.215 254.889 280.215 255.273C280.215 255.661 280.274 256.014 280.392 256.331C280.513 256.646 280.691 256.897 280.925 257.084C281.162 257.268 281.455 257.361 281.806 257.361ZM288.215 252.545V253.256H285.389V252.545H288.215ZM286.213 251.239H287.051V256.438C287.051 256.674 287.085 256.852 287.154 256.97C287.225 257.086 287.315 257.164 287.423 257.205C287.535 257.242 287.652 257.261 287.775 257.261C287.867 257.261 287.943 257.257 288.002 257.247C288.061 257.235 288.109 257.226 288.144 257.219L288.315 257.972C288.258 257.993 288.179 258.014 288.077 258.036C287.975 258.059 287.846 258.071 287.69 258.071C287.453 258.071 287.221 258.02 286.994 257.918C286.769 257.817 286.582 257.661 286.433 257.453C286.286 257.245 286.213 256.982 286.213 256.665V251.239ZM290.431 254.719V258H289.593V250.727H290.431V253.398H290.502C290.63 253.116 290.822 252.892 291.078 252.727C291.336 252.558 291.679 252.474 292.107 252.474C292.479 252.474 292.805 252.549 293.084 252.698C293.363 252.845 293.58 253.071 293.734 253.376C293.89 253.679 293.968 254.065 293.968 254.534V258H293.13V254.591C293.13 254.158 293.018 253.823 292.793 253.586C292.57 253.347 292.261 253.227 291.866 253.227C291.591 253.227 291.345 253.285 291.127 253.401C290.912 253.517 290.741 253.687 290.616 253.909C290.493 254.132 290.431 254.402 290.431 254.719Z" fill="#0000B3" />
																														<path d="M233.881 108V100.727H236.338C236.906 100.727 237.373 100.824 237.737 101.018C238.102 101.21 238.372 101.474 238.547 101.81C238.722 102.147 238.81 102.529 238.81 102.957C238.81 103.386 238.722 103.766 238.547 104.097C238.372 104.429 238.103 104.689 237.741 104.879C237.379 105.066 236.916 105.159 236.352 105.159H234.364V104.364H236.324C236.712 104.364 237.025 104.307 237.261 104.193C237.5 104.08 237.673 103.919 237.78 103.71C237.889 103.5 237.943 103.249 237.943 102.957C237.943 102.666 237.889 102.412 237.78 102.194C237.671 101.976 237.497 101.808 237.258 101.69C237.019 101.569 236.703 101.509 236.31 101.509H234.761V108H233.881ZM237.304 104.733L239.094 108H238.071L236.31 104.733H237.304ZM240.164 108V102.545H241.002V108H240.164ZM240.59 101.636C240.426 101.636 240.285 101.581 240.167 101.469C240.051 101.358 239.993 101.224 239.993 101.068C239.993 100.912 240.051 100.778 240.167 100.667C240.285 100.556 240.426 100.5 240.59 100.5C240.753 100.5 240.893 100.556 241.009 100.667C241.127 100.778 241.186 100.912 241.186 101.068C241.186 101.224 241.127 101.358 241.009 101.469C240.893 101.581 240.753 101.636 240.59 101.636ZM246.4 103.767L245.647 103.98C245.6 103.855 245.53 103.733 245.438 103.614C245.348 103.494 245.225 103.394 245.069 103.316C244.912 103.238 244.712 103.199 244.468 103.199C244.135 103.199 243.856 103.276 243.634 103.43C243.414 103.581 243.304 103.774 243.304 104.009C243.304 104.217 243.379 104.381 243.531 104.502C243.682 104.623 243.919 104.723 244.241 104.804L245.051 105.003C245.538 105.121 245.902 105.302 246.141 105.546C246.38 105.788 246.5 106.099 246.5 106.48C246.5 106.793 246.41 107.072 246.23 107.318C246.052 107.564 245.804 107.759 245.484 107.901C245.164 108.043 244.793 108.114 244.369 108.114C243.813 108.114 243.352 107.993 242.988 107.751C242.623 107.51 242.392 107.157 242.295 106.693L243.091 106.494C243.166 106.788 243.31 107.008 243.52 107.155C243.733 107.302 244.011 107.375 244.355 107.375C244.745 107.375 245.056 107.292 245.285 107.126C245.517 106.958 245.633 106.757 245.633 106.523C245.633 106.333 245.567 106.175 245.434 106.047C245.302 105.917 245.098 105.82 244.824 105.756L243.914 105.543C243.415 105.424 243.048 105.241 242.814 104.992C242.582 104.741 242.466 104.428 242.466 104.051C242.466 103.743 242.552 103.471 242.725 103.234C242.9 102.998 243.138 102.812 243.439 102.677C243.742 102.542 244.085 102.474 244.468 102.474C245.008 102.474 245.432 102.593 245.74 102.83C246.05 103.066 246.27 103.379 246.4 103.767ZM250.048 108.114C249.523 108.114 249.069 107.998 248.688 107.766C248.309 107.531 248.017 107.205 247.811 106.786C247.607 106.364 247.506 105.874 247.506 105.315C247.506 104.757 247.607 104.264 247.811 103.838C248.017 103.41 248.303 103.076 248.67 102.837C249.04 102.595 249.47 102.474 249.963 102.474C250.247 102.474 250.528 102.522 250.805 102.616C251.081 102.711 251.334 102.865 251.561 103.078C251.788 103.289 251.969 103.568 252.104 103.916C252.239 104.264 252.307 104.693 252.307 105.202V105.557H248.102V104.832H251.454C251.454 104.525 251.393 104.25 251.27 104.009C251.149 103.767 250.976 103.576 250.751 103.437C250.529 103.297 250.266 103.227 249.963 103.227C249.629 103.227 249.34 103.31 249.096 103.476C248.855 103.639 248.669 103.852 248.539 104.115C248.409 104.378 248.344 104.66 248.344 104.96V105.443C248.344 105.855 248.415 106.204 248.557 106.491C248.701 106.775 248.901 106.991 249.157 107.141C249.412 107.287 249.71 107.361 250.048 107.361C250.268 107.361 250.467 107.33 250.645 107.268C250.825 107.205 250.98 107.11 251.11 106.984C251.24 106.857 251.341 106.698 251.412 106.509L252.221 106.736C252.136 107.01 251.993 107.252 251.792 107.46C251.59 107.666 251.342 107.827 251.046 107.943C250.75 108.057 250.417 108.114 250.048 108.114Z" fill="#0000B3" />
																														<path d="M176.881 67V59.7273H179.338C179.906 59.7273 180.373 59.8243 180.737 60.0185C181.102 60.2102 181.372 60.4742 181.547 60.8104C181.722 61.1465 181.81 61.5289 181.81 61.9574C181.81 62.3859 181.722 62.7659 181.547 63.0973C181.372 63.4287 181.103 63.6892 180.741 63.8786C180.379 64.0656 179.916 64.1591 179.352 64.1591H177.364V63.3636H179.324C179.712 63.3636 180.025 63.3068 180.261 63.1932C180.5 63.0795 180.673 62.9186 180.78 62.7102C180.889 62.4995 180.943 62.2486 180.943 61.9574C180.943 61.6662 180.889 61.4117 180.78 61.1939C180.671 60.9761 180.497 60.808 180.258 60.6896C180.019 60.5689 179.703 60.5085 179.31 60.5085H177.761V67H176.881ZM180.304 63.733L182.094 67H181.071L179.31 63.733H180.304ZM186.601 64.7699V61.5455H187.439V67H186.601V66.0767H186.544C186.416 66.3537 186.218 66.5893 185.948 66.7834C185.678 66.9751 185.337 67.071 184.925 67.071C184.584 67.071 184.281 66.9964 184.016 66.8473C183.751 66.6958 183.542 66.4685 183.391 66.1655C183.239 65.8601 183.164 65.4754 183.164 65.0114V61.5455H184.002V64.9545C184.002 65.3523 184.113 65.6695 184.335 65.9062C184.56 66.143 184.847 66.2614 185.195 66.2614C185.403 66.2614 185.615 66.2081 185.83 66.1016C186.048 65.995 186.231 65.8317 186.377 65.6115C186.526 65.3913 186.601 65.1108 186.601 64.7699ZM189.812 63.7188V67H188.974V61.5455H189.784V62.3977H189.855C189.983 62.1207 190.177 61.8982 190.437 61.7301C190.698 61.5597 191.034 61.4744 191.446 61.4744C191.815 61.4744 192.138 61.5502 192.415 61.7017C192.692 61.8509 192.908 62.0781 193.061 62.3835C193.215 62.6866 193.292 63.0701 193.292 63.5341V67H192.454V63.5909C192.454 63.1624 192.343 62.8286 192.12 62.5895C191.898 62.348 191.592 62.2273 191.204 62.2273C190.937 62.2273 190.698 62.2853 190.487 62.4013C190.279 62.5173 190.114 62.6866 189.993 62.9091C189.873 63.1316 189.812 63.4015 189.812 63.7188Z" fill="#0000B3" />
																														<path d="M88.7098 8V0.727273H91.1672C91.7377 0.727273 92.2041 0.830255 92.5663 1.03622C92.9309 1.23982 93.2008 1.51562 93.376 1.86364C93.5512 2.21165 93.6388 2.59991 93.6388 3.02841C93.6388 3.45691 93.5512 3.84635 93.376 4.19673C93.2032 4.54711 92.9356 4.82647 92.5734 5.0348C92.2112 5.24077 91.7472 5.34375 91.1814 5.34375H89.42V4.5625H91.153C91.5436 4.5625 91.8573 4.49503 92.094 4.36009C92.3308 4.22514 92.5024 4.04285 92.6089 3.81321C92.7178 3.5812 92.7723 3.3196 92.7723 3.02841C92.7723 2.73722 92.7178 2.4768 92.6089 2.24716C92.5024 2.01752 92.3296 1.83759 92.0905 1.70739C91.8514 1.57481 91.5341 1.50852 91.1388 1.50852H89.5905V8H88.7098ZM95.7819 0.727273V8H94.9438V0.727273H95.7819ZM98.922 8.12784C98.5763 8.12784 98.2626 8.06274 97.9809 7.93253C97.6992 7.79995 97.4755 7.60938 97.3097 7.3608C97.144 7.10985 97.0612 6.80682 97.0612 6.4517C97.0612 6.1392 97.1227 5.88589 97.2458 5.69176C97.3689 5.49527 97.5335 5.34138 97.7394 5.23011C97.9454 5.11884 98.1727 5.03598 98.4213 4.98153C98.6722 4.92472 98.9243 4.87973 99.1776 4.84659C99.5091 4.80398 99.7778 4.77202 99.9838 4.75071C100.192 4.72704 100.344 4.68797 100.438 4.63352C100.535 4.57907 100.584 4.48437 100.584 4.34943V4.32102C100.584 3.97064 100.488 3.69839 100.296 3.50426C100.107 3.31013 99.8192 3.21307 99.4333 3.21307C99.0332 3.21307 98.7195 3.30066 98.4923 3.47585C98.265 3.65104 98.1052 3.83807 98.0129 4.03693L97.2174 3.75284C97.3595 3.4214 97.5489 3.16335 97.7856 2.97869C98.0247 2.79167 98.2851 2.66146 98.5669 2.58807C98.8509 2.51231 99.1303 2.47443 99.4049 2.47443C99.5801 2.47443 99.7813 2.49574 100.009 2.53835C100.238 2.5786 100.46 2.66264 100.673 2.79048C100.888 2.91832 101.067 3.11127 101.209 3.36932C101.351 3.62737 101.422 3.97301 101.422 4.40625V8H100.584V7.26136H100.541C100.484 7.37973 100.39 7.50639 100.257 7.64134C100.125 7.77628 99.9482 7.8911 99.7281 7.9858C99.5079 8.08049 99.2392 8.12784 98.922 8.12784ZM99.0498 7.375C99.3812 7.375 99.6606 7.3099 99.8879 7.17969C100.118 7.04948 100.29 6.88139 100.406 6.67543C100.525 6.46946 100.584 6.25284 100.584 6.02557V5.25852C100.548 5.30114 100.47 5.3402 100.35 5.37571C100.231 5.40885 100.094 5.43845 99.9376 5.46449C99.7837 5.48816 99.6334 5.50947 99.4866 5.52841C99.3422 5.54498 99.225 5.55919 99.135 5.57102C98.9172 5.59943 98.7136 5.6456 98.5242 5.70952C98.3372 5.77107 98.1857 5.86458 98.0697 5.99006C97.9561 6.11316 97.8992 6.28125 97.8992 6.49432C97.8992 6.78551 98.007 7.00568 98.2224 7.15483C98.4402 7.30161 98.716 7.375 99.0498 7.375ZM105.324 2.54545V3.25568H102.497V2.54545H105.324ZM103.321 1.23864H104.159V6.4375C104.159 6.67424 104.193 6.8518 104.262 6.97017C104.333 7.08617 104.423 7.1643 104.532 7.20455C104.643 7.24242 104.76 7.26136 104.883 7.26136C104.976 7.26136 105.052 7.25663 105.111 7.24716C105.17 7.23532 105.217 7.22585 105.253 7.21875L105.423 7.97159C105.366 7.9929 105.287 8.0142 105.185 8.03551C105.083 8.05919 104.954 8.07102 104.798 8.07102C104.561 8.07102 104.329 8.02012 104.102 7.91832C103.877 7.81652 103.69 7.66146 103.541 7.45312C103.394 7.24479 103.321 6.98201 103.321 6.66477V1.23864ZM109.013 2.54545V3.25568H106.073V2.54545H109.013ZM106.954 8V1.79261C106.954 1.48011 107.027 1.2197 107.174 1.01136C107.321 0.80303 107.511 0.64678 107.746 0.542613C107.98 0.438446 108.227 0.386363 108.488 0.386363C108.694 0.386363 108.862 0.402935 108.992 0.436079C109.122 0.469223 109.219 0.5 109.283 0.528409L109.042 1.25284C108.999 1.23864 108.94 1.22088 108.864 1.19957C108.791 1.17827 108.694 1.16761 108.573 1.16761C108.296 1.16761 108.096 1.23745 107.973 1.37713C107.852 1.51681 107.792 1.72159 107.792 1.99148V8H106.954ZM112.179 8.11364C111.687 8.11364 111.255 7.99645 110.883 7.76207C110.514 7.5277 110.225 7.19981 110.017 6.77841C109.811 6.35701 109.708 5.86458 109.708 5.30114C109.708 4.73295 109.811 4.23698 110.017 3.81321C110.225 3.38944 110.514 3.06037 110.883 2.82599C111.255 2.59162 111.687 2.47443 112.179 2.47443C112.672 2.47443 113.103 2.59162 113.472 2.82599C113.844 3.06037 114.132 3.38944 114.338 3.81321C114.547 4.23698 114.651 4.73295 114.651 5.30114C114.651 5.86458 114.547 6.35701 114.338 6.77841C114.132 7.19981 113.844 7.5277 113.472 7.76207C113.103 7.99645 112.672 8.11364 112.179 8.11364ZM112.179 7.3608C112.553 7.3608 112.861 7.26491 113.103 7.07315C113.344 6.88139 113.523 6.62926 113.639 6.31676C113.755 6.00426 113.813 5.66572 113.813 5.30114C113.813 4.93655 113.755 4.59683 113.639 4.28196C113.523 3.96709 113.344 3.71259 113.103 3.51847C112.861 3.32434 112.553 3.22727 112.179 3.22727C111.805 3.22727 111.497 3.32434 111.256 3.51847C111.014 3.71259 110.836 3.96709 110.72 4.28196C110.604 4.59683 110.546 4.93655 110.546 5.30114C110.546 5.66572 110.604 6.00426 110.72 6.31676C110.836 6.62926 111.014 6.88139 111.256 7.07315C111.497 7.26491 111.805 7.3608 112.179 7.3608ZM115.93 8V2.54545H116.74V3.36932H116.797C116.896 3.09943 117.076 2.88045 117.336 2.71236C117.597 2.54427 117.89 2.46023 118.217 2.46023C118.279 2.46023 118.356 2.46141 118.448 2.46378C118.54 2.46615 118.61 2.4697 118.657 2.47443V3.3267C118.629 3.3196 118.564 3.30895 118.462 3.29474C118.363 3.27817 118.257 3.26989 118.146 3.26989C117.881 3.26989 117.644 3.32552 117.436 3.43679C117.23 3.54569 117.066 3.69721 116.946 3.89134C116.827 4.0831 116.768 4.30208 116.768 4.5483V8H115.93ZM119.651 8V2.54545H120.46V3.39773H120.532C120.645 3.10653 120.829 2.88045 121.082 2.71946C121.335 2.55611 121.639 2.47443 121.995 2.47443C122.354 2.47443 122.654 2.55611 122.893 2.71946C123.134 2.88045 123.323 3.10653 123.458 3.39773H123.514C123.654 3.116 123.864 2.89228 124.143 2.72656C124.422 2.55848 124.757 2.47443 125.148 2.47443C125.636 2.47443 126.035 2.62713 126.345 2.93253C126.655 3.23556 126.81 3.70786 126.81 4.34943V8H125.972V4.34943C125.972 3.94697 125.862 3.65933 125.642 3.48651C125.421 3.31368 125.162 3.22727 124.864 3.22727C124.48 3.22727 124.183 3.34328 123.973 3.57528C123.762 3.80492 123.657 4.09612 123.657 4.44886V8H122.804V4.2642C122.804 3.95407 122.704 3.70431 122.502 3.51491C122.301 3.32315 122.042 3.22727 121.725 3.22727C121.507 3.22727 121.303 3.28527 121.114 3.40128C120.927 3.51728 120.775 3.67827 120.659 3.88423C120.546 4.08783 120.489 4.32339 120.489 4.59091V8H119.651ZM133.214 8.11364C132.76 8.11364 132.359 7.99882 132.011 7.76918C131.663 7.53717 131.39 7.21046 131.194 6.78906C130.997 6.36529 130.899 5.86458 130.899 5.28693C130.899 4.71402 130.997 4.21686 131.194 3.79545C131.39 3.37405 131.664 3.04853 132.014 2.81889C132.364 2.58925 132.769 2.47443 133.229 2.47443C133.584 2.47443 133.864 2.53362 134.07 2.65199C134.279 2.76799 134.437 2.90057 134.546 3.04972C134.657 3.1965 134.744 3.31723 134.805 3.41193H134.876V0.727273H135.714V8H134.905V7.16193H134.805C134.744 7.26136 134.656 7.38684 134.543 7.53835C134.429 7.6875 134.267 7.82126 134.056 7.93963C133.845 8.05563 133.565 8.11364 133.214 8.11364ZM133.328 7.3608C133.664 7.3608 133.948 7.2732 134.18 7.09801C134.412 6.92045 134.589 6.67543 134.709 6.36293C134.83 6.04806 134.891 5.68466 134.891 5.27273C134.891 4.86553 134.831 4.50923 134.713 4.20384C134.595 3.89607 134.419 3.65696 134.187 3.48651C133.955 3.31368 133.669 3.22727 133.328 3.22727C132.973 3.22727 132.677 3.31842 132.44 3.50071C132.206 3.68063 132.03 3.92566 131.911 4.2358C131.795 4.54356 131.737 4.8892 131.737 5.27273C131.737 5.66098 131.796 6.01373 131.915 6.33097C132.035 6.64583 132.213 6.89678 132.447 7.08381C132.684 7.26847 132.978 7.3608 133.328 7.3608ZM139.653 8.11364C139.127 8.11364 138.674 7.99763 138.293 7.76562C137.914 7.53125 137.621 7.20455 137.415 6.78551C137.212 6.36411 137.11 5.87405 137.11 5.31534C137.11 4.75663 137.212 4.2642 137.415 3.83807C137.621 3.40956 137.908 3.07576 138.275 2.83665C138.644 2.59517 139.075 2.47443 139.567 2.47443C139.851 2.47443 140.132 2.52178 140.409 2.61648C140.686 2.71117 140.938 2.86506 141.165 3.07812C141.393 3.28883 141.574 3.56818 141.709 3.91619C141.844 4.2642 141.911 4.69271 141.911 5.2017V5.55682H137.707V4.83239H141.059C141.059 4.52462 140.997 4.25 140.874 4.00852C140.753 3.76705 140.581 3.57647 140.356 3.43679C140.133 3.29711 139.87 3.22727 139.567 3.22727C139.234 3.22727 138.945 3.31013 138.701 3.47585C138.459 3.6392 138.274 3.85227 138.143 4.11506C138.013 4.37784 137.948 4.65956 137.948 4.96023V5.44318C137.948 5.85511 138.019 6.20431 138.161 6.49077C138.306 6.77486 138.506 6.99148 138.761 7.14062C139.017 7.28741 139.314 7.3608 139.653 7.3608C139.873 7.3608 140.072 7.33002 140.249 7.26847C140.429 7.20455 140.584 7.10985 140.714 6.98438C140.845 6.85653 140.945 6.69792 141.016 6.50852L141.826 6.7358C141.741 7.01042 141.597 7.25189 141.396 7.46023C141.195 7.66619 140.946 7.82718 140.65 7.94318C140.355 8.05682 140.022 8.11364 139.653 8.11364ZM143.186 10.0455V2.54545H143.996V3.41193H144.095C144.157 3.31723 144.242 3.1965 144.351 3.04972C144.462 2.90057 144.621 2.76799 144.827 2.65199C145.035 2.53362 145.317 2.47443 145.672 2.47443C146.131 2.47443 146.536 2.58925 146.886 2.81889C147.237 3.04853 147.51 3.37405 147.707 3.79545C147.903 4.21686 148.001 4.71402 148.001 5.28693C148.001 5.86458 147.903 6.36529 147.707 6.78906C147.51 7.21046 147.238 7.53717 146.89 7.76918C146.542 7.99882 146.141 8.11364 145.686 8.11364C145.336 8.11364 145.055 8.05563 144.844 7.93963C144.634 7.82126 144.472 7.6875 144.358 7.53835C144.244 7.38684 144.157 7.26136 144.095 7.16193H144.024V10.0455H143.186ZM144.01 5.27273C144.01 5.68466 144.07 6.04806 144.191 6.36293C144.312 6.67543 144.488 6.92045 144.72 7.09801C144.952 7.2732 145.236 7.3608 145.572 7.3608C145.923 7.3608 146.215 7.26847 146.449 7.08381C146.686 6.89678 146.864 6.64583 146.982 6.33097C147.103 6.01373 147.163 5.66098 147.163 5.27273C147.163 4.8892 147.104 4.54356 146.986 4.2358C146.87 3.92566 146.693 3.68063 146.457 3.50071C146.222 3.31842 145.927 3.22727 145.572 3.22727C145.231 3.22727 144.945 3.31368 144.713 3.48651C144.481 3.65696 144.306 3.89607 144.187 4.20384C144.069 4.50923 144.01 4.86553 144.01 5.27273ZM151.652 2.54545V3.25568H148.825V2.54545H151.652ZM149.649 1.23864H150.487V6.4375C150.487 6.67424 150.521 6.8518 150.59 6.97017C150.661 7.08617 150.751 7.1643 150.86 7.20455C150.971 7.24242 151.088 7.26136 151.212 7.26136C151.304 7.26136 151.38 7.25663 151.439 7.24716C151.498 7.23532 151.545 7.22585 151.581 7.21875L151.751 7.97159C151.695 7.9929 151.615 8.0142 151.513 8.03551C151.412 8.05919 151.283 8.07102 151.126 8.07102C150.89 8.07102 150.658 8.02012 150.43 7.91832C150.205 7.81652 150.018 7.66146 149.869 7.45312C149.722 7.24479 149.649 6.98201 149.649 6.66477V1.23864ZM153.868 4.71875V8H153.03V0.727273H153.868V3.39773H153.939C154.067 3.116 154.258 2.89228 154.514 2.72656C154.772 2.55848 155.115 2.47443 155.544 2.47443C155.916 2.47443 156.241 2.54901 156.521 2.69815C156.8 2.84493 157.016 3.07102 157.17 3.37642C157.327 3.67945 157.405 4.06534 157.405 4.53409V8H156.567V4.59091C156.567 4.15767 156.454 3.82268 156.229 3.58594C156.007 3.34683 155.698 3.22727 155.302 3.22727C155.028 3.22727 154.782 3.28527 154.564 3.40128C154.348 3.51728 154.178 3.68655 154.052 3.90909C153.929 4.13163 153.868 4.40152 153.868 4.71875Z" fill="#0000B3" />
																													</svg>
																													<label className='square-1-selected-label col-12 p-1'>{images[5].label}</label>
																												</div>
																											) :
																											(
																												<div className='m-1 p-3 square-1 row justify-content-center align-items-center' onClick={() => onChangedSelectedImage(5, indexShape)}>
																													<svg xmlns="http://www.w3.org/2000/svg" width="90" height="60" viewBox="0 0 310 310" fill="none">
																														<line x1="3.67224" y1="155.012" x2="2.49996" y2="305.007" stroke="#0000B3" stroke-width="3" />
																														<line x1="211" y1="306.5" x2="1" y2="306.5" stroke="#0000B3" stroke-width="3" />
																														<path d="M72 155L2 155" stroke="#0000B3" stroke-width="3" />
																														<line x1="141" y1="206.5" x2="71" y2="206.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="211" y1="255.5" x2="141" y2="255.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="294" y1="131.5" x2="224" y2="131.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="225" y1="81.5001" x2="155" y2="81.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="156" y1="30.5001" x2="86" y2="30.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="70.5" y1="205" x2="70.5" y2="155" stroke="#0000B3" stroke-width="3" />
																														<path d="M141 255V205" stroke="#0000B3" stroke-width="3" />
																														<line x1="209.5" y1="305" x2="209.5" y2="255" stroke="#0000B3" stroke-width="3" />
																														<line x1="223.5" y1="130" x2="223.5" y2="80" stroke="#0000B3" stroke-width="3" />
																														<line x1="236" y1="129.5" x2="226" y2="129.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="236" y1="82.5" x2="226" y2="82.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="229.5" y1="128" x2="229.5" y2="81" stroke="#0000B3" stroke-width="3" />
																														<line x1="225.5" y1="67" x2="225.5" y2="77" stroke="#0000B3" stroke-width="3" />
																														<line x1="158.5" y1="67" x2="158.5" y2="77" stroke="#0000B3" stroke-width="3" />
																														<line x1="224" y1="73.5" x2="157" y2="73.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="156.5" y1="13" x2="156.5" y2="23" stroke="#0000B3" stroke-width="3" />
																														<line x1="89.5" y1="13" x2="89.5" y2="23" stroke="#0000B3" stroke-width="3" />
																														<line x1="155" y1="19.5" x2="88" y2="19.5" stroke="#0000B3" stroke-width="3" />
																														<line x1="154.5" y1="80" x2="154.5" y2="30" stroke="#0000B3" stroke-width="3" />
																														<line x1="1.75328" y1="153.838" x2="85.1608" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																														<line x1="70.7533" y1="153.838" x2="154.161" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																														<line x1="70.7533" y1="204.838" x2="154.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																														<line x1="139.753" y1="204.838" x2="223.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																														<line x1="140.753" y1="253.838" x2="224.161" y2="129.166" stroke="#0000B3" stroke-width="3" />
																														<line x1="225.5" y1="302" x2="225.5" y2="312" stroke="#0000B3" stroke-width="3" />
																														<line x1="307.5" y1="189" x2="307.5" y2="179" stroke="#0000B3" stroke-width="3" />
																														<line x1="293.5" y1="180" x2="293.5" y2="130" stroke="#0000B3" stroke-width="3" />
																														<line x1="209.753" y1="254.838" x2="293.161" y2="130.166" stroke="#0000B3" stroke-width="3" />
																														<line x1="209.757" y1="304.161" x2="294.164" y2="179.161" stroke="#0000B3" stroke-width="3" />
																														<line x1="223.757" y1="307.161" x2="308.164" y2="182.161" stroke="#0000B3" stroke-width="3" />
																														<path d="M269.202 258L267.213 250.727H268.108L269.628 256.651H269.699L271.247 250.727H272.241L273.79 256.651H273.861L275.381 250.727H276.276L274.287 258H273.378L271.773 252.205H271.716L270.111 258H269.202ZM277.259 258V252.545H278.097V258H277.259ZM277.685 251.636C277.522 251.636 277.381 251.581 277.263 251.469C277.147 251.358 277.089 251.224 277.089 251.068C277.089 250.912 277.147 250.778 277.263 250.667C277.381 250.556 277.522 250.5 277.685 250.5C277.849 250.5 277.988 250.556 278.104 250.667C278.223 250.778 278.282 250.912 278.282 251.068C278.282 251.224 278.223 251.358 278.104 251.469C277.988 251.581 277.849 251.636 277.685 251.636ZM281.692 258.114C281.237 258.114 280.836 257.999 280.488 257.769C280.14 257.537 279.868 257.21 279.671 256.789C279.475 256.365 279.377 255.865 279.377 255.287C279.377 254.714 279.475 254.217 279.671 253.795C279.868 253.374 280.141 253.049 280.492 252.819C280.842 252.589 281.247 252.474 281.706 252.474C282.061 252.474 282.342 252.534 282.548 252.652C282.756 252.768 282.915 252.901 283.024 253.05C283.135 253.196 283.221 253.317 283.283 253.412H283.354V250.727H284.192V258H283.382V257.162H283.283C283.221 257.261 283.134 257.387 283.02 257.538C282.906 257.687 282.744 257.821 282.534 257.94C282.323 258.056 282.042 258.114 281.692 258.114ZM281.806 257.361C282.142 257.361 282.426 257.273 282.658 257.098C282.89 256.92 283.066 256.675 283.187 256.363C283.308 256.048 283.368 255.685 283.368 255.273C283.368 254.866 283.309 254.509 283.191 254.204C283.072 253.896 282.897 253.657 282.665 253.487C282.433 253.314 282.146 253.227 281.806 253.227C281.45 253.227 281.155 253.318 280.918 253.501C280.683 253.681 280.507 253.926 280.389 254.236C280.273 254.544 280.215 254.889 280.215 255.273C280.215 255.661 280.274 256.014 280.392 256.331C280.513 256.646 280.691 256.897 280.925 257.084C281.162 257.268 281.455 257.361 281.806 257.361ZM288.215 252.545V253.256H285.389V252.545H288.215ZM286.213 251.239H287.051V256.438C287.051 256.674 287.085 256.852 287.154 256.97C287.225 257.086 287.315 257.164 287.423 257.205C287.535 257.242 287.652 257.261 287.775 257.261C287.867 257.261 287.943 257.257 288.002 257.247C288.061 257.235 288.109 257.226 288.144 257.219L288.315 257.972C288.258 257.993 288.179 258.014 288.077 258.036C287.975 258.059 287.846 258.071 287.69 258.071C287.453 258.071 287.221 258.02 286.994 257.918C286.769 257.817 286.582 257.661 286.433 257.453C286.286 257.245 286.213 256.982 286.213 256.665V251.239ZM290.431 254.719V258H289.593V250.727H290.431V253.398H290.502C290.63 253.116 290.822 252.892 291.078 252.727C291.336 252.558 291.679 252.474 292.107 252.474C292.479 252.474 292.805 252.549 293.084 252.698C293.363 252.845 293.58 253.071 293.734 253.376C293.89 253.679 293.968 254.065 293.968 254.534V258H293.13V254.591C293.13 254.158 293.018 253.823 292.793 253.586C292.57 253.347 292.261 253.227 291.866 253.227C291.591 253.227 291.345 253.285 291.127 253.401C290.912 253.517 290.741 253.687 290.616 253.909C290.493 254.132 290.431 254.402 290.431 254.719Z" fill="#0000B3" />
																														<path d="M233.881 108V100.727H236.338C236.906 100.727 237.373 100.824 237.737 101.018C238.102 101.21 238.372 101.474 238.547 101.81C238.722 102.147 238.81 102.529 238.81 102.957C238.81 103.386 238.722 103.766 238.547 104.097C238.372 104.429 238.103 104.689 237.741 104.879C237.379 105.066 236.916 105.159 236.352 105.159H234.364V104.364H236.324C236.712 104.364 237.025 104.307 237.261 104.193C237.5 104.08 237.673 103.919 237.78 103.71C237.889 103.5 237.943 103.249 237.943 102.957C237.943 102.666 237.889 102.412 237.78 102.194C237.671 101.976 237.497 101.808 237.258 101.69C237.019 101.569 236.703 101.509 236.31 101.509H234.761V108H233.881ZM237.304 104.733L239.094 108H238.071L236.31 104.733H237.304ZM240.164 108V102.545H241.002V108H240.164ZM240.59 101.636C240.426 101.636 240.285 101.581 240.167 101.469C240.051 101.358 239.993 101.224 239.993 101.068C239.993 100.912 240.051 100.778 240.167 100.667C240.285 100.556 240.426 100.5 240.59 100.5C240.753 100.5 240.893 100.556 241.009 100.667C241.127 100.778 241.186 100.912 241.186 101.068C241.186 101.224 241.127 101.358 241.009 101.469C240.893 101.581 240.753 101.636 240.59 101.636ZM246.4 103.767L245.647 103.98C245.6 103.855 245.53 103.733 245.438 103.614C245.348 103.494 245.225 103.394 245.069 103.316C244.912 103.238 244.712 103.199 244.468 103.199C244.135 103.199 243.856 103.276 243.634 103.43C243.414 103.581 243.304 103.774 243.304 104.009C243.304 104.217 243.379 104.381 243.531 104.502C243.682 104.623 243.919 104.723 244.241 104.804L245.051 105.003C245.538 105.121 245.902 105.302 246.141 105.546C246.38 105.788 246.5 106.099 246.5 106.48C246.5 106.793 246.41 107.072 246.23 107.318C246.052 107.564 245.804 107.759 245.484 107.901C245.164 108.043 244.793 108.114 244.369 108.114C243.813 108.114 243.352 107.993 242.988 107.751C242.623 107.51 242.392 107.157 242.295 106.693L243.091 106.494C243.166 106.788 243.31 107.008 243.52 107.155C243.733 107.302 244.011 107.375 244.355 107.375C244.745 107.375 245.056 107.292 245.285 107.126C245.517 106.958 245.633 106.757 245.633 106.523C245.633 106.333 245.567 106.175 245.434 106.047C245.302 105.917 245.098 105.82 244.824 105.756L243.914 105.543C243.415 105.424 243.048 105.241 242.814 104.992C242.582 104.741 242.466 104.428 242.466 104.051C242.466 103.743 242.552 103.471 242.725 103.234C242.9 102.998 243.138 102.812 243.439 102.677C243.742 102.542 244.085 102.474 244.468 102.474C245.008 102.474 245.432 102.593 245.74 102.83C246.05 103.066 246.27 103.379 246.4 103.767ZM250.048 108.114C249.523 108.114 249.069 107.998 248.688 107.766C248.309 107.531 248.017 107.205 247.811 106.786C247.607 106.364 247.506 105.874 247.506 105.315C247.506 104.757 247.607 104.264 247.811 103.838C248.017 103.41 248.303 103.076 248.67 102.837C249.04 102.595 249.47 102.474 249.963 102.474C250.247 102.474 250.528 102.522 250.805 102.616C251.081 102.711 251.334 102.865 251.561 103.078C251.788 103.289 251.969 103.568 252.104 103.916C252.239 104.264 252.307 104.693 252.307 105.202V105.557H248.102V104.832H251.454C251.454 104.525 251.393 104.25 251.27 104.009C251.149 103.767 250.976 103.576 250.751 103.437C250.529 103.297 250.266 103.227 249.963 103.227C249.629 103.227 249.34 103.31 249.096 103.476C248.855 103.639 248.669 103.852 248.539 104.115C248.409 104.378 248.344 104.66 248.344 104.96V105.443C248.344 105.855 248.415 106.204 248.557 106.491C248.701 106.775 248.901 106.991 249.157 107.141C249.412 107.287 249.71 107.361 250.048 107.361C250.268 107.361 250.467 107.33 250.645 107.268C250.825 107.205 250.98 107.11 251.11 106.984C251.24 106.857 251.341 106.698 251.412 106.509L252.221 106.736C252.136 107.01 251.993 107.252 251.792 107.46C251.59 107.666 251.342 107.827 251.046 107.943C250.75 108.057 250.417 108.114 250.048 108.114Z" fill="#0000B3" />
																														<path d="M176.881 67V59.7273H179.338C179.906 59.7273 180.373 59.8243 180.737 60.0185C181.102 60.2102 181.372 60.4742 181.547 60.8104C181.722 61.1465 181.81 61.5289 181.81 61.9574C181.81 62.3859 181.722 62.7659 181.547 63.0973C181.372 63.4287 181.103 63.6892 180.741 63.8786C180.379 64.0656 179.916 64.1591 179.352 64.1591H177.364V63.3636H179.324C179.712 63.3636 180.025 63.3068 180.261 63.1932C180.5 63.0795 180.673 62.9186 180.78 62.7102C180.889 62.4995 180.943 62.2486 180.943 61.9574C180.943 61.6662 180.889 61.4117 180.78 61.1939C180.671 60.9761 180.497 60.808 180.258 60.6896C180.019 60.5689 179.703 60.5085 179.31 60.5085H177.761V67H176.881ZM180.304 63.733L182.094 67H181.071L179.31 63.733H180.304ZM186.601 64.7699V61.5455H187.439V67H186.601V66.0767H186.544C186.416 66.3537 186.218 66.5893 185.948 66.7834C185.678 66.9751 185.337 67.071 184.925 67.071C184.584 67.071 184.281 66.9964 184.016 66.8473C183.751 66.6958 183.542 66.4685 183.391 66.1655C183.239 65.8601 183.164 65.4754 183.164 65.0114V61.5455H184.002V64.9545C184.002 65.3523 184.113 65.6695 184.335 65.9062C184.56 66.143 184.847 66.2614 185.195 66.2614C185.403 66.2614 185.615 66.2081 185.83 66.1016C186.048 65.995 186.231 65.8317 186.377 65.6115C186.526 65.3913 186.601 65.1108 186.601 64.7699ZM189.812 63.7188V67H188.974V61.5455H189.784V62.3977H189.855C189.983 62.1207 190.177 61.8982 190.437 61.7301C190.698 61.5597 191.034 61.4744 191.446 61.4744C191.815 61.4744 192.138 61.5502 192.415 61.7017C192.692 61.8509 192.908 62.0781 193.061 62.3835C193.215 62.6866 193.292 63.0701 193.292 63.5341V67H192.454V63.5909C192.454 63.1624 192.343 62.8286 192.12 62.5895C191.898 62.348 191.592 62.2273 191.204 62.2273C190.937 62.2273 190.698 62.2853 190.487 62.4013C190.279 62.5173 190.114 62.6866 189.993 62.9091C189.873 63.1316 189.812 63.4015 189.812 63.7188Z" fill="#0000B3" />
																														<path d="M88.7098 8V0.727273H91.1672C91.7377 0.727273 92.2041 0.830255 92.5663 1.03622C92.9309 1.23982 93.2008 1.51562 93.376 1.86364C93.5512 2.21165 93.6388 2.59991 93.6388 3.02841C93.6388 3.45691 93.5512 3.84635 93.376 4.19673C93.2032 4.54711 92.9356 4.82647 92.5734 5.0348C92.2112 5.24077 91.7472 5.34375 91.1814 5.34375H89.42V4.5625H91.153C91.5436 4.5625 91.8573 4.49503 92.094 4.36009C92.3308 4.22514 92.5024 4.04285 92.6089 3.81321C92.7178 3.5812 92.7723 3.3196 92.7723 3.02841C92.7723 2.73722 92.7178 2.4768 92.6089 2.24716C92.5024 2.01752 92.3296 1.83759 92.0905 1.70739C91.8514 1.57481 91.5341 1.50852 91.1388 1.50852H89.5905V8H88.7098ZM95.7819 0.727273V8H94.9438V0.727273H95.7819ZM98.922 8.12784C98.5763 8.12784 98.2626 8.06274 97.9809 7.93253C97.6992 7.79995 97.4755 7.60938 97.3097 7.3608C97.144 7.10985 97.0612 6.80682 97.0612 6.4517C97.0612 6.1392 97.1227 5.88589 97.2458 5.69176C97.3689 5.49527 97.5335 5.34138 97.7394 5.23011C97.9454 5.11884 98.1727 5.03598 98.4213 4.98153C98.6722 4.92472 98.9243 4.87973 99.1776 4.84659C99.5091 4.80398 99.7778 4.77202 99.9838 4.75071C100.192 4.72704 100.344 4.68797 100.438 4.63352C100.535 4.57907 100.584 4.48437 100.584 4.34943V4.32102C100.584 3.97064 100.488 3.69839 100.296 3.50426C100.107 3.31013 99.8192 3.21307 99.4333 3.21307C99.0332 3.21307 98.7195 3.30066 98.4923 3.47585C98.265 3.65104 98.1052 3.83807 98.0129 4.03693L97.2174 3.75284C97.3595 3.4214 97.5489 3.16335 97.7856 2.97869C98.0247 2.79167 98.2851 2.66146 98.5669 2.58807C98.8509 2.51231 99.1303 2.47443 99.4049 2.47443C99.5801 2.47443 99.7813 2.49574 100.009 2.53835C100.238 2.5786 100.46 2.66264 100.673 2.79048C100.888 2.91832 101.067 3.11127 101.209 3.36932C101.351 3.62737 101.422 3.97301 101.422 4.40625V8H100.584V7.26136H100.541C100.484 7.37973 100.39 7.50639 100.257 7.64134C100.125 7.77628 99.9482 7.8911 99.7281 7.9858C99.5079 8.08049 99.2392 8.12784 98.922 8.12784ZM99.0498 7.375C99.3812 7.375 99.6606 7.3099 99.8879 7.17969C100.118 7.04948 100.29 6.88139 100.406 6.67543C100.525 6.46946 100.584 6.25284 100.584 6.02557V5.25852C100.548 5.30114 100.47 5.3402 100.35 5.37571C100.231 5.40885 100.094 5.43845 99.9376 5.46449C99.7837 5.48816 99.6334 5.50947 99.4866 5.52841C99.3422 5.54498 99.225 5.55919 99.135 5.57102C98.9172 5.59943 98.7136 5.6456 98.5242 5.70952C98.3372 5.77107 98.1857 5.86458 98.0697 5.99006C97.9561 6.11316 97.8992 6.28125 97.8992 6.49432C97.8992 6.78551 98.007 7.00568 98.2224 7.15483C98.4402 7.30161 98.716 7.375 99.0498 7.375ZM105.324 2.54545V3.25568H102.497V2.54545H105.324ZM103.321 1.23864H104.159V6.4375C104.159 6.67424 104.193 6.8518 104.262 6.97017C104.333 7.08617 104.423 7.1643 104.532 7.20455C104.643 7.24242 104.76 7.26136 104.883 7.26136C104.976 7.26136 105.052 7.25663 105.111 7.24716C105.17 7.23532 105.217 7.22585 105.253 7.21875L105.423 7.97159C105.366 7.9929 105.287 8.0142 105.185 8.03551C105.083 8.05919 104.954 8.07102 104.798 8.07102C104.561 8.07102 104.329 8.02012 104.102 7.91832C103.877 7.81652 103.69 7.66146 103.541 7.45312C103.394 7.24479 103.321 6.98201 103.321 6.66477V1.23864ZM109.013 2.54545V3.25568H106.073V2.54545H109.013ZM106.954 8V1.79261C106.954 1.48011 107.027 1.2197 107.174 1.01136C107.321 0.80303 107.511 0.64678 107.746 0.542613C107.98 0.438446 108.227 0.386363 108.488 0.386363C108.694 0.386363 108.862 0.402935 108.992 0.436079C109.122 0.469223 109.219 0.5 109.283 0.528409L109.042 1.25284C108.999 1.23864 108.94 1.22088 108.864 1.19957C108.791 1.17827 108.694 1.16761 108.573 1.16761C108.296 1.16761 108.096 1.23745 107.973 1.37713C107.852 1.51681 107.792 1.72159 107.792 1.99148V8H106.954ZM112.179 8.11364C111.687 8.11364 111.255 7.99645 110.883 7.76207C110.514 7.5277 110.225 7.19981 110.017 6.77841C109.811 6.35701 109.708 5.86458 109.708 5.30114C109.708 4.73295 109.811 4.23698 110.017 3.81321C110.225 3.38944 110.514 3.06037 110.883 2.82599C111.255 2.59162 111.687 2.47443 112.179 2.47443C112.672 2.47443 113.103 2.59162 113.472 2.82599C113.844 3.06037 114.132 3.38944 114.338 3.81321C114.547 4.23698 114.651 4.73295 114.651 5.30114C114.651 5.86458 114.547 6.35701 114.338 6.77841C114.132 7.19981 113.844 7.5277 113.472 7.76207C113.103 7.99645 112.672 8.11364 112.179 8.11364ZM112.179 7.3608C112.553 7.3608 112.861 7.26491 113.103 7.07315C113.344 6.88139 113.523 6.62926 113.639 6.31676C113.755 6.00426 113.813 5.66572 113.813 5.30114C113.813 4.93655 113.755 4.59683 113.639 4.28196C113.523 3.96709 113.344 3.71259 113.103 3.51847C112.861 3.32434 112.553 3.22727 112.179 3.22727C111.805 3.22727 111.497 3.32434 111.256 3.51847C111.014 3.71259 110.836 3.96709 110.72 4.28196C110.604 4.59683 110.546 4.93655 110.546 5.30114C110.546 5.66572 110.604 6.00426 110.72 6.31676C110.836 6.62926 111.014 6.88139 111.256 7.07315C111.497 7.26491 111.805 7.3608 112.179 7.3608ZM115.93 8V2.54545H116.74V3.36932H116.797C116.896 3.09943 117.076 2.88045 117.336 2.71236C117.597 2.54427 117.89 2.46023 118.217 2.46023C118.279 2.46023 118.356 2.46141 118.448 2.46378C118.54 2.46615 118.61 2.4697 118.657 2.47443V3.3267C118.629 3.3196 118.564 3.30895 118.462 3.29474C118.363 3.27817 118.257 3.26989 118.146 3.26989C117.881 3.26989 117.644 3.32552 117.436 3.43679C117.23 3.54569 117.066 3.69721 116.946 3.89134C116.827 4.0831 116.768 4.30208 116.768 4.5483V8H115.93ZM119.651 8V2.54545H120.46V3.39773H120.532C120.645 3.10653 120.829 2.88045 121.082 2.71946C121.335 2.55611 121.639 2.47443 121.995 2.47443C122.354 2.47443 122.654 2.55611 122.893 2.71946C123.134 2.88045 123.323 3.10653 123.458 3.39773H123.514C123.654 3.116 123.864 2.89228 124.143 2.72656C124.422 2.55848 124.757 2.47443 125.148 2.47443C125.636 2.47443 126.035 2.62713 126.345 2.93253C126.655 3.23556 126.81 3.70786 126.81 4.34943V8H125.972V4.34943C125.972 3.94697 125.862 3.65933 125.642 3.48651C125.421 3.31368 125.162 3.22727 124.864 3.22727C124.48 3.22727 124.183 3.34328 123.973 3.57528C123.762 3.80492 123.657 4.09612 123.657 4.44886V8H122.804V4.2642C122.804 3.95407 122.704 3.70431 122.502 3.51491C122.301 3.32315 122.042 3.22727 121.725 3.22727C121.507 3.22727 121.303 3.28527 121.114 3.40128C120.927 3.51728 120.775 3.67827 120.659 3.88423C120.546 4.08783 120.489 4.32339 120.489 4.59091V8H119.651ZM133.214 8.11364C132.76 8.11364 132.359 7.99882 132.011 7.76918C131.663 7.53717 131.39 7.21046 131.194 6.78906C130.997 6.36529 130.899 5.86458 130.899 5.28693C130.899 4.71402 130.997 4.21686 131.194 3.79545C131.39 3.37405 131.664 3.04853 132.014 2.81889C132.364 2.58925 132.769 2.47443 133.229 2.47443C133.584 2.47443 133.864 2.53362 134.07 2.65199C134.279 2.76799 134.437 2.90057 134.546 3.04972C134.657 3.1965 134.744 3.31723 134.805 3.41193H134.876V0.727273H135.714V8H134.905V7.16193H134.805C134.744 7.26136 134.656 7.38684 134.543 7.53835C134.429 7.6875 134.267 7.82126 134.056 7.93963C133.845 8.05563 133.565 8.11364 133.214 8.11364ZM133.328 7.3608C133.664 7.3608 133.948 7.2732 134.18 7.09801C134.412 6.92045 134.589 6.67543 134.709 6.36293C134.83 6.04806 134.891 5.68466 134.891 5.27273C134.891 4.86553 134.831 4.50923 134.713 4.20384C134.595 3.89607 134.419 3.65696 134.187 3.48651C133.955 3.31368 133.669 3.22727 133.328 3.22727C132.973 3.22727 132.677 3.31842 132.44 3.50071C132.206 3.68063 132.03 3.92566 131.911 4.2358C131.795 4.54356 131.737 4.8892 131.737 5.27273C131.737 5.66098 131.796 6.01373 131.915 6.33097C132.035 6.64583 132.213 6.89678 132.447 7.08381C132.684 7.26847 132.978 7.3608 133.328 7.3608ZM139.653 8.11364C139.127 8.11364 138.674 7.99763 138.293 7.76562C137.914 7.53125 137.621 7.20455 137.415 6.78551C137.212 6.36411 137.11 5.87405 137.11 5.31534C137.11 4.75663 137.212 4.2642 137.415 3.83807C137.621 3.40956 137.908 3.07576 138.275 2.83665C138.644 2.59517 139.075 2.47443 139.567 2.47443C139.851 2.47443 140.132 2.52178 140.409 2.61648C140.686 2.71117 140.938 2.86506 141.165 3.07812C141.393 3.28883 141.574 3.56818 141.709 3.91619C141.844 4.2642 141.911 4.69271 141.911 5.2017V5.55682H137.707V4.83239H141.059C141.059 4.52462 140.997 4.25 140.874 4.00852C140.753 3.76705 140.581 3.57647 140.356 3.43679C140.133 3.29711 139.87 3.22727 139.567 3.22727C139.234 3.22727 138.945 3.31013 138.701 3.47585C138.459 3.6392 138.274 3.85227 138.143 4.11506C138.013 4.37784 137.948 4.65956 137.948 4.96023V5.44318C137.948 5.85511 138.019 6.20431 138.161 6.49077C138.306 6.77486 138.506 6.99148 138.761 7.14062C139.017 7.28741 139.314 7.3608 139.653 7.3608C139.873 7.3608 140.072 7.33002 140.249 7.26847C140.429 7.20455 140.584 7.10985 140.714 6.98438C140.845 6.85653 140.945 6.69792 141.016 6.50852L141.826 6.7358C141.741 7.01042 141.597 7.25189 141.396 7.46023C141.195 7.66619 140.946 7.82718 140.65 7.94318C140.355 8.05682 140.022 8.11364 139.653 8.11364ZM143.186 10.0455V2.54545H143.996V3.41193H144.095C144.157 3.31723 144.242 3.1965 144.351 3.04972C144.462 2.90057 144.621 2.76799 144.827 2.65199C145.035 2.53362 145.317 2.47443 145.672 2.47443C146.131 2.47443 146.536 2.58925 146.886 2.81889C147.237 3.04853 147.51 3.37405 147.707 3.79545C147.903 4.21686 148.001 4.71402 148.001 5.28693C148.001 5.86458 147.903 6.36529 147.707 6.78906C147.51 7.21046 147.238 7.53717 146.89 7.76918C146.542 7.99882 146.141 8.11364 145.686 8.11364C145.336 8.11364 145.055 8.05563 144.844 7.93963C144.634 7.82126 144.472 7.6875 144.358 7.53835C144.244 7.38684 144.157 7.26136 144.095 7.16193H144.024V10.0455H143.186ZM144.01 5.27273C144.01 5.68466 144.07 6.04806 144.191 6.36293C144.312 6.67543 144.488 6.92045 144.72 7.09801C144.952 7.2732 145.236 7.3608 145.572 7.3608C145.923 7.3608 146.215 7.26847 146.449 7.08381C146.686 6.89678 146.864 6.64583 146.982 6.33097C147.103 6.01373 147.163 5.66098 147.163 5.27273C147.163 4.8892 147.104 4.54356 146.986 4.2358C146.87 3.92566 146.693 3.68063 146.457 3.50071C146.222 3.31842 145.927 3.22727 145.572 3.22727C145.231 3.22727 144.945 3.31368 144.713 3.48651C144.481 3.65696 144.306 3.89607 144.187 4.20384C144.069 4.50923 144.01 4.86553 144.01 5.27273ZM151.652 2.54545V3.25568H148.825V2.54545H151.652ZM149.649 1.23864H150.487V6.4375C150.487 6.67424 150.521 6.8518 150.59 6.97017C150.661 7.08617 150.751 7.1643 150.86 7.20455C150.971 7.24242 151.088 7.26136 151.212 7.26136C151.304 7.26136 151.38 7.25663 151.439 7.24716C151.498 7.23532 151.545 7.22585 151.581 7.21875L151.751 7.97159C151.695 7.9929 151.615 8.0142 151.513 8.03551C151.412 8.05919 151.283 8.07102 151.126 8.07102C150.89 8.07102 150.658 8.02012 150.43 7.91832C150.205 7.81652 150.018 7.66146 149.869 7.45312C149.722 7.24479 149.649 6.98201 149.649 6.66477V1.23864ZM153.868 4.71875V8H153.03V0.727273H153.868V3.39773H153.939C154.067 3.116 154.258 2.89228 154.514 2.72656C154.772 2.55848 155.115 2.47443 155.544 2.47443C155.916 2.47443 156.241 2.54901 156.521 2.69815C156.8 2.84493 157.016 3.07102 157.17 3.37642C157.327 3.67945 157.405 4.06534 157.405 4.53409V8H156.567V4.59091C156.567 4.15767 156.454 3.82268 156.229 3.58594C156.007 3.34683 155.698 3.22727 155.302 3.22727C155.028 3.22727 154.782 3.28527 154.564 3.40128C154.348 3.51728 154.178 3.68655 154.052 3.90909C153.929 4.13163 153.868 4.40152 153.868 4.71875Z" fill="#0000B3" />
																													</svg>
																													<label className='square-1-label col-12 p-1'>{images[5].label}</label>
																												</div>
																											)
																									}
																								</div>

																								<div className="col-12 m-0 p-0 align-items-start justify-content-start">
																									{
																										shapeVol.selectedImage == 0 ? (
																											<div className="col-12 m-0 p-0 align-items-center justify-content-start">
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Length')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="length"
																															value={shapeVol.length == 0 ? '' : shapeVol.length}
																															onChange={(e) => { setLengthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.lengthUnit, label: shapeVol.lengthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setLengthUnitArray(e.value, indexShape) }}
																														/>

																														{/* <select styles={{ dropdownIndicator: dropdownIndicatorStyles }}
																															className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setLengthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.lengthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Width')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="width"
																															value={shapeVol.width == 0 ? '' : shapeVol.width}
																															placeholder=''
																															onChange={(e) => { setWidthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.widthUnit, label: shapeVol.widthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setWidthUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setWidthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.widthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="height"
																															value={shapeVol.height == 0 ? '' : shapeVol.height}
																															placeholder=''
																															onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.heightUnit, label: shapeVol.heightUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setheightUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.heightUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																											</div>

																										) : ('')
																									}
																									{
																										shapeVol.selectedImage == 1 ? (
																											<div className="col-12 align-items-center justify-content-start">
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="height"
																															value={shapeVol.height == 0 ? '' : shapeVol.height}
																															onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.heightUnit, label: shapeVol.heightUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setheightUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.heightUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Diameter')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="diameter"
																															value={shapeVol.diameter == 0 ? '' : shapeVol.diameter}
																															onChange={(e) => { setDiameterArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.diameterUnit, label: shapeVol.diameterUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setDiameterUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setDiameterUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.diameterUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																											</div>

																										) : ('')
																									}
																									{
																										shapeVol.selectedImage == 2 ? (
																											<div className="col-12 align-items-center justify-content-start">
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Outer_diameter')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="outerDiameter"
																															value={shapeVol.outerDiameter == 0 ? '' : shapeVol.outerDiameter}
																															onChange={(e) => { setOuterDiameterArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.outerDiameterUnit, label: shapeVol.outerDiameterUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setOuterDiameterUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setOuterDiameterUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.outerDiameterUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Inner_diameter')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="innerDiameter"
																															value={shapeVol.innerDiameter == 0 ? '' : shapeVol.innerDiameter}
																															onChange={(e) => { setInnerDiameterArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.innerDiameterUnit, label: shapeVol.innerDiameterUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setInnerDiameterUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setInnerDiameterUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.innerDiameterUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="height"
																															value={shapeVol.height == 0 ? '' : shapeVol.height}
																															onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.heightUnit, label: shapeVol.heightUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setheightUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.heightUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																											</div>

																										) : ('')
																									}
																									{
																										shapeVol.selectedImage == 3 ? (
																											<div className="col-12 align-items-center justify-content-start">
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Width')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="width"
																															value={shapeVol.width == 0 ? '' : shapeVol.width}
																															onChange={(e) => { setWidthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.widthUnit, label: shapeVol.widthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setWidthUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setWidthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.widthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Length')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="length"
																															value={shapeVol.length == 0 ? '' : shapeVol.length}
																															onChange={(e) => { setLengthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.lengthUnit, label: shapeVol.lengthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setLengthUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setLengthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.lengthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Height')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="height"
																															value={shapeVol.height == 0 ? '' : shapeVol.height}
																															onChange={(e) => { setheightArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.heightUnit, label: shapeVol.heightUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setheightUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setheightUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.heightUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																											</div>

																										) : ('')
																									}
																									{
																										shapeVol.selectedImage == 4 ? (
																											<div className="col-12 align-items-center justify-content-start">
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Outer_width')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="outerWidth"
																															value={shapeVol.outerWidth == 0 ? '' : shapeVol.outerWidth}
																															onChange={(e) => { setOuterWidthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.outerWidthUnit, label: shapeVol.outerWidthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setOuterWidthUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setOuterWidthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.outerWidthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Outer_length')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="outerLength"
																															value={shapeVol.outerLength == 0 ? '' : shapeVol.outerLength}
																															onChange={(e) => { setOuterLengthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.outerLengthUnit, label: shapeVol.outerLengthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setOuterLengthUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setOuterLengthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.outerLengthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Inner_width')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="innerWidth"
																															value={shapeVol.innerWidth == 0 ? '' : shapeVol.innerWidth}
																															onChange={(e) => { setInnerWidthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.innerWidthUnit, label: shapeVol.innerWidthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setInnerWidthUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setInnerWidthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.innerWidthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Inner_length')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="innerLength"
																															value={shapeVol.innerLength == 0 ? '' : shapeVol.innerLength}
																															onChange={(e) => { setInnerLengthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6 align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.innerLengthUnit, label: shapeVol.innerLengthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setInnerLengthUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setInnerLengthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.innerLengthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Depth')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="depth"
																															value={shapeVol.depth == 0 ? '' : shapeVol.depth}
																															onChange={(e) => { setDepthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.depthUnit, label: shapeVol.depthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setDepthUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setDepthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.depthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																											</div>

																										) : ('')
																									}
																									{
																										shapeVol.selectedImage == 5 ? (
																											<div className="col-12 align-items-center justify-content-start">
																												<div className="row align-items-center justify-content-start mb-1">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Width')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="width"
																															value={shapeVol.width == 0 ? '' : shapeVol.width}
																															onChange={(e) => { setWidthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6 align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.widthUnit, label: shapeVol.widthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setWidthUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setWidthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.widthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Rise')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="rise"
																															value={shapeVol.rise == 0 ? '' : shapeVol.rise}
																															onChange={(e) => { setRiseArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.riseUnit, label: shapeVol.riseUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setRiseUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setRiseUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.riseUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Run')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="run"
																															value={shapeVol.run == 0 ? '' : shapeVol.run}
																															onChange={(e) => { setRunArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.runUnit, label: shapeVol.runUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setRunUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setRunUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.runUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Platform_depth')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="platformDepth"
																															value={shapeVol.platformDepth == 0 ? '' : shapeVol.platformDepth}
																															onChange={(e) => { setPlatformDepthArray(e.target.value, indexShape) }}
																														/>
																													</div>
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Unit')}</label>
																														<Select
																															className="select-style col-12"
																															closeMenuOnSelect={true}
																															components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																															value={{ value: shapeVol.platformDepthUnit, label: shapeVol.platformDepthUnit }}
																															styles={customStyles}
																															options={unitsM}
																															onChange={(e) => { setPlatformDepthUnitArray(e.value, indexShape) }}
																														/>
																														{/* <select className="select-style cmx-form-control col-12 pl-2" onChange={(e) => { setPlatformDepthUnitArray(e.target.value, indexShape) }}>
																															<option className="option-style" selected>{t('Choose_an_option')}</option>
																															{unitsM.map((unit) => (
																																<option className="option-style" key={unit} value={unit}
																																	selected={unit == shapeVol.platformDepthUnit}>{unit}</option>
																															))}
																														</select> */}
																													</div>
																												</div>
																												<div className="row   align-items-center justify-content-start mb-3 mt-3">
																													<div className='col-6   align-items-center justify-content-start'>
																														<label className='cmx-form-label col-12 mb-1 pl-2'>{t('Number_of_stairs')}</label>
																														<input
																															type="number"
																															className="option-style cmx-form-control col-12 p-1 pl-2"
																															id="numberStairs"
																															value={shapeVol.numberStairs == 0 ? '' : shapeVol.numberStairs}
																															onChange={(e) => { setNumberStairsArray(e.target.value, indexShape) }}
																														/>
																													</div>
																												</div>
																											</div>

																										) : ('')
																									}
																								</div>
																							</div>
																						) : ('')
																					}
																				</div>
																			))}

																			<div className="col row align-items-end justify-content-end mt-3 mb-3">
																				<p className='add-shape-text row align-items-end justify-content-end cursor-pointer'
																					onClick={(e) => { addNewShape() }}>
																					+ {t('Add_shape')}
																				</p>
																			</div>
																		</form>
																	) : ('')
																}

															</div>
														) : ('')
													}

													<div className={nextActivated == true ? 'col-12 p-0' : 'col-6 row align-items-center justify-content-end'}>
														<div className={nextActivated == true ? 'col-12 p-3 detail-section' : 'col-10 p-3 detail-section'}>
															{
																selectedProjectId != null ? (
																	<p className='detail-title col-12 mb-2'>{t('Project')}</p>
																) : ('')
															}

															<div className="row mb-2">
																{
																	selectedProjectId != null ? (
																		<p className='chip-1 m-2 h6 col-auto'><strong>{getProjectName(selectedProjectId)}</strong></p>
																	) : ('')
																}
																{
																	selectedOptionId != null ? (
																		< p className='chip-1 m-2 h6 col-auto'><strong>{getOptionName(selectedOptionId)}</strong></p>
																	) : ('')
																}
																{/* {selectedProjectIdsList.map((proj) => (
														<p key={proj} className='chip-1 m-2 h6 col-auto'><strong>{proj}</strong></p>
													))} */}
															</div>
															<p className='detail-header col-12 mb-2'>{t('Order_detail')}</p>
															{shapesVolumeArray.map((shapeVol, index) => (
																<div key={shapeVol.id} className="row align-items-center justify-content-between m-0">
																	<div className='square-small row align-items-center justify-content-center m-2'>
																		{
																			shapeVol.selectedImage == 0 ?
																				(
																					<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 92 42" fill="none">
																						<path opacity="0.4" d="M30.8401 1L1.37012 17.54V41L30.8401 24.21V1Z" fill="#1203B8" />
																						<path opacity="0.4" d="M91.0001 1H30.8401V24.21H91.0001V1Z" fill="#1203B8" />
																						<path opacity="0.4" d="M61.29 17.54H1V41H61.29V17.54Z" fill="#1203B8" />
																						<path opacity="0.4" d="M91 1L61.29 17.54V41L91 24.21V1Z" fill="#1203B8" />
																						<path d="M1.37012 17.54V41H61.2901L91.0001 24.21V1H30.8401L1.37012 17.54Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M1.37012 17.54H61.2901L91.0001 1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M61.29 41V17.54" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M91.0002 24.21H89.9202" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M87.7802 24.21H30.8402L3.24023 39.93" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M2.31012 40.46L1.37012 41" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M30.8401 24.21V23.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M30.8401 20.79V3.25" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M30.8401 2.08V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																					</svg>
																				) :
																				('')
																		}
																		{
																			shapeVol.selectedImage == 1 ?
																				(
																					<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 92 56" fill="none">
																						<path opacity="0.3" d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47556 70.8528 1 46 1C21.1472 1 1 6.47556 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" fill="#0003B8" />
																						<path opacity="0.6" d="M46 55C70.8528 55 91 49.5244 91 42.77C91 36.0155 70.8528 30.54 46 30.54C21.1472 30.54 1 36.0155 1 42.77C1 49.5244 21.1472 55 46 55Z" fill="#0003B8" />
																						<path opacity="0.5" d="M90.83 14.4301V42.7701C90.83 42.7701 92.33 31.8001 46 30.5401C46 30.5401 3.88 30.5401 1 42.7701V15.5501C1 15.5501 6.84 24.9001 46 25.4701C46 25.4701 84.29 25.4701 90.83 14.4301Z" fill="#0003B8" />
																						<path d="M1 42.77C1 42.29 1.1 41.81 1.3 41.35" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M3.04004 39.11C8.75004 34.14 25.77 30.54 45.89 30.54C67.35 30.54 85.3 34.65 89.73 40.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M90.48 41.34C90.68 41.81 90.78 42.28 90.78 42.76" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M45.89 25.46C70.6821 25.46 90.78 19.9844 90.78 13.23C90.78 6.47556 70.6821 1 45.89 1C21.0979 1 1 6.47556 1 13.23C1 19.9844 21.0979 25.46 45.89 25.46Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M1 13.23V42.76C1 49.52 21.1 54.99 45.89 54.99C70.68 54.99 90.78 49.51 90.78 42.76V13.23" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																					</svg>
																				) :
																				('')
																		}
																		{
																			shapeVol.selectedImage == 2 ?
																				(
																					<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 92 56" fill="none">
																						<path opacity="0.3" d="M46 25.46C70.8528 25.46 91 19.9844 91 13.23C91 6.47556 70.8528 1 46 1C21.1472 1 1 6.47556 1 13.23C1 19.9844 21.1472 25.46 46 25.46Z" fill="#0003B8" />
																						<path opacity="0.6" d="M46 55C70.8528 55 91 49.5244 91 42.77C91 36.0155 70.8528 30.54 46 30.54C21.1472 30.54 1 36.0155 1 42.77C1 49.5244 21.1472 55 46 55Z" fill="#0003B8" />
																						<path opacity="0.5" d="M90.83 14.4301V42.7701C90.83 42.7701 92.33 31.8001 46 30.5401C46 30.5401 3.88 30.5401 1 42.7701V15.5501C1 15.5501 6.84 24.9001 46 25.4701C46 25.4701 84.29 25.4701 90.83 14.4301Z" fill="#0003B8" />
																						<path d="M15.9199 43.3401C15.9199 42.8401 16.1699 42.3601 16.6299 41.8901" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																						<path d="M19.3398 40.2501C24.3698 38.1301 34.4198 36.6801 45.9998 36.6801C58.8098 36.6801 69.7398 38.4501 74.0798 40.9401" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																						<path d="M75.3599 41.8901C75.8299 42.3601 76.0699 42.8401 76.0699 43.3401" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.12 2.12" />
																						<path d="M45.9999 19.35C62.6126 19.35 76.0799 16.3727 76.0799 12.7C76.0799 9.02735 62.6126 6.05005 45.9999 6.05005C29.3872 6.05005 15.9199 9.02735 15.9199 12.7C15.9199 16.3727 29.3872 19.35 45.9999 19.35Z" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M15.9199 13.1801V42.6601C15.9199 46.3301 29.3899 49.3101 45.9999 49.3101C62.6099 49.3101 76.0799 46.3301 76.0799 42.6601V13.1801" stroke="#0003B8" stroke-width="1.06" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M1.11011 42.77C1.11011 42.29 1.21011 41.81 1.41011 41.35" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M3.15015 39.11C8.86015 34.14 25.8802 30.54 46.0002 30.54C67.4602 30.54 85.4101 34.65 89.8401 40.13" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M90.5901 41.34C90.7901 41.81 90.8901 42.28 90.8901 42.76" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" />
																						<path d="M46.0001 25.46C70.7922 25.46 90.8901 19.9844 90.8901 13.23C90.8901 6.47556 70.7922 1 46.0001 1C21.208 1 1.11011 6.47556 1.11011 13.23C1.11011 19.9844 21.208 25.46 46.0001 25.46Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M1.11011 13.23V42.76C1.11011 49.52 21.2101 54.99 46.0001 54.99C70.7901 54.99 90.8901 49.51 90.8901 42.76V13.23" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path opacity="0.15" d="M45.9999 49.16C62.6126 49.16 76.0799 46.326 76.0799 42.83C76.0799 39.334 62.6126 36.5 45.9999 36.5C29.3872 36.5 15.9199 39.334 15.9199 42.83C15.9199 46.326 29.3872 49.16 45.9999 49.16Z" fill="#0003B8" />
																						<path opacity="0.25" d="M45.9999 19.03C62.6126 19.03 76.0799 16.196 76.0799 12.7C76.0799 9.20403 62.6126 6.37 45.9999 6.37C29.3872 6.37 15.9199 9.20403 15.9199 12.7C15.9199 16.196 29.3872 19.03 45.9999 19.03Z" fill="#0003B8" />
																					</svg>
																				) :
																				('')
																		}
																		{
																			shapeVol.selectedImage == 3 ?
																				(
																					<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 92 42" fill="none">
																						<path opacity="0.3" d="M83.65 9.58997H1V41H83.65V9.58997Z" fill="#0003B8" />
																						<path opacity="0.6" d="M90.9999 1L83.6499 9.59V41L90.9999 32.41V1Z" fill="#0003B8" />
																						<path opacity="0.5" d="M8.42001 1L1 9.59H83.65L91 1H8.42001Z" fill="#0003B8" />
																						<path d="M83.65 9.58997H1V41H83.65V9.58997Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M83.6499 41L90.9999 32.41V1" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M83.58 9.59L91 1H8.42001L1 9.59" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																					</svg>
																				) :
																				('')
																		}
																		{
																			shapeVol.selectedImage == 4 ?
																				(
																					<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 92 30" fill="none">
																						<path opacity="0.3" d="M71.7799 19.95H1.3999V29H71.7799V19.95Z" fill="#0003B8" />
																						<path opacity="0.6" d="M91 10.05V1L71.77 19.95V29L91 10.05Z" fill="#0003B8" />
																						<path opacity="0.5" d="M20.07 1.27001L1 19.96H71.38L90.61 1.01001L20.08 1.28001L20.07 1.27001ZM68.77 16.61H9.82001L22.25 4.51001L80.99 4.65001L68.77 16.61Z" fill="#0003B8" />
																						<path opacity="0.7" d="M20.62 6.48999V10.05L14.15 16.39H10.22L20.62 6.48999Z" fill="#0003B8" />
																						<path opacity="0.7" d="M75.4801 10.05L81.3901 4.65002L22.6501 4.52002L20.6201 6.49002V10.05H75.4801Z" fill="#0003B8" />
																						<path d="M71.7799 19.95H1.3999V29H71.7799V19.95Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M90.5799 1L71.7699 19.95H1.3999L20.4699 1.27L90.5799 1Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M69.1599 16.61H10.22L22.65 4.52002H81.52L69.1599 16.61Z" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M91 1V10.05L71.77 29V19.95" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M20.6199 6.48999V10.05L75.9999 9.92999" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																						<path d="M14.0598 16.61L20.6198 10.05" stroke="#0003B8" stroke-linecap="round" stroke-linejoin="round" />
																					</svg>
																				) :
																				('')
																		}
																		{
																			shapeVol.selectedImage == 5 ?
																				(
																					<svg xmlns="http://www.w3.org/2000/svg" width="90" height="60" viewBox="0 0 310 310" fill="none">
																						<line x1="3.67224" y1="155.012" x2="2.49996" y2="305.007" stroke="#0000B3" stroke-width="3" />
																						<line x1="211" y1="306.5" x2="1" y2="306.5" stroke="#0000B3" stroke-width="3" />
																						<path d="M72 155L2 155" stroke="#0000B3" stroke-width="3" />
																						<line x1="141" y1="206.5" x2="71" y2="206.5" stroke="#0000B3" stroke-width="3" />
																						<line x1="211" y1="255.5" x2="141" y2="255.5" stroke="#0000B3" stroke-width="3" />
																						<line x1="294" y1="131.5" x2="224" y2="131.5" stroke="#0000B3" stroke-width="3" />
																						<line x1="225" y1="81.5001" x2="155" y2="81.5" stroke="#0000B3" stroke-width="3" />
																						<line x1="156" y1="30.5001" x2="86" y2="30.5" stroke="#0000B3" stroke-width="3" />
																						<line x1="70.5" y1="205" x2="70.5" y2="155" stroke="#0000B3" stroke-width="3" />
																						<path d="M141 255V205" stroke="#0000B3" stroke-width="3" />
																						<line x1="209.5" y1="305" x2="209.5" y2="255" stroke="#0000B3" stroke-width="3" />
																						<line x1="223.5" y1="130" x2="223.5" y2="80" stroke="#0000B3" stroke-width="3" />
																						<line x1="236" y1="129.5" x2="226" y2="129.5" stroke="#0000B3" stroke-width="3" />
																						<line x1="236" y1="82.5" x2="226" y2="82.5" stroke="#0000B3" stroke-width="3" />
																						<line x1="229.5" y1="128" x2="229.5" y2="81" stroke="#0000B3" stroke-width="3" />
																						<line x1="225.5" y1="67" x2="225.5" y2="77" stroke="#0000B3" stroke-width="3" />
																						<line x1="158.5" y1="67" x2="158.5" y2="77" stroke="#0000B3" stroke-width="3" />
																						<line x1="224" y1="73.5" x2="157" y2="73.5" stroke="#0000B3" stroke-width="3" />
																						<line x1="156.5" y1="13" x2="156.5" y2="23" stroke="#0000B3" stroke-width="3" />
																						<line x1="89.5" y1="13" x2="89.5" y2="23" stroke="#0000B3" stroke-width="3" />
																						<line x1="155" y1="19.5" x2="88" y2="19.5" stroke="#0000B3" stroke-width="3" />
																						<line x1="154.5" y1="80" x2="154.5" y2="30" stroke="#0000B3" stroke-width="3" />
																						<line x1="1.75328" y1="153.838" x2="85.1608" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																						<line x1="70.7533" y1="153.838" x2="154.161" y2="29.1659" stroke="#0000B3" stroke-width="3" />
																						<line x1="70.7533" y1="204.838" x2="154.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																						<line x1="139.753" y1="204.838" x2="223.161" y2="80.1659" stroke="#0000B3" stroke-width="3" />
																						<line x1="140.753" y1="253.838" x2="224.161" y2="129.166" stroke="#0000B3" stroke-width="3" />
																						<line x1="225.5" y1="302" x2="225.5" y2="312" stroke="#0000B3" stroke-width="3" />
																						<line x1="307.5" y1="189" x2="307.5" y2="179" stroke="#0000B3" stroke-width="3" />
																						<line x1="293.5" y1="180" x2="293.5" y2="130" stroke="#0000B3" stroke-width="3" />
																						<line x1="209.753" y1="254.838" x2="293.161" y2="130.166" stroke="#0000B3" stroke-width="3" />
																						<line x1="209.757" y1="304.161" x2="294.164" y2="179.161" stroke="#0000B3" stroke-width="3" />
																						<line x1="223.757" y1="307.161" x2="308.164" y2="182.161" stroke="#0000B3" stroke-width="3" />
																						<path d="M269.202 258L267.213 250.727H268.108L269.628 256.651H269.699L271.247 250.727H272.241L273.79 256.651H273.861L275.381 250.727H276.276L274.287 258H273.378L271.773 252.205H271.716L270.111 258H269.202ZM277.259 258V252.545H278.097V258H277.259ZM277.685 251.636C277.522 251.636 277.381 251.581 277.263 251.469C277.147 251.358 277.089 251.224 277.089 251.068C277.089 250.912 277.147 250.778 277.263 250.667C277.381 250.556 277.522 250.5 277.685 250.5C277.849 250.5 277.988 250.556 278.104 250.667C278.223 250.778 278.282 250.912 278.282 251.068C278.282 251.224 278.223 251.358 278.104 251.469C277.988 251.581 277.849 251.636 277.685 251.636ZM281.692 258.114C281.237 258.114 280.836 257.999 280.488 257.769C280.14 257.537 279.868 257.21 279.671 256.789C279.475 256.365 279.377 255.865 279.377 255.287C279.377 254.714 279.475 254.217 279.671 253.795C279.868 253.374 280.141 253.049 280.492 252.819C280.842 252.589 281.247 252.474 281.706 252.474C282.061 252.474 282.342 252.534 282.548 252.652C282.756 252.768 282.915 252.901 283.024 253.05C283.135 253.196 283.221 253.317 283.283 253.412H283.354V250.727H284.192V258H283.382V257.162H283.283C283.221 257.261 283.134 257.387 283.02 257.538C282.906 257.687 282.744 257.821 282.534 257.94C282.323 258.056 282.042 258.114 281.692 258.114ZM281.806 257.361C282.142 257.361 282.426 257.273 282.658 257.098C282.89 256.92 283.066 256.675 283.187 256.363C283.308 256.048 283.368 255.685 283.368 255.273C283.368 254.866 283.309 254.509 283.191 254.204C283.072 253.896 282.897 253.657 282.665 253.487C282.433 253.314 282.146 253.227 281.806 253.227C281.45 253.227 281.155 253.318 280.918 253.501C280.683 253.681 280.507 253.926 280.389 254.236C280.273 254.544 280.215 254.889 280.215 255.273C280.215 255.661 280.274 256.014 280.392 256.331C280.513 256.646 280.691 256.897 280.925 257.084C281.162 257.268 281.455 257.361 281.806 257.361ZM288.215 252.545V253.256H285.389V252.545H288.215ZM286.213 251.239H287.051V256.438C287.051 256.674 287.085 256.852 287.154 256.97C287.225 257.086 287.315 257.164 287.423 257.205C287.535 257.242 287.652 257.261 287.775 257.261C287.867 257.261 287.943 257.257 288.002 257.247C288.061 257.235 288.109 257.226 288.144 257.219L288.315 257.972C288.258 257.993 288.179 258.014 288.077 258.036C287.975 258.059 287.846 258.071 287.69 258.071C287.453 258.071 287.221 258.02 286.994 257.918C286.769 257.817 286.582 257.661 286.433 257.453C286.286 257.245 286.213 256.982 286.213 256.665V251.239ZM290.431 254.719V258H289.593V250.727H290.431V253.398H290.502C290.63 253.116 290.822 252.892 291.078 252.727C291.336 252.558 291.679 252.474 292.107 252.474C292.479 252.474 292.805 252.549 293.084 252.698C293.363 252.845 293.58 253.071 293.734 253.376C293.89 253.679 293.968 254.065 293.968 254.534V258H293.13V254.591C293.13 254.158 293.018 253.823 292.793 253.586C292.57 253.347 292.261 253.227 291.866 253.227C291.591 253.227 291.345 253.285 291.127 253.401C290.912 253.517 290.741 253.687 290.616 253.909C290.493 254.132 290.431 254.402 290.431 254.719Z" fill="#0000B3" />
																						<path d="M233.881 108V100.727H236.338C236.906 100.727 237.373 100.824 237.737 101.018C238.102 101.21 238.372 101.474 238.547 101.81C238.722 102.147 238.81 102.529 238.81 102.957C238.81 103.386 238.722 103.766 238.547 104.097C238.372 104.429 238.103 104.689 237.741 104.879C237.379 105.066 236.916 105.159 236.352 105.159H234.364V104.364H236.324C236.712 104.364 237.025 104.307 237.261 104.193C237.5 104.08 237.673 103.919 237.78 103.71C237.889 103.5 237.943 103.249 237.943 102.957C237.943 102.666 237.889 102.412 237.78 102.194C237.671 101.976 237.497 101.808 237.258 101.69C237.019 101.569 236.703 101.509 236.31 101.509H234.761V108H233.881ZM237.304 104.733L239.094 108H238.071L236.31 104.733H237.304ZM240.164 108V102.545H241.002V108H240.164ZM240.59 101.636C240.426 101.636 240.285 101.581 240.167 101.469C240.051 101.358 239.993 101.224 239.993 101.068C239.993 100.912 240.051 100.778 240.167 100.667C240.285 100.556 240.426 100.5 240.59 100.5C240.753 100.5 240.893 100.556 241.009 100.667C241.127 100.778 241.186 100.912 241.186 101.068C241.186 101.224 241.127 101.358 241.009 101.469C240.893 101.581 240.753 101.636 240.59 101.636ZM246.4 103.767L245.647 103.98C245.6 103.855 245.53 103.733 245.438 103.614C245.348 103.494 245.225 103.394 245.069 103.316C244.912 103.238 244.712 103.199 244.468 103.199C244.135 103.199 243.856 103.276 243.634 103.43C243.414 103.581 243.304 103.774 243.304 104.009C243.304 104.217 243.379 104.381 243.531 104.502C243.682 104.623 243.919 104.723 244.241 104.804L245.051 105.003C245.538 105.121 245.902 105.302 246.141 105.546C246.38 105.788 246.5 106.099 246.5 106.48C246.5 106.793 246.41 107.072 246.23 107.318C246.052 107.564 245.804 107.759 245.484 107.901C245.164 108.043 244.793 108.114 244.369 108.114C243.813 108.114 243.352 107.993 242.988 107.751C242.623 107.51 242.392 107.157 242.295 106.693L243.091 106.494C243.166 106.788 243.31 107.008 243.52 107.155C243.733 107.302 244.011 107.375 244.355 107.375C244.745 107.375 245.056 107.292 245.285 107.126C245.517 106.958 245.633 106.757 245.633 106.523C245.633 106.333 245.567 106.175 245.434 106.047C245.302 105.917 245.098 105.82 244.824 105.756L243.914 105.543C243.415 105.424 243.048 105.241 242.814 104.992C242.582 104.741 242.466 104.428 242.466 104.051C242.466 103.743 242.552 103.471 242.725 103.234C242.9 102.998 243.138 102.812 243.439 102.677C243.742 102.542 244.085 102.474 244.468 102.474C245.008 102.474 245.432 102.593 245.74 102.83C246.05 103.066 246.27 103.379 246.4 103.767ZM250.048 108.114C249.523 108.114 249.069 107.998 248.688 107.766C248.309 107.531 248.017 107.205 247.811 106.786C247.607 106.364 247.506 105.874 247.506 105.315C247.506 104.757 247.607 104.264 247.811 103.838C248.017 103.41 248.303 103.076 248.67 102.837C249.04 102.595 249.47 102.474 249.963 102.474C250.247 102.474 250.528 102.522 250.805 102.616C251.081 102.711 251.334 102.865 251.561 103.078C251.788 103.289 251.969 103.568 252.104 103.916C252.239 104.264 252.307 104.693 252.307 105.202V105.557H248.102V104.832H251.454C251.454 104.525 251.393 104.25 251.27 104.009C251.149 103.767 250.976 103.576 250.751 103.437C250.529 103.297 250.266 103.227 249.963 103.227C249.629 103.227 249.34 103.31 249.096 103.476C248.855 103.639 248.669 103.852 248.539 104.115C248.409 104.378 248.344 104.66 248.344 104.96V105.443C248.344 105.855 248.415 106.204 248.557 106.491C248.701 106.775 248.901 106.991 249.157 107.141C249.412 107.287 249.71 107.361 250.048 107.361C250.268 107.361 250.467 107.33 250.645 107.268C250.825 107.205 250.98 107.11 251.11 106.984C251.24 106.857 251.341 106.698 251.412 106.509L252.221 106.736C252.136 107.01 251.993 107.252 251.792 107.46C251.59 107.666 251.342 107.827 251.046 107.943C250.75 108.057 250.417 108.114 250.048 108.114Z" fill="#0000B3" />
																						<path d="M176.881 67V59.7273H179.338C179.906 59.7273 180.373 59.8243 180.737 60.0185C181.102 60.2102 181.372 60.4742 181.547 60.8104C181.722 61.1465 181.81 61.5289 181.81 61.9574C181.81 62.3859 181.722 62.7659 181.547 63.0973C181.372 63.4287 181.103 63.6892 180.741 63.8786C180.379 64.0656 179.916 64.1591 179.352 64.1591H177.364V63.3636H179.324C179.712 63.3636 180.025 63.3068 180.261 63.1932C180.5 63.0795 180.673 62.9186 180.78 62.7102C180.889 62.4995 180.943 62.2486 180.943 61.9574C180.943 61.6662 180.889 61.4117 180.78 61.1939C180.671 60.9761 180.497 60.808 180.258 60.6896C180.019 60.5689 179.703 60.5085 179.31 60.5085H177.761V67H176.881ZM180.304 63.733L182.094 67H181.071L179.31 63.733H180.304ZM186.601 64.7699V61.5455H187.439V67H186.601V66.0767H186.544C186.416 66.3537 186.218 66.5893 185.948 66.7834C185.678 66.9751 185.337 67.071 184.925 67.071C184.584 67.071 184.281 66.9964 184.016 66.8473C183.751 66.6958 183.542 66.4685 183.391 66.1655C183.239 65.8601 183.164 65.4754 183.164 65.0114V61.5455H184.002V64.9545C184.002 65.3523 184.113 65.6695 184.335 65.9062C184.56 66.143 184.847 66.2614 185.195 66.2614C185.403 66.2614 185.615 66.2081 185.83 66.1016C186.048 65.995 186.231 65.8317 186.377 65.6115C186.526 65.3913 186.601 65.1108 186.601 64.7699ZM189.812 63.7188V67H188.974V61.5455H189.784V62.3977H189.855C189.983 62.1207 190.177 61.8982 190.437 61.7301C190.698 61.5597 191.034 61.4744 191.446 61.4744C191.815 61.4744 192.138 61.5502 192.415 61.7017C192.692 61.8509 192.908 62.0781 193.061 62.3835C193.215 62.6866 193.292 63.0701 193.292 63.5341V67H192.454V63.5909C192.454 63.1624 192.343 62.8286 192.12 62.5895C191.898 62.348 191.592 62.2273 191.204 62.2273C190.937 62.2273 190.698 62.2853 190.487 62.4013C190.279 62.5173 190.114 62.6866 189.993 62.9091C189.873 63.1316 189.812 63.4015 189.812 63.7188Z" fill="#0000B3" />
																						<path d="M88.7098 8V0.727273H91.1672C91.7377 0.727273 92.2041 0.830255 92.5663 1.03622C92.9309 1.23982 93.2008 1.51562 93.376 1.86364C93.5512 2.21165 93.6388 2.59991 93.6388 3.02841C93.6388 3.45691 93.5512 3.84635 93.376 4.19673C93.2032 4.54711 92.9356 4.82647 92.5734 5.0348C92.2112 5.24077 91.7472 5.34375 91.1814 5.34375H89.42V4.5625H91.153C91.5436 4.5625 91.8573 4.49503 92.094 4.36009C92.3308 4.22514 92.5024 4.04285 92.6089 3.81321C92.7178 3.5812 92.7723 3.3196 92.7723 3.02841C92.7723 2.73722 92.7178 2.4768 92.6089 2.24716C92.5024 2.01752 92.3296 1.83759 92.0905 1.70739C91.8514 1.57481 91.5341 1.50852 91.1388 1.50852H89.5905V8H88.7098ZM95.7819 0.727273V8H94.9438V0.727273H95.7819ZM98.922 8.12784C98.5763 8.12784 98.2626 8.06274 97.9809 7.93253C97.6992 7.79995 97.4755 7.60938 97.3097 7.3608C97.144 7.10985 97.0612 6.80682 97.0612 6.4517C97.0612 6.1392 97.1227 5.88589 97.2458 5.69176C97.3689 5.49527 97.5335 5.34138 97.7394 5.23011C97.9454 5.11884 98.1727 5.03598 98.4213 4.98153C98.6722 4.92472 98.9243 4.87973 99.1776 4.84659C99.5091 4.80398 99.7778 4.77202 99.9838 4.75071C100.192 4.72704 100.344 4.68797 100.438 4.63352C100.535 4.57907 100.584 4.48437 100.584 4.34943V4.32102C100.584 3.97064 100.488 3.69839 100.296 3.50426C100.107 3.31013 99.8192 3.21307 99.4333 3.21307C99.0332 3.21307 98.7195 3.30066 98.4923 3.47585C98.265 3.65104 98.1052 3.83807 98.0129 4.03693L97.2174 3.75284C97.3595 3.4214 97.5489 3.16335 97.7856 2.97869C98.0247 2.79167 98.2851 2.66146 98.5669 2.58807C98.8509 2.51231 99.1303 2.47443 99.4049 2.47443C99.5801 2.47443 99.7813 2.49574 100.009 2.53835C100.238 2.5786 100.46 2.66264 100.673 2.79048C100.888 2.91832 101.067 3.11127 101.209 3.36932C101.351 3.62737 101.422 3.97301 101.422 4.40625V8H100.584V7.26136H100.541C100.484 7.37973 100.39 7.50639 100.257 7.64134C100.125 7.77628 99.9482 7.8911 99.7281 7.9858C99.5079 8.08049 99.2392 8.12784 98.922 8.12784ZM99.0498 7.375C99.3812 7.375 99.6606 7.3099 99.8879 7.17969C100.118 7.04948 100.29 6.88139 100.406 6.67543C100.525 6.46946 100.584 6.25284 100.584 6.02557V5.25852C100.548 5.30114 100.47 5.3402 100.35 5.37571C100.231 5.40885 100.094 5.43845 99.9376 5.46449C99.7837 5.48816 99.6334 5.50947 99.4866 5.52841C99.3422 5.54498 99.225 5.55919 99.135 5.57102C98.9172 5.59943 98.7136 5.6456 98.5242 5.70952C98.3372 5.77107 98.1857 5.86458 98.0697 5.99006C97.9561 6.11316 97.8992 6.28125 97.8992 6.49432C97.8992 6.78551 98.007 7.00568 98.2224 7.15483C98.4402 7.30161 98.716 7.375 99.0498 7.375ZM105.324 2.54545V3.25568H102.497V2.54545H105.324ZM103.321 1.23864H104.159V6.4375C104.159 6.67424 104.193 6.8518 104.262 6.97017C104.333 7.08617 104.423 7.1643 104.532 7.20455C104.643 7.24242 104.76 7.26136 104.883 7.26136C104.976 7.26136 105.052 7.25663 105.111 7.24716C105.17 7.23532 105.217 7.22585 105.253 7.21875L105.423 7.97159C105.366 7.9929 105.287 8.0142 105.185 8.03551C105.083 8.05919 104.954 8.07102 104.798 8.07102C104.561 8.07102 104.329 8.02012 104.102 7.91832C103.877 7.81652 103.69 7.66146 103.541 7.45312C103.394 7.24479 103.321 6.98201 103.321 6.66477V1.23864ZM109.013 2.54545V3.25568H106.073V2.54545H109.013ZM106.954 8V1.79261C106.954 1.48011 107.027 1.2197 107.174 1.01136C107.321 0.80303 107.511 0.64678 107.746 0.542613C107.98 0.438446 108.227 0.386363 108.488 0.386363C108.694 0.386363 108.862 0.402935 108.992 0.436079C109.122 0.469223 109.219 0.5 109.283 0.528409L109.042 1.25284C108.999 1.23864 108.94 1.22088 108.864 1.19957C108.791 1.17827 108.694 1.16761 108.573 1.16761C108.296 1.16761 108.096 1.23745 107.973 1.37713C107.852 1.51681 107.792 1.72159 107.792 1.99148V8H106.954ZM112.179 8.11364C111.687 8.11364 111.255 7.99645 110.883 7.76207C110.514 7.5277 110.225 7.19981 110.017 6.77841C109.811 6.35701 109.708 5.86458 109.708 5.30114C109.708 4.73295 109.811 4.23698 110.017 3.81321C110.225 3.38944 110.514 3.06037 110.883 2.82599C111.255 2.59162 111.687 2.47443 112.179 2.47443C112.672 2.47443 113.103 2.59162 113.472 2.82599C113.844 3.06037 114.132 3.38944 114.338 3.81321C114.547 4.23698 114.651 4.73295 114.651 5.30114C114.651 5.86458 114.547 6.35701 114.338 6.77841C114.132 7.19981 113.844 7.5277 113.472 7.76207C113.103 7.99645 112.672 8.11364 112.179 8.11364ZM112.179 7.3608C112.553 7.3608 112.861 7.26491 113.103 7.07315C113.344 6.88139 113.523 6.62926 113.639 6.31676C113.755 6.00426 113.813 5.66572 113.813 5.30114C113.813 4.93655 113.755 4.59683 113.639 4.28196C113.523 3.96709 113.344 3.71259 113.103 3.51847C112.861 3.32434 112.553 3.22727 112.179 3.22727C111.805 3.22727 111.497 3.32434 111.256 3.51847C111.014 3.71259 110.836 3.96709 110.72 4.28196C110.604 4.59683 110.546 4.93655 110.546 5.30114C110.546 5.66572 110.604 6.00426 110.72 6.31676C110.836 6.62926 111.014 6.88139 111.256 7.07315C111.497 7.26491 111.805 7.3608 112.179 7.3608ZM115.93 8V2.54545H116.74V3.36932H116.797C116.896 3.09943 117.076 2.88045 117.336 2.71236C117.597 2.54427 117.89 2.46023 118.217 2.46023C118.279 2.46023 118.356 2.46141 118.448 2.46378C118.54 2.46615 118.61 2.4697 118.657 2.47443V3.3267C118.629 3.3196 118.564 3.30895 118.462 3.29474C118.363 3.27817 118.257 3.26989 118.146 3.26989C117.881 3.26989 117.644 3.32552 117.436 3.43679C117.23 3.54569 117.066 3.69721 116.946 3.89134C116.827 4.0831 116.768 4.30208 116.768 4.5483V8H115.93ZM119.651 8V2.54545H120.46V3.39773H120.532C120.645 3.10653 120.829 2.88045 121.082 2.71946C121.335 2.55611 121.639 2.47443 121.995 2.47443C122.354 2.47443 122.654 2.55611 122.893 2.71946C123.134 2.88045 123.323 3.10653 123.458 3.39773H123.514C123.654 3.116 123.864 2.89228 124.143 2.72656C124.422 2.55848 124.757 2.47443 125.148 2.47443C125.636 2.47443 126.035 2.62713 126.345 2.93253C126.655 3.23556 126.81 3.70786 126.81 4.34943V8H125.972V4.34943C125.972 3.94697 125.862 3.65933 125.642 3.48651C125.421 3.31368 125.162 3.22727 124.864 3.22727C124.48 3.22727 124.183 3.34328 123.973 3.57528C123.762 3.80492 123.657 4.09612 123.657 4.44886V8H122.804V4.2642C122.804 3.95407 122.704 3.70431 122.502 3.51491C122.301 3.32315 122.042 3.22727 121.725 3.22727C121.507 3.22727 121.303 3.28527 121.114 3.40128C120.927 3.51728 120.775 3.67827 120.659 3.88423C120.546 4.08783 120.489 4.32339 120.489 4.59091V8H119.651ZM133.214 8.11364C132.76 8.11364 132.359 7.99882 132.011 7.76918C131.663 7.53717 131.39 7.21046 131.194 6.78906C130.997 6.36529 130.899 5.86458 130.899 5.28693C130.899 4.71402 130.997 4.21686 131.194 3.79545C131.39 3.37405 131.664 3.04853 132.014 2.81889C132.364 2.58925 132.769 2.47443 133.229 2.47443C133.584 2.47443 133.864 2.53362 134.07 2.65199C134.279 2.76799 134.437 2.90057 134.546 3.04972C134.657 3.1965 134.744 3.31723 134.805 3.41193H134.876V0.727273H135.714V8H134.905V7.16193H134.805C134.744 7.26136 134.656 7.38684 134.543 7.53835C134.429 7.6875 134.267 7.82126 134.056 7.93963C133.845 8.05563 133.565 8.11364 133.214 8.11364ZM133.328 7.3608C133.664 7.3608 133.948 7.2732 134.18 7.09801C134.412 6.92045 134.589 6.67543 134.709 6.36293C134.83 6.04806 134.891 5.68466 134.891 5.27273C134.891 4.86553 134.831 4.50923 134.713 4.20384C134.595 3.89607 134.419 3.65696 134.187 3.48651C133.955 3.31368 133.669 3.22727 133.328 3.22727C132.973 3.22727 132.677 3.31842 132.44 3.50071C132.206 3.68063 132.03 3.92566 131.911 4.2358C131.795 4.54356 131.737 4.8892 131.737 5.27273C131.737 5.66098 131.796 6.01373 131.915 6.33097C132.035 6.64583 132.213 6.89678 132.447 7.08381C132.684 7.26847 132.978 7.3608 133.328 7.3608ZM139.653 8.11364C139.127 8.11364 138.674 7.99763 138.293 7.76562C137.914 7.53125 137.621 7.20455 137.415 6.78551C137.212 6.36411 137.11 5.87405 137.11 5.31534C137.11 4.75663 137.212 4.2642 137.415 3.83807C137.621 3.40956 137.908 3.07576 138.275 2.83665C138.644 2.59517 139.075 2.47443 139.567 2.47443C139.851 2.47443 140.132 2.52178 140.409 2.61648C140.686 2.71117 140.938 2.86506 141.165 3.07812C141.393 3.28883 141.574 3.56818 141.709 3.91619C141.844 4.2642 141.911 4.69271 141.911 5.2017V5.55682H137.707V4.83239H141.059C141.059 4.52462 140.997 4.25 140.874 4.00852C140.753 3.76705 140.581 3.57647 140.356 3.43679C140.133 3.29711 139.87 3.22727 139.567 3.22727C139.234 3.22727 138.945 3.31013 138.701 3.47585C138.459 3.6392 138.274 3.85227 138.143 4.11506C138.013 4.37784 137.948 4.65956 137.948 4.96023V5.44318C137.948 5.85511 138.019 6.20431 138.161 6.49077C138.306 6.77486 138.506 6.99148 138.761 7.14062C139.017 7.28741 139.314 7.3608 139.653 7.3608C139.873 7.3608 140.072 7.33002 140.249 7.26847C140.429 7.20455 140.584 7.10985 140.714 6.98438C140.845 6.85653 140.945 6.69792 141.016 6.50852L141.826 6.7358C141.741 7.01042 141.597 7.25189 141.396 7.46023C141.195 7.66619 140.946 7.82718 140.65 7.94318C140.355 8.05682 140.022 8.11364 139.653 8.11364ZM143.186 10.0455V2.54545H143.996V3.41193H144.095C144.157 3.31723 144.242 3.1965 144.351 3.04972C144.462 2.90057 144.621 2.76799 144.827 2.65199C145.035 2.53362 145.317 2.47443 145.672 2.47443C146.131 2.47443 146.536 2.58925 146.886 2.81889C147.237 3.04853 147.51 3.37405 147.707 3.79545C147.903 4.21686 148.001 4.71402 148.001 5.28693C148.001 5.86458 147.903 6.36529 147.707 6.78906C147.51 7.21046 147.238 7.53717 146.89 7.76918C146.542 7.99882 146.141 8.11364 145.686 8.11364C145.336 8.11364 145.055 8.05563 144.844 7.93963C144.634 7.82126 144.472 7.6875 144.358 7.53835C144.244 7.38684 144.157 7.26136 144.095 7.16193H144.024V10.0455H143.186ZM144.01 5.27273C144.01 5.68466 144.07 6.04806 144.191 6.36293C144.312 6.67543 144.488 6.92045 144.72 7.09801C144.952 7.2732 145.236 7.3608 145.572 7.3608C145.923 7.3608 146.215 7.26847 146.449 7.08381C146.686 6.89678 146.864 6.64583 146.982 6.33097C147.103 6.01373 147.163 5.66098 147.163 5.27273C147.163 4.8892 147.104 4.54356 146.986 4.2358C146.87 3.92566 146.693 3.68063 146.457 3.50071C146.222 3.31842 145.927 3.22727 145.572 3.22727C145.231 3.22727 144.945 3.31368 144.713 3.48651C144.481 3.65696 144.306 3.89607 144.187 4.20384C144.069 4.50923 144.01 4.86553 144.01 5.27273ZM151.652 2.54545V3.25568H148.825V2.54545H151.652ZM149.649 1.23864H150.487V6.4375C150.487 6.67424 150.521 6.8518 150.59 6.97017C150.661 7.08617 150.751 7.1643 150.86 7.20455C150.971 7.24242 151.088 7.26136 151.212 7.26136C151.304 7.26136 151.38 7.25663 151.439 7.24716C151.498 7.23532 151.545 7.22585 151.581 7.21875L151.751 7.97159C151.695 7.9929 151.615 8.0142 151.513 8.03551C151.412 8.05919 151.283 8.07102 151.126 8.07102C150.89 8.07102 150.658 8.02012 150.43 7.91832C150.205 7.81652 150.018 7.66146 149.869 7.45312C149.722 7.24479 149.649 6.98201 149.649 6.66477V1.23864ZM153.868 4.71875V8H153.03V0.727273H153.868V3.39773H153.939C154.067 3.116 154.258 2.89228 154.514 2.72656C154.772 2.55848 155.115 2.47443 155.544 2.47443C155.916 2.47443 156.241 2.54901 156.521 2.69815C156.8 2.84493 157.016 3.07102 157.17 3.37642C157.327 3.67945 157.405 4.06534 157.405 4.53409V8H156.567V4.59091C156.567 4.15767 156.454 3.82268 156.229 3.58594C156.007 3.34683 155.698 3.22727 155.302 3.22727C155.028 3.22727 154.782 3.28527 154.564 3.40128C154.348 3.51728 154.178 3.68655 154.052 3.90909C153.929 4.13163 153.868 4.40152 153.868 4.71875Z" fill="#0000B3" />
																					</svg>
																				) :
																				('')
																		}
																	</div>

																	<p className={nextActivated == true ? 'order-detail-item col-4 mt-3'
																		: 'order-detail-item col-4 mt-3'}>
																		{images[shapeVol.selectedImage].label}
																	</p>
																	<p className={nextActivated == true ? 'order-detail-amount col-5 mt-3'
																		: 'order-detail-amount col-6 mt-3'}>
																		{shapeVol.shapeVolume.toLocaleString(undefined, { maximumFractionDigits: decimalsCount })} {getDefaultUnitDesc()} <sup>3</sup>
																	</p>
																</div>
															))}
															<div className="row align-items-start justify-content-start">
																<div className='align-items-start justify-content-start col-6 p-1'>
																	<label className='detail-label col-12 pl-1'>{t('Reserve_volume')}</label>
																	<div className='cmx-form-control '>
																		<input
																			type="number"
																			className="cmx-form-control-percentage col-9 pr-2"
																			id="reserveVolume"
																			value={reserveVolume}
																			disabled={nextActivated}
																			onChange={(e) => { setReserveVolume(e.target.value) }}
																		/>
																		<label className='cmx-form-label col-1 pl-3 ml-3'>%</label>
																	</div>
																</div>
																<p className='order-detail-amount-reserve col-6'>
																	+{calcTotalReserveVolume().toLocaleString(undefined, { maximumFractionDigits: decimalsCount })} {getDefaultUnitDesc()} <sup>3</sup>
																</p>
															</div>
															<div className="row align-items-center justify-content-start mt-3">
																<p className='order-detail-total-label col-4 mb-3'>{t('Total_volume')}</p>
																<p className='cmx-display-1 col-8'>{calcTotalPlusReserveVolume().toLocaleString(undefined, { maximumFractionDigits: decimalsCount })} {getDefaultUnitDesc()} <sup>3</sup></p>
															</div>
														</div>
														{
															nextActivated == false ? (
																<div className="row col-12 align-items-center justify-content-end m-0 p-0">
																	<button type="button" className={shapeArrayValid() == true ?
																		"cmx-btn mt-3 m-0 col-10 row align-items-center justify-content-center" :
																		"cmx-btn-disabled mt-3 m-0 col-10 row align-items-center justify-content-center"}
																		onClick={() => activateNext()}
																		disabled={shapeArrayValid() == true ? false : true}>
																		<p className="cmx-btn-text pt-1">{t('Next')}</p>
																	</button>
																	{
																		showMinVolMessage ? (
																			< p className='min-vol-message col-10 mt-1'>
																				* {t('minimum_volume_message') + ' ' + minimumVolume + getDefaultUnitDesc()} <sup>3</sup>
																			</p>
																		) : ('')
																	}

																</div>

															) : ('')
														}

													</div>
												</div>
											)
										}
									</div>
								) : (
									<div className="loading-container">
										<div className="loading-container-sub">

										</div>
										<div className="loading-container-sub">

										</div>
										<div className="loading-container-sub">

										</div>
										<div className="loading-container-sub">

										</div>
									</div>
								)}

					</div>
				)
			}
		</div >

	);
};

export default HelloWorld;
